import { C as lt, V as W } from "./config-9944f489.js";
import { openBlock as a, createElementBlock as o, mergeProps as T, toDisplayString as S, createCommentVNode as _, createElementVNode as u, renderSlot as h, resolveComponent as f, createBlock as k, withCtx as b, Fragment as w, renderList as I, resolveDynamicComponent as J, normalizeClass as v, resolveDirective as z, withDirectives as D, createVNode as g, normalizeStyle as $, Transition as G, vShow as O, withModifiers as L, createSlots as Y, createTextVNode as P, withKeys as R, vModelDynamic as ot, normalizeProps as M, guardReactiveProps as B, pushScopeId as me, popScopeId as fe, toHandlers as rt, h as be } from "vue";
import { L as K } from "./localisation.service-2bcd1f37.js";
const y = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [l, s] of t)
    n[l] = s;
  return n;
}, dt = {
  name: "j-icon",
  props: {
    iconId: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: null
    },
    size: {
      type: String,
      validator(e) {
        return lt.SPACING.includes(e);
      },
      default: null
    }
  }
}, ct = ["aria-hidden"], ut = { key: 0 }, ht = ["href"];
function pt(e, t, n, l, s, i) {
  return a(), o("svg", T({
    ref: e.$attrs.ref,
    class: [n.size ? "j-icon--sized" : ""],
    style: [
      n.size ? {
        "--j-icon-size": `var(--icon-size-${n.size})`
      } : {}
    ]
  }, e.$attrs, {
    "aria-hidden": !n.title
  }), [
    n.title ? (a(), o("title", ut, S(n.title), 1)) : _("", !0),
    u("use", {
      href: `#${n.iconId}`
    }, null, 8, ht)
  ], 16, ct);
}
const E = /* @__PURE__ */ y(dt, [["render", pt], ["__scopeId", "data-v-85623ee4"]]);
const _t = {
  name: "j-panel"
}, mt = { class: "j-panel" };
function ft(e, t, n, l, s, i) {
  return a(), o("div", mt, [
    h(e.$slots, "default", {}, void 0, !0)
  ]);
}
const ye = /* @__PURE__ */ y(_t, [["render", ft], ["__scopeId", "data-v-afd13a2d"]]);
const yt = {
  name: "action-panel",
  components: {
    "j-icon": E,
    "j-panel": ye
  },
  props: {
    /**
     * The array of actions that will be rendered
     *
     * Entries should each be an `object`. The following properties are supported, all of which are optional:
     *
     * - `url` ~ `string`: If provided, the list item will contain an `a` linking to the given url. If omitted, the list item will contain a button.
     * - `isExternal` ~ `boolean`: If `url` is set and this prop is set to `true`, clicking it will open the given URL in a new tab.
     * - `disabled` ~ `boolean`: If set to  `true`, the button will be disabled.
     * - `icon` ~ `string`: If provided, the list item will show the given icon before the label.
     * - `iconClasses` ~ `string` | `Array`: If provided, the one or more given CSS classes will be applied to the icon.
     * - `label` ~ `string`: If provided, the list item will contain this label.
     * - `onClick` ~ `function`: If provided, clicking the button will trigger a call to the given function. The first argument will be the `action` object and the second will be the `$event` object.
     */
    actions: {
      type: Array,
      required: !0,
      default: () => []
    }
  },
  methods: {
    onActionClick(e, t) {
      e.onClick && e.onClick(e, t);
    }
  }
}, gt = {
  ref: "action-panel",
  class: "j-action-panel__list"
}, vt = { class: "j-action-panel__label" };
function bt(e, t, n, l, s, i) {
  const r = f("j-icon"), d = f("j-panel");
  return a(), k(d, {
    class: "j-action-panel",
    role: "menu"
  }, {
    default: b(() => [
      u("ul", gt, [
        (a(!0), o(w, null, I(n.actions, (c, m) => (a(), o("li", {
          key: m,
          class: "j-action-panel__action"
        }, [
          (a(), k(J(c.url ? "a" : "button"), {
            href: c.url,
            role: "menuitem",
            class: "j-action-panel__action-item",
            target: c.isExternal ? "_blank" : null,
            rel: c.isExternal ? "noreferrer noopener" : null,
            disabled: c.disabled,
            onClick: (p) => i.onActionClick(c, p)
          }, {
            default: b(() => [
              c.icon ? (a(), k(r, {
                key: 0,
                "icon-id": c.icon,
                class: v(["j-action-panel__icon", c.iconClasses])
              }, null, 8, ["icon-id", "class"])) : _("", !0),
              u("span", vt, S(c.label), 1),
              c.isExternal ? (a(), k(r, {
                key: 1,
                "icon-id": "icon-open-new",
                class: "j-action-panel__icon j-action-panel__icon--external"
              })) : _("", !0)
            ]),
            _: 2
          }, 1032, ["href", "target", "rel", "disabled", "onClick"]))
        ]))), 128))
      ], 512)
    ]),
    _: 1
  });
}
const jt = /* @__PURE__ */ y(yt, [["render", bt], ["__scopeId", "data-v-8073c85d"]]);
const St = {
  name: "j-button",
  components: {
    "j-icon": E
  },
  props: {
    /**
     * Button variant (e.g. primary, secondary)
     */
    variant: {
      type: String,
      default: "primary",
      required: !1,
      validator: (e) => ["primary", "success", "destructive", "secondary", "tertiary"].includes(e)
    },
    /**
     * Button size
     */
    size: {
      type: String,
      default: "regular",
      required: !1,
      validator: (e) => ["regular", "small"].includes(e)
    },
    /**
     * What sort of content the button will have. One of text-only, icon-left, icon-right or icon-only
     */
    contentType: {
      type: String,
      default: "text-only",
      validator: (e) => ["text-only", "icon-left", "icon-right", "icon-only", "circle"].includes(e)
    },
    /**
     * ID of the icon to display (not required for text-only content type)
     */
    iconId: {
      type: String,
      default: null
    },
    /**
     * Classes to pass to the icon (e.g. to rotate it)
     */
    iconClasses: {
      type: String,
      default: null
    },
    /**
     * URL property to determine if component should use button or a tag
     */
    href: {
      type: String,
      default: null
    },
    /**
     * Custom click event method
     */
    onClick: {
      type: Function,
      default: () => {
      }
    }
  }
}, kt = { class: "j-button__content" };
function Ct(e, t, n, l, s, i) {
  const r = f("j-icon");
  return a(), k(J(n.href ? "a" : "button"), T({
    href: n.href,
    class: ["j-button", [`j-button--${n.variant}`, `j-button--${n.size}`, `j-button--${n.contentType}`]]
  }, e.$attrs, { onClick: n.onClick }), {
    default: b(() => [
      u("span", kt, [
        n.iconId ? (a(), k(r, {
          key: 0,
          "icon-id": n.iconId,
          class: v(["j-button__icon", [`j-button__icon--${n.contentType}`, n.iconClasses]])
        }, null, 8, ["icon-id", "class"])) : _("", !0),
        n.contentType !== "icon-only" ? h(e.$slots, "default", { key: 1 }, void 0, !0) : _("", !0)
      ])
    ]),
    _: 3
  }, 16, ["href", "class", "onClick"]);
}
const F = /* @__PURE__ */ y(St, [["render", Ct], ["__scopeId", "data-v-4fa06f38"]]), Q = {
  beforeMount(e, { expression: t, modifiers: { bubble: n } = {}, value: l } = {}) {
    if (typeof l != "function") {
      console.warn(`[Click-away:] provided expression '${t}' is not a function, but has to be`);
      return;
    }
    const s = (i) => {
      (n || !wt(i, e)) && l();
    };
    e.__addClickAwayTimeoutID__ = setTimeout(() => {
      e.__vueClickAway__ = s, document.addEventListener("click", s);
    }, 0);
  },
  unmounted(e) {
    clearTimeout(e.__addClickAwayTimeoutID__), document.removeEventListener("click", e.__vueClickAway__), e.__vueClickAway__ = null;
  }
};
function wt(e, t) {
  var l;
  const n = e.path || ((l = e == null ? void 0 : e.composedPath) == null ? void 0 : l.call(e));
  return t.contains(e.target) || n.includes(t);
}
const xt = {
  name: "j-dropdown-button",
  components: {
    "j-button": F,
    "j-action-panel": jt
  },
  directives: {
    clickAway: Q
  },
  props: {
    /** The configuration to pass to the Button component */
    buttonConfig: {
      type: Object,
      default: () => ({
        variant: "primary",
        contentType: "icon-only",
        iconId: "icon-add"
      })
    },
    /**
     * The array of option objects that will be rendered in the OptionPanel
     */
    actions: {
      default: () => [],
      type: Array
    },
    /**
     * Should the panel open above the button (defaults to opening below)
     */
    openPanelAbove: {
      type: Boolean,
      default: !1
    },
    /**
     * Should the panel align to the left side of the button (defaults to aligning to the right)
     */
    alignPanelLeft: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      panelVisible: !1
    };
  },
  methods: {
    /**
     * Toggles the open state of the panel between true or false.
     * If the panelState argument is passed, it will force the open state of the panel to that value
     * @param {boolean|undefined} panelState
     * @returns {void}
     */
    togglePanelState(e) {
      this.panelVisible = e === void 0 ? !this.panelVisible : !!e, this.$emit("panel-toggled", this.panelVisible);
    }
  }
};
function It(e, t, n, l, s, i) {
  const r = f("j-button"), d = f("j-action-panel"), c = z("click-away");
  return D((a(), o("div", {
    class: v(["j-dropdown-button", {
      "j-dropdown-button--open-above": n.openPanelAbove,
      "j-dropdown-button--align-left": n.alignPanelLeft
    }])
  }, [
    g(r, T(n.buttonConfig, {
      class: "j-dropdown-button__button",
      onClick: t[0] || (t[0] = (m) => i.togglePanelState())
    }), {
      default: b(() => [
        h(e.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16),
    s.panelVisible ? (a(), k(d, {
      key: 0,
      actions: n.actions,
      class: "j-dropdown-button__list"
    }, null, 8, ["actions"])) : _("", !0)
  ], 2)), [
    [c, () => i.togglePanelState(!1)]
  ]);
}
const ze = /* @__PURE__ */ y(xt, [["render", It], ["__scopeId", "data-v-885deea1"]]);
function ge(e, t) {
  const n = {};
  for (const l in e)
    Object.prototype.hasOwnProperty.call(t, l) ? Object.prototype.toString.call(t[l]) === "[object Object]" ? n[l] = ge(e[l], t[l]) : n[l] = t[l] : n[l] = e[l];
  return n;
}
function Fe() {
  return Math.floor(Math.random() * 999999).toString().padStart(6, "0");
}
function ve() {
  return `j-id-${Fe()}`;
}
function Tt(e) {
  return Array.isArray(e) ? e : [e];
}
function Dt(e, t = 0, n = !0) {
  if (typeof e != "function")
    return () => 0;
  let l = !1;
  return (...s) => {
    l || (n && setTimeout(() => e(...s)), l = !0, setTimeout(() => {
      n || e(...s), l = !1;
    }, t));
  };
}
function Vt(e, t = "ASC") {
  const n = (l, s) => typeof l[s] > "u" ? Number.MIN_SAFE_INTEGER : l[s];
  return (l, s) => {
    const i = n(l, e), r = n(s, e);
    return t === "ASC" ? i - r : r - i;
  };
}
const At = {
  name: "j-tooltip",
  props: {
    /**
     * The time (in ms) to wait before showing/hiding the tooltip on mouse over / mouse out
     */
    delay: {
      type: Number,
      default: 50,
      required: !1
    },
    /**
     * The maximum width for the tooltip container (and therefore also the contents of the tooltip).
     * Due to the way that this component is built (with a parent child relationship), a maximum width
     * must be provided, or the tooltip will not be able to be wider than the toggle elememnt.
     */
    maxWidth: {
      type: String,
      default: "calc(20 * var(--j-spacing-m))"
    },
    /**
     * Where the tooltip should be vertically positioned relative to the toggle element.
     * Valid values are: 'auto' (which is the default), 'top' and 'bottom'
     */
    positionVertical: {
      type: String,
      default: "auto",
      validator: (e) => ["auto", "top", "bottom"].includes(e)
    },
    /**
     * Where the tooltip should be horizontally positioned relative to the toggle element.
     * Valid values are: 'auto' (which is the default), 'center', 'left' and 'right'
     */
    positionHorizontal: {
      type: String,
      default: "auto",
      validator: (e) => ["auto", "center", "left", "right"].includes(e)
    },
    /**
     * The z-index of the tooltip. Defaults to 1.
     */
    zIndex: {
      type: Number,
      default: 1
    },
    /**
     * An (optional) id to provide for the tooltip to help screenreaders to know about the tooltip.
     * If no a11yid is provided, one will be randomly generated.
     */
    a11yId: {
      type: String,
      default: null,
      required: !1
    }
  },
  data() {
    return {
      show: !1,
      timer: null,
      cursorInside: !1,
      verticalPosition: "top",
      horizontalPosition: "center",
      smallScreenNudge: void 0,
      ariaId: this.$props.a11yId || `tooltip-${Fe()}`
    };
  },
  watch: {
    positionHorizontal: {
      handler(e) {
        e !== "auto" && (this.horizontalPosition = e);
      },
      immediate: !0
    },
    positionVertical: {
      handler(e) {
        e !== "auto" && (this.verticalPosition = e);
      },
      immediate: !0
    }
  },
  mounted() {
    document.addEventListener("joltTooltipShow", this.closeOnOtherTooltipOpened);
  },
  beforeUnmount() {
    document.removeEventListener("joltTooltipShow", this.closeOnOtherTooltipOpened);
  },
  methods: {
    closeOnOtherTooltipOpened({ detail: e }) {
      this.show && e !== this.ariaId && this.closeTooltip();
    },
    hoverOverToggleArea() {
      this.timer = setTimeout(() => {
        this.show || this.showTooltip();
      }, this.delay);
    },
    hoverOutsideToggleArea() {
      clearTimeout(this.timer), this.timer = setTimeout(() => {
        this.cursorInside || this.closeTooltip();
      }, this.delay);
    },
    hoverInsideContent() {
      this.cursorInside = !0;
    },
    hoverOutsideContent() {
      this.cursorInside = !1, this.hoverOutsideToggleArea();
    },
    findSpaceAroundToggle(e) {
      const {
        top: t,
        left: n,
        width: l,
        height: s
      } = e, i = window.innerHeight - (t + s), r = window.innerWidth - (n + l);
      return {
        spaceAboveToggle: t,
        spaceBelowToggle: i,
        spaceLeftOfToggle: n,
        spaceRightOfToggle: r
      };
    },
    findPopupVerticalPosition(e, t) {
      const { spaceBelowToggle: n, spaceAboveToggle: l } = this.findSpaceAroundToggle(e);
      return n > t.height && l < t.height ? "bottom" : "top";
    },
    findPopupHorizontalPosition(e, t) {
      const { spaceLeftOfToggle: n, spaceRightOfToggle: l } = this.findSpaceAroundToggle(e), s = (t.width - e.width) / 2, i = n > s && l > s;
      return this.smallScreenNudge = void 0, i ? "center" : n > t.width ? "left" : l > t.width ? "right" : (this.smallScreenNudge = s - n, "center");
    },
    positionTooltip() {
      const e = this.$refs.toggleEl.getBoundingClientRect(), t = this.$refs.popupEl.getBoundingClientRect();
      this.positionVertical === "auto" && (this.verticalPosition = this.findPopupVerticalPosition(e, t)), this.positionHorizontal === "auto" && (this.horizontalPosition = this.findPopupHorizontalPosition(e, t));
    },
    showTooltip() {
      this.show = !0;
      const e = new CustomEvent("joltTooltipShow", {
        detail: this.ariaId
      });
      document.dispatchEvent(e), this.$nextTick(this.positionTooltip);
    },
    closeTooltip() {
      this.show = !1;
    }
  }
}, $t = ["aria-describedby"], Et = ["id"];
function Pt(e, t, n, l, s, i) {
  return a(), o("span", {
    ref: "toggleEl",
    tabindex: "0",
    class: "j-tooltip",
    style: $({ "--tooltip-max-width": n.maxWidth }),
    "aria-describedby": s.ariaId,
    onMouseover: t[2] || (t[2] = (...r) => i.hoverOverToggleArea && i.hoverOverToggleArea(...r)),
    onMouseout: t[3] || (t[3] = (...r) => i.hoverOutsideToggleArea && i.hoverOutsideToggleArea(...r)),
    onFocus: t[4] || (t[4] = (...r) => i.hoverOverToggleArea && i.hoverOverToggleArea(...r)),
    onBlur: t[5] || (t[5] = (...r) => i.hoverOutsideToggleArea && i.hoverOutsideToggleArea(...r))
  }, [
    h(e.$slots, "default", {}, void 0, !0),
    g(G, { name: "fade" }, {
      default: b(() => [
        D(u("div", {
          class: v(["j-tooltip__inner", [
            `j-tooltip__inner--vertical-${s.verticalPosition}`,
            `j-tooltip__inner--horizontal-${s.horizontalPosition}`
          ]]),
          style: $([{ zIndex: n.zIndex }, s.smallScreenNudge ? { marginLeft: `${s.smallScreenNudge}px` } : {}])
        }, [
          u("div", {
            id: s.ariaId,
            ref: "popupEl",
            class: "j-tooltip__wrapper",
            role: "tooltip",
            onMouseover: t[0] || (t[0] = (...r) => i.hoverInsideContent && i.hoverInsideContent(...r)),
            onMouseout: t[1] || (t[1] = (...r) => i.hoverOutsideContent && i.hoverOutsideContent(...r))
          }, [
            h(e.$slots, "tooltip", {}, void 0, !0)
          ], 40, Et)
        ], 6), [
          [O, s.show]
        ])
      ]),
      _: 3
    })
  ], 44, $t);
}
const He = /* @__PURE__ */ y(At, [["render", Pt], ["__scopeId", "data-v-38c6edfd"]]);
const Mt = {
  name: "tooltip-message",
  props: {
    /**
     * The minimum width for the tooltip message. It can be unrestricted by passing null.
     */
    minWidth: {
      type: String,
      default: "calc(10 * var(--j-spacing-m))"
    }
  }
};
function Ot(e, t, n, l, s, i) {
  return a(), o("div", T({
    ref: e.$attrs.ref,
    class: "j-tooltip-message",
    style: [n.minWidth ? { minWidth: n.minWidth } : {}]
  }, e.$attrs), [
    h(e.$slots, "default", {}, void 0, !0)
  ], 16);
}
const We = /* @__PURE__ */ y(Mt, [["render", Ot], ["__scopeId", "data-v-7ecfc9c9"]]);
const Bt = {
  name: "actions-group",
  components: {
    "j-button": F,
    "j-dropdown-button": ze,
    "j-tooltip": He,
    "j-tooltip-message": We
  },
  props: {
    /**
     * The array of option objects that will be rendered
     *
     * Entries should each be an `object`. The following properties are supported, all of which are optional:
     *
     * - `url` ~ `string`: If provided, the list item will contain an `a` linking to the given url. If omitted, the list item will contain a button.
     * - `isExternal` ~ `boolean`: If `url` is set and this prop is set to `true`, clicking it will open the given URL in a new tab.
     * - `disabled` ~ `boolean`: If set to  `true`, the button will be disabled.
     * - `icon` ~ `string`: If provided, the list item will show the given icon before the label.
     * - `iconClasses` ~ `string` | `Array`: If provided, the one or more given CSS classes will be applied to the icon.
     * - `label` ~ `string`: If provided, the list item will contain this label.
     * - `onClick` ~ `function`: If provided, clicking the button will trigger a call to the given function. The first argument will be the `action` object and the second will be the `$event` object.
     * - `tooltip` ~ `string`: If provided, hovering over the action icon will cause a tooltip to show with the given content. (It will be rendered into a slot)
     */
    actions: {
      type: Array,
      required: !0,
      default: () => []
    },
    /**
     * The maximum visible action items to be displayed when is full space available
     */
    maxVisibleActions: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      resizeObserver: null,
      visibleActions: this.maxVisibleActions
    };
  },
  computed: {
    hasActionPanel() {
      return this.actions.length > this.visibleActions;
    },
    sections() {
      if (!this.hasActionPanel)
        return {
          visible: this.actions
        };
      let e = [], t = this.actions;
      return this.visibleActions > 0 && (e = this.actions.slice(0, this.visibleActions), t = this.actions.slice(this.visibleActions)), {
        visible: e,
        panel: t
      };
    }
  },
  mounted() {
    this.bindObserver();
  },
  beforeUnmount() {
    var e;
    (e = this.resizeObserver) == null || e.unobserve(this.$refs.actionGroupContainer), this.resizeObserver = null;
  },
  methods: {
    bindObserver() {
      var n;
      const e = this.getActionItemWidth(), t = this.actions.length;
      this.resizeObserver = new ResizeObserver(
        ([
          {
            contentRect: { width: l }
          }
        ]) => {
          const s = Math.floor(l / e), i = Math.min(t, this.maxVisibleActions);
          s < i ? this.visibleActions = s - 1 : s === i ? this.visibleActions = i < t ? s - 1 : t : this.visibleActions = i;
        }
      ), (n = this.resizeObserver) == null || n.observe(this.$refs.actionGroupContainer);
    },
    getActionItemWidth() {
      var n, l, s, i, r;
      let e;
      Array.isArray((n = this == null ? void 0 : this.$refs) == null ? void 0 : n.actionItem) ? e = (l = this == null ? void 0 : this.$refs) == null ? void 0 : l.actionItem[0] : e = ((s = this == null ? void 0 : this.$refs) == null ? void 0 : s.actionItem) || null;
      const t = e || ((i = this == null ? void 0 : this.$refs.dropdownActionItem) == null ? void 0 : i.$el);
      return (r = t == null ? void 0 : t.getBoundingClientRect()) == null ? void 0 : r.width;
    },
    onActionClick(e, t) {
      e.onClick && e.onClick(e, t);
    }
  }
}, Nt = {
  key: 0,
  class: "j-actions-group__visible-list"
}, Lt = { key: 1 };
function Rt(e, t, n, l, s, i) {
  const r = f("j-button"), d = f("j-tooltip-message"), c = f("j-tooltip"), m = f("j-dropdown-button");
  return a(), o("div", {
    ref: "actionGroupContainer",
    class: "j-actions-group",
    onClick: t[0] || (t[0] = L(() => {
    }, ["stop"]))
  }, [
    s.visibleActions > 0 ? (a(), o("ul", Nt, [
      (a(!0), o(w, null, I(i.sections.visible, (p, j) => (a(), o("li", {
        key: j,
        ref_for: !0,
        ref: "actionItem"
      }, [
        g(c, null, Y({
          default: b(() => [
            g(r, {
              class: "j-actions-group__item",
              variant: "tertiary",
              size: "small",
              "content-type": "icon-only",
              disabled: p.disabled,
              href: p.url,
              target: p.isExternal ? "_blank" : null,
              rel: p.isExternal ? "noreferrer noopener" : null,
              "icon-id": p.icon,
              "icon-classes": p.iconClasses,
              "aria-label": p.tooltip,
              onClick: (C) => i.onActionClick(p, C)
            }, null, 8, ["disabled", "href", "target", "rel", "icon-id", "icon-classes", "aria-label", "onClick"])
          ]),
          _: 2
        }, [
          p.tooltip ? {
            name: "tooltip",
            fn: b(() => [
              g(d, null, {
                default: b(() => [
                  P(S(p.tooltip), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            key: "0"
          } : void 0
        ]), 1024)
      ]))), 128))
    ])) : _("", !0),
    i.hasActionPanel ? (a(), o("div", Lt, [
      g(m, {
        ref: "dropdownActionItem",
        "button-config": {
          variant: "tertiary",
          contentType: "icon-only",
          iconId: "icon-more",
          size: "small",
          class: "j-actions-group__item"
        },
        actions: i.sections.panel
      }, null, 8, ["actions"])
    ])) : _("", !0)
  ], 512);
}
const zt = /* @__PURE__ */ y(Bt, [["render", Rt], ["__scopeId", "data-v-752c66e8"]]);
const Ft = {
  name: "primary-nav-section-item",
  components: {
    "j-icon": E
  },
  props: {
    /**
     * The id of the icon to show
     */
    icon: {
      type: String,
      default: null
    },
    /**
     * The text of the item
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Whether or not the text should be shown
     */
    showLabel: {
      type: Boolean,
      default: !0
    },
    /**
     * Is this item an expandable section with subItems?
     */
    isExpandable: {
      type: Boolean,
      default: !1
    },
    /**
     * Is this item expanded? (only applies to items where isExpandable is set to true)
     */
    isExpanded: {
      type: Boolean,
      default: !1
    },
    /**
     * Is this item active?
     */
    isActive: {
      type: Boolean,
      default: !1
    }
  }
}, Ht = { class: "j-primary-nav-section-item" };
function Wt(e, t, n, l, s, i) {
  const r = f("j-icon");
  return a(), o("span", Ht, [
    n.icon ? (a(), k(r, {
      key: 0,
      "icon-id": n.icon,
      class: "j-primary-nav-section-item__icon"
    }, null, 8, ["icon-id"])) : _("", !0),
    u("span", {
      class: v(["j-primary-nav-section-item__label", { "j-primary-nav-section-item__label--visible": n.showLabel }])
    }, [
      P(S(n.label) + " ", 1),
      h(e.$slots, "after-label")
    ], 2),
    n.isExpandable || n.isActive ? (a(), k(r, {
      key: 1,
      "icon-id": "icon-arrow",
      class: v(["j-primary-nav-section-item__icon j-primary-nav-section-item__icon--expand", { "j-primary-nav-section-item__icon--expanded": n.isExpanded || n.isActive }])
    }, null, 8, ["class"])) : _("", !0)
  ]);
}
const Ut = /* @__PURE__ */ y(Ft, [["render", Wt]]);
const qt = {
  name: "j-primary-nav-section",
  components: {
    "j-primary-nav-section-item": Ut
  },
  props: {
    /**
     * An (optional) header for the the section
     */
    header: {
      type: String,
      default: null
    },
    /**
     * An (optional) title for the the section
     */
    navTitle: {
      type: String,
      default: null
    },
    /**
     * An array of items to render in the section. The items will be
     * passed back into the link slot, so can take any form. The only
     * recommended property to give an item is isActive, which will allow
     * it to be given a different visual treatment, showing its active status.
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * Whether or not item labels should be shown
     */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
     * The index of the expanded item in the section (if one is expanded, null otherwise)
     */
    expandedItemIndex: {
      type: Number,
      default: null
    },
    /**
     * The index of the active item in the section (if the active item is in this section, null otherwise)
     * */
    activeItemIndex: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      expandedSectionHeights: []
    };
  },
  mounted() {
    const e = [];
    if (!!this.$refs["expandableSection-0"])
      for (const n in this.$refs)
        Object.prototype.hasOwnProperty.call(this.$refs, n) && e.push(Array.isArray(this.$refs[n]) ? this.$refs[n][0] : this.$refs[n]);
    this.expandedSectionHeights = (e == null ? void 0 : e.map(
      (n) => {
        var l;
        return ((l = n == null ? void 0 : n.querySelector(".j-primary-nav-section__list--secondary")) == null ? void 0 : l.offsetHeight) || 0;
      }
    )) || [];
  },
  methods: {
    isItemVisible(e) {
      return e === this.activeItemIndex || e === this.expandedItemIndex;
    }
  }
}, Kt = ["aria-label"], Gt = { class: "j-primary-nav-section__list" }, Yt = ["disabled", "aria-expanded", "onClick"], Xt = ["aria-hidden"];
function Zt(e, t, n, l, s, i) {
  const r = f("j-primary-nav-section-item");
  return a(), o("nav", {
    class: "j-primary-nav-section",
    "aria-label": n.navTitle
  }, [
    n.header ? (a(), o("h6", {
      key: 0,
      class: v(["j-primary-nav-section__header", { "j-primary-nav-section__header--visible": n.showLabels }])
    }, S(n.header), 3)) : _("", !0),
    u("ul", Gt, [
      (a(!0), o(w, null, I(n.items, (d, c) => (a(), o("li", {
        key: d.label,
        ref_for: !0,
        ref: `expandableSection-${c}`
      }, [
        d.items ? (a(), o("button", {
          key: 0,
          disabled: c === n.activeItemIndex,
          class: v(["j-primary-nav-section__item j-primary-nav-section__item--expandable", {
            "j-primary-nav-section__item--expanded": i.isItemVisible(c),
            "j-primary-nav-section__item--active": c === n.activeItemIndex
          }]),
          "aria-expanded": i.isItemVisible(c),
          onClick: (m) => e.$emit("toggle", c)
        }, [
          g(r, {
            icon: d.icon,
            label: d.label,
            "show-label": n.showLabels,
            "is-expandable": !0,
            "is-active": c === n.activeItemIndex,
            "is-expanded": c === n.expandedItemIndex
          }, null, 8, ["icon", "label", "show-label", "is-active", "is-expanded"])
        ], 10, Yt)) : _("", !0),
        d.items ? (a(), o("div", {
          key: 1,
          class: "j-primary-nav-section__list-wrapper",
          style: $(`--expandable-section-height: ${s.expandedSectionHeights[c]}px`)
        }, [
          u("ul", {
            class: "j-primary-nav-section__list j-primary-nav-section__list--secondary",
            "aria-hidden": !i.isItemVisible(c)
          }, [
            (a(!0), o(w, null, I(d.items, (m) => (a(), o("li", {
              key: m.label
            }, [
              h(e.$slots, "link", {
                data: {
                  item: m,
                  classes: {
                    "j-primary-nav-section__item": !0,
                    "j-primary-nav-section__item--secondary": !0,
                    "j-primary-nav-section__item--active": m.isActive
                  },
                  isVisible: i.isItemVisible(c)
                }
              })
            ]))), 128))
          ], 8, Xt)
        ], 4)) : h(e.$slots, "link", {
          key: 2,
          data: {
            item: d,
            isVisible: !0,
            classes: {
              "j-primary-nav-section__item": !0,
              "j-primary-nav-section__item--active": d.isActive
            }
          }
        })
      ]))), 128))
    ])
  ], 8, Kt);
}
const Ue = /* @__PURE__ */ y(qt, [["render", Zt]]);
const Jt = {
  name: "j-primary-nav-expandable-sections",
  components: {
    "j-primary-nav-section": Ue
  },
  props: {
    /**
     * A list of navigation section objects. Each section should contain
     *      items: A list of naviagtion items
     *      header (optional): The string
     */
    sections: {
      type: Array,
      default: () => []
    },
    /**
     * Is the navigation expanded (only relevant if the PrimaryNav has isCollapsible set to true)?
     */
    navExpanded: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      // If the nav is collapsible, start it collapsed. If it isn't, start it open
      activeSectionIndex: null,
      activeItemIndex: null,
      expandedSectionIndex: null,
      expandedItemIndex: null
    };
  },
  watch: {
    sections: {
      handler() {
        this.findActiveItem();
      },
      immediate: !0
    }
  },
  methods: {
    findActiveItem() {
      const [e] = this.sections.map(
        (t, n) => t.items.map((l, s) => {
          var i;
          return {
            hasActiveItem: (i = l.items) == null ? void 0 : i.some((r) => r.isActive),
            sectionIndex: n,
            itemIndex: s
          };
        })
      ).flat().filter((t) => t.hasActiveItem);
      e ? (this.activeSectionIndex = e.sectionIndex, this.activeItemIndex = e.itemIndex) : (this.activeSectionIndex = null, this.activeItemIndex = null);
    },
    toggleExpandableSection(e, t) {
      e === this.expandedSectionIndex && t === this.expandedItemIndex ? (this.expandedSectionIndex = null, this.expandedItemIndex = null) : (this.expandedSectionIndex = e, this.expandedItemIndex = t);
    }
  }
};
function Qt(e, t, n, l, s, i) {
  const r = f("j-primary-nav-section");
  return a(), o("div", null, [
    (a(!0), o(w, null, I(n.sections, (d, c) => (a(), k(r, {
      key: c,
      header: d.header,
      "nav-title": d.navTitle || d.header,
      items: d.items,
      "show-labels": n.navExpanded,
      "active-item-index": c === s.activeSectionIndex ? s.activeItemIndex : null,
      "expanded-item-index": c === s.expandedSectionIndex ? s.expandedItemIndex : null,
      onToggle: (m) => i.toggleExpandableSection(c, m)
    }, {
      link: b(({ data: { item: m, classes: p, isVisible: j, expandNav: C, collapseNav: V } }) => [
        h(e.$slots, "link", {
          data: {
            item: m,
            classes: p,
            isVisible: j,
            navExpanded: n.navExpanded,
            expandNav: C,
            collapseNav: V
          }
        })
      ]),
      _: 2
    }, 1032, ["header", "nav-title", "items", "show-labels", "active-item-index", "expanded-item-index", "onToggle"]))), 128))
  ]);
}
const qe = /* @__PURE__ */ y(Jt, [["render", Qt]]);
let _e;
const je = () => {
  _e = window.scrollY, document.body.style.overflow = "hidden", document.body.style.top = `-${_e}px`, document.body.style.left = "0", document.body.style.right = "0", document.body.style.position = "fixed";
}, Se = () => {
  document.body.style.overflow = "", document.body.style.position = "", document.body.style.top = "", document.body.style.left = "", document.body.style.right = "", window.scrollTo({ top: _e, left: 0 });
}, Ke = {
  mounted(e, { value: t }) {
    t && je();
  },
  updated(e, { value: t, oldValue: n }) {
    t !== n && (t ? je() : Se());
  },
  unmounted(e, { value: t }) {
    t && Se();
  }
};
const en = {
  name: "j-auxiliary-nav",
  components: {
    "j-button": F,
    "j-dropdown-button": ze,
    "j-primary-nav-expandable-sections": qe,
    "j-primary-nav-section": Ue
  },
  directives: {
    clickAway: Q,
    preventBodyScroll: Ke
  },
  props: {
    /**
     * Should the navigation be shown small device mode
     */
    isSmall: {
      type: Boolean,
      default: !1
    },
    /**
     * The page title
     */
    title: {
      type: String,
      default: null
    },
    /**
     * The logo
     */
    logo: {
      type: String
    },
    primaryNavSections: {
      type: Array,
      default: () => []
    },
    /**
     * A list of items for the actions menu
     */
    actionsMenu: {
      type: Array,
      default: () => []
    },
    /**
     * A list of items for the profile menu
     */
    profileMenu: {
      type: Array,
      default: () => []
    },
    /**
     * The distance in any css unit (px, rem, vh, ...) after which the fixed position header should appear
     */
    fixedAfter: {
      type: String,
      default: "9rem"
    },
    /**
     * The first letter of the logged in user's first name
     */
    userInitial: {
      type: String,
      default: null
    },
    isHeaderVisible: {
      type: Boolean,
      default: !0
    },
    /**
     * The z-index to apply to the nav. Default is 15
     */
    zIndex: {
      type: Number,
      default: 15
    }
  },
  data() {
    return {
      isOpening: !1,
      isResizing: !1,
      hasScrolled: !1,
      smallNavOpen: !1,
      intersectionObserver: null,
      navLeft: 0,
      resizeTimeout: null,
      profileButtonConfig: {
        contentType: "circle",
        variant: "tertiary",
        class: "j-auxiliary-nav__profile-button"
      }
    };
  },
  computed: {
    hasActionsMenu() {
      var e;
      return ((e = this.actionsMenu) == null ? void 0 : e.length) > 0;
    },
    isFixed() {
      return this.isSmall || this.hasScrolled;
    },
    actionsButtonConfig() {
      return {
        contentType: "icon-only",
        iconId: "icon-add",
        variant: this.isSmall ? "primary" : "secondary",
        class: "j-auxiliary-nav__actions-button"
      };
    }
  },
  watch: {
    isSmall(e) {
      this.isResizing = !0, this.smallNavOpen = !1, clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(() => this.isResizing = !1, 300), !e && this.navLeft === 0 && (this.navLeft = this.$refs.navWrapper.getBoundingClientRect().left);
    }
  },
  beforeUnmount() {
    this.intersectionObserver.disconnect();
  },
  created() {
    this.intersectionObserver = new IntersectionObserver((e) => {
      for (const t of e)
        this.hasScrolled = t.intersectionRatio === 0;
    });
  },
  mounted() {
    this.intersectionObserver.observe(this.$refs.navTrigger), this.navLeft = this.$refs.navWrapper.getBoundingClientRect().left;
  },
  methods: {
    toggleSmallNav() {
      this.smallNavOpen = !this.smallNavOpen, this.smallNavOpen && (this.isOpening = !0, setTimeout(() => this.isOpening = !1, 300));
    },
    hideSmallNav() {
      this.isOpening || (this.smallNavOpen = !1);
    }
  }
}, tn = ["src"], nn = { class: "j-auxiliary-nav__title-wrapper" }, sn = {
  key: 0,
  class: "j-auxiliary-nav__title"
}, an = {
  key: 2,
  class: "j-auxiliary-nav__actions-button-holder"
}, ln = {
  key: 0,
  class: "j-auxiliary-nav__button-spacer"
}, on = {
  key: 0,
  class: "j-auxiliary-nav__primary-nav-overlay"
}, rn = { class: "j-auxiliary-nav__primary-nav-header" }, dn = {
  key: 0,
  class: "j-auxiliary-nav__small-contents-divider"
};
function cn(e, t, n, l, s, i) {
  const r = f("j-button"), d = f("j-dropdown-button"), c = f("j-primary-nav-expandable-sections"), m = f("j-primary-nav-section"), p = z("click-away"), j = z("prevent-body-scroll");
  return D((a(), o("nav", {
    ref: "navWrapper",
    class: v(["j-auxiliary-nav", {
      "j-auxiliary-nav--resizing": s.isResizing,
      "j-auxiliary-nav--no-small": !n.isSmall,
      "j-auxiliary-nav--isHeaderVisible": n.isHeaderVisible
    }]),
    style: $({
      "--j-auxiliary-nav-left": `${s.navLeft}px`,
      "--j-auxiliary-nav-z-index": n.zIndex
    })
  }, [
    u("div", {
      ref: "navTrigger",
      class: "j-auxiliary-nav__trigger",
      style: $({ top: n.fixedAfter })
    }, null, 4),
    g(G, { name: "navigation-pin" }, {
      default: b(() => [
        n.isHeaderVisible ? (a(), o("div", {
          key: i.isFixed,
          class: v(["j-auxiliary-nav__bar", { "j-auxiliary-nav__bar--fixed": i.isFixed }])
        }, [
          n.isSmall && n.logo ? (a(), o("img", {
            key: 0,
            src: n.logo,
            alt: "",
            class: "j-auxiliary-nav__logo"
          }, null, 8, tn)) : _("", !0),
          u("div", nn, [
            n.title ? (a(), o("h1", sn, S(n.title), 1)) : _("", !0)
          ]),
          n.isSmall ? (a(), k(r, {
            key: 1,
            "content-type": "icon-only",
            variant: "tertiary",
            "icon-id": "icon-nav",
            class: "j-auxiliary-nav__nav-button",
            onClick: i.toggleSmallNav
          }, null, 8, ["onClick"])) : _("", !0),
          i.hasActionsMenu ? (a(), o("div", an, [
            g(d, {
              "button-config": i.actionsButtonConfig,
              actions: n.actionsMenu,
              "open-panel-above": n.isSmall
            }, null, 8, ["button-config", "actions", "open-panel-above"])
          ])) : _("", !0),
          !n.isSmall && n.userInitial ? (a(), o(w, { key: 3 }, [
            i.hasActionsMenu ? (a(), o("div", ln)) : _("", !0),
            g(d, {
              "button-config": s.profileButtonConfig,
              actions: n.profileMenu
            }, {
              default: b(() => [
                P(S(n.userInitial), 1)
              ]),
              _: 1
            }, 8, ["button-config", "actions"])
          ], 64)) : _("", !0)
        ], 2)) : _("", !0)
      ]),
      _: 1
    }),
    g(G, { name: "overlay-fade" }, {
      default: b(() => [
        n.isSmall && s.smallNavOpen ? (a(), o("div", on)) : _("", !0)
      ]),
      _: 1
    }),
    n.isSmall ? D((a(), o("div", {
      key: 0,
      class: v(["j-auxiliary-nav__primary-nav", { "j-auxiliary-nav__primary-nav--visible": s.smallNavOpen }])
    }, [
      u("div", rn, [
        g(r, {
          "content-type": "icon-only",
          variant: "tertiary",
          "icon-id": "icon-delete",
          onClick: i.hideSmallNav
        }, null, 8, ["onClick"])
      ]),
      e.$slots.smallNavContent ? h(e.$slots, "smallNavContent", {
        key: 0,
        hideSmallNav: i.hideSmallNav
      }) : _("", !0),
      e.$slots.smallNavContent ? _("", !0) : (a(), o(w, { key: 1 }, [
        g(c, { sections: n.primaryNavSections }, {
          link: b(({ data: { item: C, classes: V, isVisible: A } }) => [
            h(e.$slots, "auxiliaryNavLink", {
              data: { item: C, classes: V, isVisible: A, hideSmallNav: i.hideSmallNav }
            })
          ]),
          _: 3
        }, 8, ["sections"]),
        n.profileMenu ? (a(), o("div", dn)) : _("", !0),
        g(m, { items: n.profileMenu }, {
          link: b(({ data: { item: C, classes: V } }) => [
            h(e.$slots, "auxiliaryNavProfileMenuLink", {
              data: { item: C, classes: V, hideSmallNav: i.hideSmallNav }
            })
          ]),
          _: 3
        }, 8, ["items"])
      ], 64)),
      h(e.$slots, "smallNavExtraContent")
    ], 2)), [
      [p, i.hideSmallNav]
    ]) : _("", !0)
  ], 6)), [
    [j, s.smallNavOpen]
  ]);
}
const un = /* @__PURE__ */ y(en, [["render", cn]]);
const hn = {
  name: "j-badge",
  components: {
    "j-icon": E
  },
  props: {
    /**
     * The id of the icon to display (if one is required)
     */
    icon: {
      type: String,
      default: null
    },
    /**
     * The text content of the badge
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * The variant prop controls the styling of the badge. Valid options are:
     * neutral, info, success, warning or danger
     */
    variant: {
      type: String,
      default: "neutral",
      validator: (e) => ["neutral", "info", "success", "warning", "danger"].includes(e)
    },
    /**
     * The outlined prop makes the badge renders in an outlined style. Valid options are:
     * true, false
     */
    outlined: {
      type: Boolean,
      default: !1
    }
  }
};
function pn(e, t, n, l, s, i) {
  const r = f("j-icon");
  return a(), o("div", {
    class: v(["j-badge", [`j-badge--${n.variant}`, n.outlined ? "j-badge--outlined" : ""]])
  }, [
    n.icon ? (a(), k(r, {
      key: 0,
      "icon-id": n.icon,
      class: "j-badge__icon"
    }, null, 8, ["icon-id"])) : _("", !0),
    h(e.$slots, "default", {}, () => [
      P(S(n.text), 1)
    ], !0)
  ], 2);
}
const Vo = /* @__PURE__ */ y(hn, [["render", pn], ["__scopeId", "data-v-eff104f4"]]);
const _n = {
  name: "j-card",
  components: {
    "j-icon": E
  },
  props: {
    /**
     * The string which will be used in the title of the card
     */
    tag: {
      type: String,
      default: "div"
    },
    /**
     * The string which will be used in the title of the card
     */
    title: {
      type: String,
      default: null
    },
    /**
     * The string to set orientation of the card
     * Default is vertical. Can be changed to horizontal.
     */
    orientation: {
      type: String,
      default: "vertical",
      validator: (e) => ["horizontal", "vertical"].includes(e)
    },
    /**
     * The string to set icon to the card.
     */
    icon: {
      type: String,
      default: null
    },
    /**
     * The boolean to set if card should be clickable and emit click event.
     */
    clickable: {
      type: Boolean,
      default: !0
    },
    /**
     * Cards support 3 states: disabled, active or selected.
     */
    state: {
      type: String,
      default: null,
      validator: (e) => ["disabled", "active", "selected"].includes(e)
    }
  },
  computed: {
    /*
     * Generates a random id for the internal usage.
     * @returns {string} id
     */
    componentId() {
      return ve();
    },
    /**
     * Depending on if card is clickable and not disabled makes it focusable.
     * Supported only by clickable cards.
     * @returns {boolean|number} tabindex
     */
    tabindex() {
      return this.clickable && !this.isDisabled ? 0 : !1;
    },
    /**
     * Depending on if card is clickable and disabled returns boolean value.
     * Supported only by clickable cards.
     * @returns {boolean} isDisabled
     */
    isDisabled() {
      return this.clickable && this.state === "disabled";
    },
    /**
     * Depending on if card is clickable and disabled returns boolean value.
     * Supported only by clickable cards.
     * @returns {boolean} isDisabled
     */
    isActive() {
      return this.clickable && this.state === "active";
    },
    /**
     * Depending on if card is clickable and selected returns boolean value.
     * Supported only by not clickable cards.
     * @returns {boolean} isSelected
     */
    isSelected() {
      return this.state === "selected";
    }
  },
  methods: {
    /**
     * Emitts click event.
     * Supported only by not disabled cards.
     * @param {Object} event
     */
    clicked(e) {
      this.isDisabled || this.$emit("click", e);
    },
    /**
     * Handles click on clickable card.
     * Supported only by clickable cards.
     * @param {Object} event
     */
    handleWrapperClick(e) {
      this.clickable && this.clicked(e);
    }
  }
}, mn = {
  key: 0,
  class: "j-card__label"
}, fn = { class: "j-card__wrapper" }, yn = { class: "j-card__body" }, gn = ["id"], vn = {
  key: 0,
  class: "j-card__title"
}, bn = {
  key: 1,
  class: "j-card__main"
}, jn = {
  key: 2,
  class: "j-card__footer"
};
function Sn(e, t, n, l, s, i) {
  const r = f("j-icon");
  return a(), k(J(n.tag), {
    "aria-labeledby": n.title ? `j-card__header-${i.componentId}` : "",
    class: v([[`j-card__${n.orientation}`, n.clickable ? "j-card__clickable" : ""], "j-card"]),
    disabled: i.isDisabled,
    active: i.isActive,
    "aria-selected": i.isSelected,
    tabindex: i.tabindex,
    onClickCapture: i.handleWrapperClick,
    onKeydown: R(i.handleWrapperClick, ["enter"])
  }, {
    default: b(() => [
      e.$slots.label ? (a(), o("div", mn, [
        h(e.$slots, "label", {}, void 0, !0)
      ])) : _("", !0),
      u("div", fn, [
        n.icon ? (a(), k(r, {
          key: 0,
          "icon-id": n.icon,
          class: "j-card__icon"
        }, null, 8, ["icon-id"])) : _("", !0),
        u("div", yn, [
          e.$slots.header || n.title ? (a(), o("header", {
            key: 0,
            id: `j-card__header-${i.componentId}`,
            class: "j-card__header"
          }, [
            h(e.$slots, "header", {}, () => [
              n.title ? (a(), o("h3", vn, S(n.title), 1)) : _("", !0)
            ], !0)
          ], 8, gn)) : _("", !0),
          e.$slots.default ? (a(), o("div", bn, [
            h(e.$slots, "default", {}, void 0, !0)
          ])) : _("", !0),
          e.$slots.footer ? (a(), o("footer", jn, [
            h(e.$slots, "footer", {}, void 0, !0)
          ])) : _("", !0)
        ])
      ])
    ]),
    _: 3
  }, 40, ["aria-labeledby", "class", "disabled", "active", "aria-selected", "tabindex", "onClickCapture", "onKeydown"]);
}
const Ao = /* @__PURE__ */ y(_n, [["render", Sn], ["__scopeId", "data-v-ad7ec224"]]);
const ke = 100, kn = {
  name: "j-carousel",
  components: {
    "j-button": F
  },
  props: {
    /**
     * Index of selected slide.
     */
    selectedSlide: {
      type: Number,
      default: null
    },
    /**
     * A function which resolves a translated string for Carousel description.
     * Accepts three params:
     *   - {number} start of active range
     *   - {number} end of active range
     *   - {number} total amount of slides
     */
    translationResolver: {
      type: Function,
      required: !1
    }
  },
  data() {
    return {
      slides: [],
      slidesVisibility: [],
      visibleRange: [],
      scrollTimer: null,
      resizeTimer: null,
      observer: null
    };
  },
  computed: {
    /*
     * Indicates if any movement of Carousel is happening.
     * @returns {boolean}
     */
    carouselIsMoving() {
      return !!(this.scrollTimer || this.resizeTimer);
    },
    /*
     * Gets total number of slides.
     * @returns {number}
     */
    numberOfSlides() {
      return this.slides.length;
    },
    /*
     * Indicates if carousel has any slides on the left.
     * @returns {boolean}
     */
    canScrollLeft() {
      return this.slidesVisibility[0] === !1;
    },
    /*
     * Indicates if carousel has any slides on the right.
     * @returns {boolean}
     */
    canScrollRight() {
      return this.slidesVisibility[this.slidesVisibility.length - 1] === !1;
    },
    /*
     * Runs translationResolver against current range of visible slides.
     * @returns {string|null}
     */
    descriptionTranslation() {
      var n;
      const [e, t] = this.visibleRange;
      return ((n = this.translationResolver) == null ? void 0 : n.call(this, {
        startOfRange: e + 1,
        endOfRange: t + 1,
        numberOfSlides: this.numberOfSlides
      })) || null;
    }
  },
  watch: {
    /*
     * Updates visible range of slides after carousel movement is finished.
     */
    carouselIsMoving() {
      this.updateVisibleRange();
    },
    /*
     * Updates visible range of slides after intersection observer updates slides visibility.
     */
    slidesVisibility() {
      this.updateVisibleRange();
    },
    /*
     * Scrolls to a newly selected slide.
     */
    selectedSlide() {
      this.scrollToSelectedSlide();
    }
  },
  updated() {
    const { children: e } = this.$refs.carouselContainer, t = Array.from(e).every(
      (n, l) => this.slides[l] === n
    );
    (e.length !== this.slides.length || !t) && this.setUpSlides();
  },
  mounted() {
    this.setIntersectionObserver(), this.setUpSlides(), window.addEventListener("resize", this.onResize);
  },
  beforeUnmount() {
    this.observer.disconnect(), window.removeEventListener("resize", this.onResize);
  },
  methods: {
    /*
     * Triggers carousel movement for a given direction.
     * @params {number} factor
     */
    slide(e = 1) {
      const { offsetWidth: t } = this.slides[0];
      this.$refs.carouselContainer.scrollBy({
        left: e * t,
        behavior: "smooth"
      });
    },
    /*
     * Updates internal slides tracking.
     * Resets slides observer.
     */
    setUpSlides() {
      this.slides.forEach((e) => this.observer.unobserve(e)), this.slides = [...this.$refs.carouselContainer.children], this.slidesVisibility.splice(this.slides.length), this.slides.forEach((e) => this.observer.observe(e)), this.$nextTick(() => {
        this.scrollToSelectedSlide();
      });
    },
    /*
     * Updates range of visible slides if no action is happening.
     */
    updateVisibleRange() {
      this.carouselIsMoving || (this.visibleRange = [
        this.slidesVisibility.findIndex(Boolean),
        this.slidesVisibility.lastIndexOf(!0)
      ]);
    },
    /*
     * Registers scroll event.
     */
    onScroll() {
      this.scrollTimer && clearTimeout(this.scrollTimer), this.scrollTimer = setTimeout(() => {
        this.scrollTimer = null;
      }, ke);
    },
    /*
     * Registers resize event.
     * Scrolls to active slide when resize is finished.
     */
    onResize() {
      this.resizeTimer && clearTimeout(this.resizeTimer), this.resizeTimer = setTimeout(() => {
        this.scrollToSlide(this.visibleRange[0]), this.resizeTimer = null;
      }, ke);
    },
    /*
     * Scrolls to a currently selected slide if it's not in visible range.
     */
    scrollToSelectedSlide() {
      if (typeof this.selectedSlide != "number")
        return;
      const [e, t] = this.visibleRange;
      (this.selectedSlide < e || this.selectedSlide > t) && this.scrollToSlide(this.selectedSlide);
    },
    /*
     * Scrolls to a given slide.
     * @param {number} slideIndex
     */
    scrollToSlide(e) {
      const t = this.slides[e];
      t && this.$refs.carouselContainer.scrollTo({
        left: t.offsetLeft,
        behavior: "smooth"
      });
    },
    /*
     * Initialise IntersectionObserver for carousel's root.
     */
    setIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (e) => {
          e.forEach(({ target: t, isIntersecting: n }) => {
            this.slidesVisibility[this.slides.indexOf(t)] = n;
          });
        },
        {
          threshold: 0.9,
          root: this.$refs.carouselContainer
        }
      );
    }
  }
}, Cn = { class: "j-carousel" }, wn = { class: "j-carousel__wrapper" }, xn = { class: "j-carousel__button" }, In = { class: "j-carousel__button" }, Tn = {
  key: 0,
  class: "j-carousel__bottom-description--desktop"
}, Dn = {
  key: 1,
  class: "j-carousel__bottom-description--mobile"
};
function Vn(e, t, n, l, s, i) {
  const r = f("j-button");
  return a(), o("div", Cn, [
    u("div", wn, [
      u("div", xn, [
        g(r, {
          class: "j-carousel__button--left",
          "content-type": "icon-only",
          "icon-id": "icon-arrow",
          variant: "primary",
          disabled: !i.canScrollLeft,
          onClick: t[0] || (t[0] = (d) => i.slide(-1))
        }, null, 8, ["disabled"])
      ]),
      u("div", {
        ref: "carouselContainer",
        class: "j-carousel__container",
        onScroll: t[1] || (t[1] = (...d) => i.onScroll && i.onScroll(...d))
      }, [
        h(e.$slots, "default", {}, void 0, !0)
      ], 544),
      u("div", In, [
        g(r, {
          class: "j-carousel__button--right",
          "content-type": "icon-only",
          "icon-id": "icon-arrow",
          variant: "primary",
          disabled: !i.canScrollRight,
          onClick: t[2] || (t[2] = (d) => i.slide())
        }, null, 8, ["disabled"])
      ])
    ]),
    i.descriptionTranslation ? (a(), o("div", Tn, S(i.descriptionTranslation), 1)) : _("", !0),
    i.numberOfSlides > 1 ? (a(), o("ul", Dn, [
      (a(!0), o(w, null, I(i.numberOfSlides, (d, c) => (a(), o("li", {
        key: c,
        class: v(["j-carousel__dot", { "j-carousel__dot--current": c === s.visibleRange[0] }])
      }, null, 2))), 128))
    ])) : _("", !0)
  ]);
}
const $o = /* @__PURE__ */ y(kn, [["render", Vn], ["__scopeId", "data-v-8278009c"]]);
const An = {
  name: "j-carousel-slide",
  props: {
    /**
     * CSS class to override default carousel sizing.
     */
    sizeClass: {
      type: String,
      default: "j-carousel--default"
    }
  }
};
function $n(e, t, n, l, s, i) {
  return a(), o("div", {
    class: v(["j-carousel-slide", n.sizeClass])
  }, [
    h(e.$slots, "default", {}, void 0, !0)
  ], 2);
}
const Eo = /* @__PURE__ */ y(An, [["render", $n], ["__scopeId", "data-v-a46a0d0a"]]);
const En = {
  name: "j-chart-info-highlight",
  props: {
    /**
     * Data to be shown.
     * It's an object with `value` and `label` properties.
     */
    segment: {
      type: Object,
      default: () => ({}),
      required: !0
    }
  }
}, Pn = { class: "j-chart-info-highlight" }, Mn = { class: "j-chart-info-highlight__label" }, On = { class: "j-chart-info-highlight__value" };
function Bn(e, t, n, l, s, i) {
  return D((a(), o("div", Pn, [
    u("h4", Mn, S(n.segment.label), 1),
    u("p", On, S(n.segment.value), 1)
  ], 512)), [
    [O, n.segment.value]
  ]);
}
const Nn = /* @__PURE__ */ y(En, [["render", Bn], ["__scopeId", "data-v-73ea0400"]]);
const Ln = {
  name: "j-checkbox-generic",
  props: {
    /**
     * The checkbox's value
     */
    value: {
      type: [String, Boolean],
      default: "on"
    },
    /**
     * Whether the checkbox is checked or not
     */
    modelValue: {
      type: [Boolean, Array],
      default: !1
    },
    /**
     * Indeterminate is used to display when a checkbox is neither checked nor unchecked.
     * If true, this property trumps the value passed in the value
     */
    indeterminate: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      indeterminateValue: this.indeterminate
    };
  },
  computed: {
    isChecked: {
      get() {
        return Array.isArray(this.modelValue) ? this.modelValue.includes(this.value) : this.modelValue;
      }
    }
  },
  watch: {
    indeterminate(e) {
      this.indeterminateValue = e;
    },
    modelValue() {
      this.indeterminateValue = !1;
    }
  },
  methods: {
    handleChange(e) {
      const t = e.target.checked && !this.indeterminateValue;
      if (this.indeterminateValue = !1, !Array.isArray(this.modelValue)) {
        this.$emit("update:modelValue", t);
        return;
      }
      this.$emit(
        "update:modelValue",
        t ? [...this.modelValue, this.value] : this.modelValue.filter((n) => n !== this.value)
      );
    }
  }
}, Rn = ["value", "checked", ".indeterminate"];
function zn(e, t, n, l, s, i) {
  return a(), o("input", {
    type: "checkbox",
    value: n.value,
    checked: i.isChecked,
    ".indeterminate": s.indeterminateValue,
    class: "j-checkbox-generic",
    onChange: t[0] || (t[0] = (...r) => i.handleChange && i.handleChange(...r))
  }, null, 40, Rn);
}
const Ge = /* @__PURE__ */ y(Ln, [["render", zn], ["__scopeId", "data-v-4fe37c37"]]);
const Fn = {
  name: "j-checkbox",
  components: {
    "j-icon": E,
    "j-checkbox-generic": Ge
  },
  props: {
    /**
     * Large property to render checkbox larger
     * If true, both icon and label are rendered larger
     */
    large: {
      type: Boolean,
      default: !1
    }
  }
}, Hn = { class: "j-checkbox__wrapper" }, Wn = { class: "j-checkbox__icon" }, Un = {
  key: 0,
  class: "j-checkbox__label"
};
function qn(e, t, n, l, s, i) {
  const r = f("j-checkbox-generic"), d = f("j-icon");
  return a(), o("label", {
    class: v(["j-checkbox", {
      "j-checkbox--large": n.large
    }])
  }, [
    u("span", Hn, [
      g(r, T(e.$attrs, { class: "j-checkbox__input" }), null, 16),
      u("span", Wn, [
        g(d, {
          "icon-id": "icon-minus",
          class: "j-checkbox__icon--indeterminate"
        }),
        g(d, {
          "icon-id": "icon-done",
          class: "j-checkbox__icon--checked"
        })
      ]),
      e.$slots.default ? (a(), o("span", Un, [
        h(e.$slots, "default", {}, void 0, !0)
      ])) : _("", !0)
    ])
  ], 2);
}
const Kn = /* @__PURE__ */ y(Fn, [["render", qn], ["__scopeId", "data-v-9a5f8e23"]]);
const Gn = {
  name: "j-radio",
  emits: ["update:modelValue"],
  props: {
    /**
     * The radio's model
     */
    modelValue: {
      type: [String, Boolean, Number, null],
      required: !0
    },
    /**
     * The radio's value
     */
    value: {
      type: [String, Boolean, Number]
    }
  },
  computed: {
    checked() {
      return this.value === this.modelValue;
    }
  },
  methods: {
    handleChange(e) {
      this.$emit("update:modelValue", e.target.value);
    }
  }
}, Yn = { class: "j-radio" }, Xn = ["value", "checked"], Zn = { class: "j-radio__label" };
function Jn(e, t, n, l, s, i) {
  return a(), o("label", Yn, [
    u("input", T({ type: "radio" }, e.$attrs, {
      value: n.value,
      checked: i.checked,
      class: "j-radio__input",
      onChange: t[0] || (t[0] = (...r) => i.handleChange && i.handleChange(...r))
    }), null, 16, Xn),
    u("span", Zn, [
      h(e.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const Qn = /* @__PURE__ */ y(Gn, [["render", Jn], ["__scopeId", "data-v-c0dda5aa"]]);
const ei = {
  checkbox: Kn,
  radio: Qn
}, ti = {
  name: "j-choice-group",
  props: {
    /**
     * An array of configuration for each element in the group.
     */
    config: {
      type: Array,
      required: !0
    },
    /**
     * Type of the group. Could be either `radio` or `checkbox`.
     */
    type: {
      type: String,
      validator: (e) => ["radio", "checkbox"].includes(e),
      required: !0
    },
    /**
     * Value of the group. Synced through `v-model`.
     */
    modelValue: {
      type: [Array, Boolean, String, Number, null],
      default: null
    }
  },
  data() {
    return {
      componentValue: null
    };
  },
  computed: {
    /**
     * Gets a component definition for a required type.
     * @returns {Object} component definition
     */
    component() {
      return ei[this.type];
    }
  },
  watch: {
    componentValue(e) {
      this.$emit("update:modelValue", e);
    },
    modelValue: {
      handler(e) {
        this.componentValue = this.type === "radio" || e ? e : this.config.length > 1 && [];
      },
      immediate: !0
    }
  },
  created() {
    this.componentValue = this.modelValue;
  }
}, ni = { class: "j-choice-group" };
function ii(e, t, n, l, s, i) {
  return a(), o("fieldset", ni, [
    (a(!0), o(w, null, I(n.config, (r, d) => (a(), o("div", { key: d }, [
      (a(), k(J(i.component), T({
        modelValue: s.componentValue,
        "onUpdate:modelValue": t[0] || (t[0] = (c) => s.componentValue = c),
        value: r.value
      }, r), {
        default: b(() => [
          P(S(r.label), 1)
        ]),
        _: 2
      }, 1040, ["modelValue", "value"]))
    ]))), 128))
  ]);
}
const Ce = /* @__PURE__ */ y(ti, [["render", ii], ["__scopeId", "data-v-99234818"]]);
function de(e) {
  return `0${e}`.slice(-2);
}
const le = {
  calendar: null
}, Ye = 31;
function si() {
  return Array.from({ length: Ye }, (e, t) => t + 1);
}
function ai(e, t) {
  return e ? le.calendar.days.slice(-e - (Ye - t), t) : [];
}
function li(e) {
  return e > 7 ? e.slice(0, e.length) : e;
}
const H = {
  /**
   * Returns an object of date, day, month and year properties
   * @param {string} date
   * @returns {Object}
   */
  parseDate(e) {
    const t = new Date(e);
    return {
      date: e || t,
      day: e ? t.getDate() : null,
      month: e ? t.getMonth() : null,
      year: e ? t.getFullYear() : null
    };
  },
  /**
   * Returns an array of given starting and ending numbers
   * @param {number} start
   * @param {number} end
   * @returns {Array}
   */
  getRange(e, t) {
    return Array.from({ length: t - e + 1 }, (n, l) => l + e);
  },
  /**
   * Returns date string which can be used with native date inputs
   * @param {Date|number} date
   * @param {boolean} withTime
   * @returns {string}
   */
  convertToNativeDateFormat(e, t) {
    if (e) {
      const n = new Date(e), l = t ? `T${n.toLocaleTimeString()}` : "";
      return `${n.getFullYear()}-${de(n.getMonth())}-${de(
        n.getDate()
      )}${l}`;
    }
  },
  /**
   * Returns an object which consists of years, months and days of the date placeholder
   * @param {string} placeholder
   * @param {string} value
   * @returns {Object}
   */
  getDateObjToSet(e, t) {
    const n = e[0] === "Y" ? e[4] : e[2], l = e.slice(0, 10).split(n), s = t.slice(0, 10).split(n), i = {};
    return l.forEach((r, d) => {
      i[r] = s[d];
    }), i;
  },
  /**
   * Returns a date string with given locale and translations
   * @param {string} locale
   * @param {Array} translations
   * @param {Object} options
   * @param {boolean} time
   * @returns {string} placeholder
   */
  generatePlaceholder(e, t, n, l) {
    const s = /* @__PURE__ */ new Date(), i = 25, r = 11;
    s.setDate(i), s.setMonth(r), s.setHours(0, 0, 0, 0);
    const d = s.toLocaleString(e, {
      ...n,
      ...!l && { hour: void 0, minute: void 0 }
    });
    let c = r + 1, m = 2;
    if (n.month.toLowerCase() !== "numeric") {
      K.setLocale(e);
      const A = K.MonthFormat[n.month.toUpperCase()];
      c = K.getLocalisedMonths(A)[r], m = 3;
    }
    const { dayPlaceholderChar: p, monthPlaceholderChar: j, yearPlaceholderChar: C } = t;
    let V;
    return V = d.replace(s.getFullYear(), C.repeat(4)), V = V.replace(i, p.repeat(2)), V = V.replace(c, j.repeat(m)), V;
  },
  /**
   * Sets calendar data
   * @param {?Object} data
   */
  setCalendarData(e) {
    le.calendar = e;
  },
  /**
   * Returns calendar data
   * @param {string} locale
   * @returns {Object}
   */
  getCalendarData(e) {
    return le.calendar || this.setCalendarData({
      days: si(),
      firstDayOfWeek: e === "en-US" ? 0 : 1,
      hoursTitle: "hours",
      minutesTitle: "minutes",
      previousTitle: "prev",
      nextTitle: "next"
    }), le.calendar;
  },
  /**
   * Returns combined single month view and calendar data
   * @param {number} year
   * @param {number} month
   * @param {string} locale
   * @returns {Object}
   */
  getData(e, t, n) {
    t > 11 ? e += 1 : t < 0 && (e -= 1), t = (t + 12) % 12;
    const l = this.getCalendarData(n), s = new Date(e, t, 1), i = new Date(e, t + 1, 0), r = new Date(e, t, 0), d = i.getDate(), c = r.getDate(), p = (s.getDay() - l.firstDayOfWeek + 7) % 7, j = l.days.slice(0, 6 * 7 - (p + d));
    return {
      monthView: {
        year: e,
        month: t,
        lastDayOfPreviousMonth: c,
        days: l.days.slice(0, d),
        leadingDays: ai(p, c),
        trailingDays: li(j)
      },
      calendar: l
    };
  },
  isBefore(e, t) {
    return new Date(e) < new Date(t);
  },
  isAfter(e, t) {
    return new Date(e) > new Date(t);
  }
};
function Xe(e = K.getLocale()) {
  K.setLocale(e);
  const t = K.getLocalisedMonths(K.MonthFormat.LONG), n = K.getLocalisedWeekDays();
  return {
    startingYear: 1970,
    lastYearMargin: 50,
    getLastYear() {
      return (/* @__PURE__ */ new Date()).getFullYear() + this.lastYearMargin;
    },
    endOftheDay: {
      hours: "23",
      minutes: "59"
    },
    startOftheDay: {
      hours: "00",
      minutes: "00"
    },
    translations: {
      toggle: "Toggle datepicker",
      months: t,
      days: n,
      prev: "Previous",
      next: "Next",
      clear: "Clear date",
      time: "Time",
      inputAriaLabel: "Date input",
      dayPlaceholderChar: "D",
      monthPlaceholderChar: "M",
      yearPlaceholderChar: "Y",
      errorMessages: {
        invalidTime: "Please enter a valid time",
        invalidDay: "Please enter a valid date",
        invalidMonth: "Please enter a valid month",
        wrongFormat: "Please follow the suggested date format"
      }
    },
    locale: e,
    options: {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    }
  };
}
const oi = /^[+-]?\d*[.,]?\d*$/, ri = {
  name: "j-input",
  components: { "j-button": F },
  inheritAttrs: !1,
  props: {
    /**
     * Type of input.
     * Can be text, email, number, password, tel or url.
     */
    type: {
      type: String,
      default: "text",
      validator: (e) => ["text", "email", "number", "password", "tel", "url", "search"].includes(e)
    },
    /**
     * @model
     * Input value - used for v-model binding on j-input.
     */
    modelValue: {
      type: [String, Number],
      default: ""
    },
    /**
     * Input validity property.
     * Used for aria-invalid attribute and invalid styles.
     */
    isValid: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      localType: null,
      iconId: "icon-eye"
    };
  },
  computed: {
    typeConfig() {
      return this.type === "number" ? "text" : this.type;
    },
    filteredAttrs() {
      const { class: e, ...t } = this.$attrs;
      return t;
    }
  },
  created() {
    this.localType = this.typeConfig;
  },
  methods: {
    /**
     * Handles input event, passing input value.
     * @param {Object} event
     */
    handleInput(e) {
      let { value: t } = e.target;
      const n = this.modelValue || "";
      if (this.type === "number" && t && t.length >= n.length && !oi.test(t)) {
        t = n, e.target.value = t;
        return;
      }
      this.$emit("update:modelValue", t);
    },
    /**
     * Handles click event for password input field to toggle between text and password
     */
    togglePasswordInputType() {
      this.localType === "password" ? (this.localType = "text", this.iconId = "icon-eye-closed") : (this.localType = "password", this.iconId = "icon-eye");
    }
  }
}, di = ["value", "type", "aria-invalid"];
function ci(e, t, n, l, s, i) {
  const r = f("j-button");
  return a(), o("div", {
    class: v(["j-input-wrapper", e.$attrs.class])
  }, [
    u("input", T({
      class: "j-input",
      value: n.modelValue
    }, i.filteredAttrs, {
      type: s.localType,
      "aria-invalid": !n.isValid,
      class: { "j-input--with-password-toggle": i.typeConfig === "password" },
      onInput: t[0] || (t[0] = (...d) => i.handleInput && i.handleInput(...d))
    }), null, 16, di),
    i.typeConfig === "password" ? (a(), k(r, {
      key: 0,
      size: "small",
      variant: "tertiary",
      "content-type": "icon-only",
      "icon-id": s.iconId,
      "icon-classes": "j-input__password-toggle-icon",
      class: "j-input__password-toggle",
      onClick: L(i.togglePasswordInputType, ["prevent"])
    }, null, 8, ["icon-id", "onClick"])) : _("", !0)
  ], 2);
}
const ne = /* @__PURE__ */ y(ri, [["render", ci], ["__scopeId", "data-v-bcc2517f"]]);
function Ze(e, t, n) {
  const l = e.getTime(), s = t == null ? l : Math.max(l, t.getTime()), i = n == null ? s : Math.min(s, n.getTime());
  return new Date(i);
}
function te(e, t) {
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function we(e, t) {
  return te(e, t) && e.getHours() === t.getHours();
}
function oe(e) {
  if (e == null)
    return !1;
  try {
    return !Number.isNaN(new Date(e).getTime());
  } catch {
    return !1;
  }
}
const ui = 0, xe = 1, hi = 23, U = 12;
function ie(e) {
  return oe(e) ? new Date(e) : null;
}
function pi(e, t) {
  let n = 0;
  return e === "PM" && t < 12 && (n = 12), e === "AM" && t >= 12 && (n = -12), n;
}
function Ie(e, t) {
  return e + pi(t, e);
}
function Te(e, t = 1 / 0, n = -1 / 0) {
  const l = Math.max(e, t);
  return Math.min(l, n);
}
const _i = {
  name: "j-timepicker",
  props: {
    value: {
      type: [Date, Number, String],
      default: null
    },
    min: {
      type: [Date, Number, String],
      default: null
    },
    max: {
      type: [Date, Number, String],
      default: null
    },
    dateConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // At some point in the future, we'll want to change this to be a string denoting only a number of hours and minutes. That way, we won't have to disable the input fields when there is no selected date in the Datepicker. (currently, that's needed because setting a time in the Timepicker is not possible without setting a date as well)
      date: ie(this.value)
    };
  },
  computed: {
    minDate() {
      return ie(this.min);
    },
    maxDate() {
      return ie(this.max);
    },
    usesAmPm() {
      return new Intl.DateTimeFormat(this.completeConfig.locale, { hour: "numeric" }).resolvedOptions().hour12;
    },
    hours() {
      const e = this.date == null ? 0 : this.date.getHours(), t = this.usesAmPm ? e % U || U : e;
      return de(t);
    },
    minutes() {
      const e = this.date == null ? 0 : this.date.getMinutes();
      return de(e);
    },
    amPm() {
      return this.date == null ? !this.canSelectAM && this.canSelectPM ? "PM" : "AM" : this.date.getHours() >= U ? "PM" : "AM";
    },
    minHours() {
      const e = this.usesAmPm ? xe : ui;
      if (this.date == null || this.minDate == null || !te(this.date, this.minDate))
        return e;
      if (!this.usesAmPm)
        return this.minDate.getHours();
      const t = (() => this.amPm === "AM" ? this.minDate.getHours() : Math.max(this.minDate.getHours() - U, 0))();
      return Math.max(t, xe);
    },
    maxHours() {
      const e = this.usesAmPm ? U : hi;
      return this.date == null || this.maxDate == null || !te(this.date, this.maxDate) ? e : this.usesAmPm ? U : this.maxDate.getHours();
    },
    minMinutes() {
      return this.date == null || this.minDate == null || !we(this.date, this.minDate) ? 0 : this.minDate.getMinutes();
    },
    maxMinutes() {
      return this.date == null || this.maxDate == null || !we(this.date, this.maxDate) ? 59 : this.maxDate.getMinutes();
    },
    canSelectAM() {
      return this.date == null || this.minDate == null || !te(this.date, this.minDate) ? !0 : this.minDate.getHours() <= U;
    },
    canSelectPM() {
      return this.date == null || this.maxDate == null || !te(this.date, this.maxDate) ? !0 : this.maxDate.getHours() > U;
    },
    completeConfig() {
      const e = Xe(this.dateConfig.locale);
      return ge(e, this.dateConfig);
    }
  },
  watch: {
    value(e) {
      this.date = ie(e);
    }
  },
  methods: {
    updateDate(e, t = this.date.getMinutes()) {
      const n = new Date(this.date.getTime());
      n.setHours(e, t), this.date = Ze(n, this.minDate, this.maxDate);
    },
    onChangeHours(e) {
      const t = Number(e.target.value), n = Te(t, this.minHours, this.maxHours), l = this.usesAmPm ? Ie(n, this.amPm) : n;
      this.updateDate(l), this.publish();
    },
    onChangeMinutes(e) {
      const t = Number(e.target.value), n = Te(t, this.minMinutes, this.maxMinutes), l = this.date.getHours();
      this.updateDate(l, n), this.publish();
    },
    onChangeAmPm(e) {
      const t = e.target.value, n = this.date.getHours(), l = this.usesAmPm ? Ie(n, t) : n;
      this.updateDate(l), this.publish();
    },
    publish() {
      this.$emit("updateDate", this.date);
    }
  }
}, mi = { class: "j-timepicker" }, fi = { class: "j-timepicker-inputs" }, yi = ["value", "min", "max", "disabled"], gi = ["value", "min", "max", "disabled"], vi = ["value", "disabled"], bi = ["disabled"], ji = ["disabled"];
function Si(e, t, n, l, s, i) {
  return a(), o("section", mi, [
    u("span", null, S(i.completeConfig.translations.time) + ":", 1),
    u("div", fi, [
      u("input", {
        value: i.hours,
        type: "number",
        min: i.minHours,
        max: i.maxHours,
        class: "hours",
        disabled: !s.date,
        onChange: t[0] || (t[0] = (...r) => i.onChangeHours && i.onChangeHours(...r))
      }, null, 40, yi),
      u("input", {
        value: i.minutes,
        type: "number",
        min: i.minMinutes,
        max: i.maxMinutes,
        class: "minutes",
        disabled: !s.date,
        onChange: t[1] || (t[1] = (...r) => i.onChangeMinutes && i.onChangeMinutes(...r))
      }, null, 40, gi),
      i.usesAmPm ? (a(), o("select", {
        key: 0,
        value: i.amPm,
        class: "am-pm",
        disabled: !s.date,
        onChange: t[2] || (t[2] = (...r) => i.onChangeAmPm && i.onChangeAmPm(...r))
      }, [
        u("option", {
          disabled: !i.canSelectAM,
          value: "AM"
        }, "AM", 8, bi),
        u("option", {
          disabled: !i.canSelectPM,
          value: "PM"
        }, "PM", 8, ji)
      ], 40, vi)) : _("", !0)
    ])
  ]);
}
const ki = /* @__PURE__ */ y(_i, [["render", Si], ["__scopeId", "data-v-e39ac89d"]]), Ci = {
  name: "datepicker",
  components: {
    "j-icon": E,
    "j-input": ne,
    "j-timepicker": ki
  },
  directives: {
    clickAway: Q
  },
  props: {
    /**
     * The preselected date value. This could be any string or number that's parsable by the `Date` constructor.
     */
    modelValue: {
      type: [String, Number],
      default: null
    },
    /**
     * The minimum value. (Warning: see caveats in `input` event description) This could be any string or number that's parsable by the `Date` constructor.
     */
    min: {
      type: [String, Number],
      default: null
    },
    /**
     * The maximum value. (Warning: see caveats in `input` event description) This could be any string or number that's parsable by the `Date` constructor.
     */
    max: {
      type: [String, Number],
      default: null
    },
    /**
     * Whether Datepicker also allows the user to also select time.
     */
    time: {
      type: Boolean,
      default: !1
    },
    /**
     * Where the Datepicker appears relative to the text input element. Allowed values are `"top"`, `"bottom"` and `"auto"` (default).
     */
    position: {
      type: String,
      default: "auto",
      validator(e) {
        return ["top", "bottom", "auto"].indexOf(e) > -1;
      }
    },
    /**
     * Whether the Datepicker's text input shows a button to clear the selected date.
     */
    clearBtn: {
      type: Boolean,
      default: !1
    },
    /**
     * Additional configuration
     */
    dateConfig: {
      type: Object,
      default: () => ({})
    },
    /**
     * Whether the field is required
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the field is disabled
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Identifier of the text input element
     */
    id: {
      type: String,
      default: null
    }
  },
  data() {
    const e = this.getCurrentDateFromNewValue(), t = this.getSelectedDateFromNewValue();
    return {
      isExpanded: !1,
      inputType: null,
      calendarData: {},
      selectedDate: t,
      currentDate: e,
      formattedDateTimeValue: null,
      pickerPosition: this.position === "auto" ? "bottom" : this.position,
      nativeDateInput: {
        value: null,
        max: null,
        min: null
      },
      lastPublishedDate: null,
      isTouchAvailable: "ontouchstart" in window
    };
  },
  computed: {
    isMinDateProvided() {
      return !!this.min;
    },
    isMaxDateProvided() {
      return !!this.max;
    },
    monthsOption() {
      return this.mergedConfig.translations.months.map((e, t) => ({
        name: e,
        disabled: this.minDate.year === this.currentDate.getFullYear() && this.minDate.month > t || this.maxDate.year === this.currentDate.getFullYear() && this.maxDate.month < t
      }));
    },
    days() {
      return this.calendarData.monthView.days.map((e) => ({
        number: e,
        disabled: this.isDisabledDay(e)
      }));
    },
    isNextMonthDisabled() {
      return this.isMaxDateProvided && this.currentDate.getMonth() === this.maxDate.month && this.currentDate.getFullYear() === this.maxDate.year;
    },
    isPreviousMonthDisabled() {
      return this.isMinDateProvided && this.currentDate.getMonth() === this.minDate.month && this.currentDate.getFullYear() === this.minDate.year;
    },
    showClearBtn() {
      return !this.isTouchAvailable && !!this.formattedDateTimeValue && this.clearBtn;
    },
    maxDate() {
      return H.parseDate(this.max);
    },
    minDate() {
      return H.parseDate(this.min);
    },
    yearRange() {
      const e = this.minDate.year || this.mergedConfig.startingYear, t = this.maxDate.year || this.mergedConfig.getLastYear();
      if (e > t)
        throw new Error("starting year cannot be less than ending year!");
      return H.getRange(e, t);
    },
    placeholder() {
      return this.isTouchAvailable ? !1 : H.generatePlaceholder(
        this.mergedConfig.locale,
        this.mergedConfig.translations,
        this.mergedConfig.options,
        this.time
      );
    },
    defaultConfig() {
      return Xe(this.dateConfig.locale);
    },
    mergedConfig() {
      return ge(this.defaultConfig, this.dateConfig);
    }
  },
  watch: {
    modelValue: {
      handler(e) {
        this.currentDate = this.getCurrentDateFromNewValue(), this.selectedDate = this.getSelectedDateFromNewValue(), this.handleDateInputChange(e);
      }
    }
  },
  created() {
    this.setupDatepicker();
  },
  methods: {
    setupDatepicker() {
      this.isTouchAvailable ? this.initNativeDatepicker() : this.initDatepicker();
    },
    initNativeDatepicker() {
      this.nativeDateInput.value = H.convertToNativeDateFormat(this.currentDate, this.time), this.nativeDateInput.max = H.convertToNativeDateFormat(this.maxDate.date, this.time), this.nativeDateInput.min = H.convertToNativeDateFormat(this.minDate.date, this.time), this.inputType = this.time ? "datetime-local" : "date";
    },
    initDatepicker() {
      this.getMonthView(), this.selectedDate && this.setFormattedDateTimeValue();
    },
    openDatePicker() {
      if (this.isExpanded = !0, this.position === "auto") {
        const e = this.$refs.inputEl.$el.getBoundingClientRect(), t = e.top, n = window.innerHeight - (e.top + e.height);
        this.$nextTick(() => {
          const l = this.$refs.pickerEl.getBoundingClientRect().height;
          t >= l && n < l ? this.pickerPosition = "top" : this.pickerPosition = "bottom";
        });
      }
    },
    closeDatePicker() {
      this.isExpanded = !1;
    },
    toggleDatePicker() {
      this.isExpanded ? this.closeDatePicker() : this.openDatePicker();
    },
    handleClickAway() {
      if (this.isTouchAvailable || !this.isExpanded)
        return !1;
      this.closeDatePicker(), this.selectedDate && (this.setFormattedDateTimeValue(), this.publishSelectedDate());
    },
    prevMonth() {
      const e = this.currentDate.getMonth();
      this.setMonth(e - 1);
    },
    nextMonth() {
      const e = this.currentDate.getMonth();
      this.setMonth(e + 1);
    },
    setMonth(e) {
      this.currentDate.setMonth(e, 1), this.currentDate = new Date(this.currentDate.getTime()), this.getMonthView();
    },
    getMonthView() {
      this.calendarData = H.getData(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth(),
        this.mergedConfig.locale
      );
    },
    getSelectedDate() {
      return this.selectedDate;
    },
    publishSelectedDate(e) {
      const t = e || this.selectedDate, n = t ? t.toISOString() : "";
      if (this.lastPublishedDate === n)
        return !1;
      this.lastPublishedDate = n, this.$emit("update:modelValue", n), this.publishDateValidationStatus(null);
    },
    publishDateValidationStatus(e) {
      this.$emit("validity-state", e);
    },
    getCurrentDateFromNewValue() {
      return oe(this.modelValue) ? new Date(this.modelValue) : /* @__PURE__ */ new Date();
    },
    getSelectedDateFromNewValue() {
      return oe(this.modelValue) ? new Date(this.modelValue) : "";
    },
    setFormattedDateTimeValue() {
      const { hour: e, minute: t, ...n } = this.mergedConfig.options;
      this.formattedDateTimeValue = this.time ? this.selectedDate.toLocaleString(this.mergedConfig.locale, this.mergedConfig.options) : this.selectedDate.toLocaleDateString(this.mergedConfig.locale, n);
    },
    onChangeMonth(e) {
      const t = Number(e.target.value);
      this.setMonth(t);
    },
    onChangeYear(e) {
      this.currentDate.setFullYear(Number(e.target.value), this.currentDate.getMonth(), 1), this.currentDate = new Date(this.currentDate), this.currentDate.getFullYear() === this.maxDate.year && this.currentDate.setMonth(this.maxDate.month), this.currentDate.getFullYear() === this.minDate.year && this.currentDate.setMonth(this.minDate.month), this.getMonthView();
    },
    onClickDay(e) {
      this.currentDate.setDate(e);
      const t = this.isMinDateProvided ? new Date(this.min) : null, n = this.isMaxDateProvided ? new Date(this.max) : null;
      this.currentDate = Ze(this.currentDate, t, n), this.setSelectedDate(), this.setFormattedDateTimeValue(), this.publishSelectedDate(), this.closeDatePicker();
    },
    onChangeTime(e) {
      this.currentDate = e, this.selectedDate = e, this.setFormattedDateTimeValue(), this.publishSelectedDate();
    },
    onChangeNativeDatepicker(e) {
      const t = new Date(e.target.value);
      this.publishSelectedDate(t);
    },
    setSelectedDate() {
      this.selectedDate = null, this.selectedDate = new Date(this.currentDate.getTime());
    },
    onInput(e) {
      this.isTyping = !0, this.handleDateInputChange(e), this.$nextTick(() => {
        this.isTyping = !1;
      });
    },
    handleDateInputChange(e) {
      if (!e) {
        this.clearDate();
        return;
      }
      oe(e) ? (this.setDateByInputValue(e), this.isTyping || (this.setFormattedDateTimeValue(), this.publishSelectedDate())) : (this.selectedDate = null, this.publishDateValidationStatus(this.mergedConfig.translations.errorMessages.wrongFormat));
    },
    setDateByInputValue(e) {
      this.currentDate = new Date(e), this.setSelectedDate(), this.getMonthView();
    },
    clearDate() {
      this.formattedDateTimeValue = null, this.selectedDate = null, this.publishSelectedDate(null);
    },
    isDisabledDay(e) {
      const t = new Date(new Date(this.currentDate).setDate(e)), n = new Date(new Date(t).setHours(0, 0, 0, 0)), l = new Date(new Date(t).setHours(23, 59, 59, 999));
      return this.isMinDateProvided && H.isBefore(l, this.min) ? !0 : this.isMaxDateProvided && H.isAfter(n, this.max);
    },
    isSelectedDay(e) {
      return !this.currentDate || !this.selectedDate ? !1 : this.currentDate.toLocaleDateString() === this.selectedDate.toLocaleDateString() ? this.currentDate.getDate() === e.number : !1;
    },
    openOnSpace() {
      this.isExpanded || this.openDatePicker();
    },
    closeOnEsc() {
      this.isExpanded && this.closeDatePicker();
    }
  }
};
const wi = { class: "j-datepicker-input-container" }, xi = ["id", "type", "min", "max", "disabled"], Ii = ["title", "disabled"], Ti = ["disabled", "title"], Di = { ref: "pickerEl" }, Vi = { class: "j-datepicker-month-year-nav" }, Ai = ["title", "disabled"], $i = ["disabled", "value", "selected"], Ei = ["value", "selected"], Pi = ["title", "disabled"], Mi = { class: "j-datepicker-month-view" }, Oi = ["title"], Bi = ["disabled", "onClick"];
function Ni(e, t, n, l, s, i) {
  const r = f("j-input"), d = f("j-icon"), c = f("j-timepicker"), m = z("click-away");
  return D((a(), o("div", {
    class: v(["j-datepicker", { "j-datepicker__open": e.isExpanded }]),
    onKeyup: t[9] || (t[9] = R((...p) => e.closeOnEsc && e.closeOnEsc(...p), ["esc"]))
  }, [
    u("div", wi, [
      e.isTouchAvailable ? _("", !0) : (a(), k(r, {
        key: 0,
        id: e.id,
        ref: "inputEl",
        modelValue: e.formattedDateTimeValue,
        "onUpdate:modelValue": [
          t[0] || (t[0] = (p) => e.formattedDateTimeValue = p),
          e.onInput
        ],
        type: "text",
        class: "j-datepicker-input",
        "aria-label": e.mergedConfig.translations.inputAriaLabel,
        placeholder: e.placeholder,
        maxlength: e.placeholder.length,
        required: e.required,
        disabled: e.disabled,
        autocomplete: "off",
        onKeyup: R(e.openOnSpace, ["space"]),
        onClick: e.openDatePicker
      }, null, 8, ["id", "modelValue", "aria-label", "placeholder", "maxlength", "required", "disabled", "onUpdate:modelValue", "onKeyup", "onClick"])),
      e.isTouchAvailable ? D((a(), o("input", {
        key: 1,
        id: e.id,
        "onUpdate:modelValue": t[1] || (t[1] = (p) => e.nativeDateInput.value = p),
        type: e.inputType,
        class: "j-datepicker-input",
        min: e.nativeDateInput.min,
        max: e.nativeDateInput.max,
        disabled: e.disabled,
        onChange: t[2] || (t[2] = (...p) => e.onChangeNativeDatepicker && e.onChangeNativeDatepicker(...p))
      }, null, 40, xi)), [
        [ot, e.nativeDateInput.value]
      ]) : _("", !0),
      e.showClearBtn ? (a(), o("button", {
        key: 2,
        type: "button",
        title: e.mergedConfig.translations.clear,
        class: "j-datepicker-clear-btn",
        disabled: e.disabled,
        onClick: t[3] || (t[3] = (p) => e.clearDate())
      }, [
        g(d, {
          class: "j-datepicker-icon",
          "icon-id": "icon-delete"
        })
      ], 8, Ii)) : _("", !0),
      e.isTouchAvailable ? _("", !0) : (a(), o("button", {
        key: 3,
        type: "button",
        disabled: e.disabled,
        title: e.mergedConfig.translations.toggle,
        class: "j-datepicker-calendar-button",
        onClick: t[4] || (t[4] = (...p) => e.toggleDatePicker && e.toggleDatePicker(...p))
      }, [
        g(d, {
          class: "j-datepicker-icon j-datepicker-icon__calendar",
          "icon-id": "icon-calendar"
        })
      ], 8, Ti))
    ]),
    g(G, { name: "appear" }, {
      default: b(() => [
        e.isTouchAvailable ? _("", !0) : D((a(), o("div", {
          key: 0,
          class: v(["j-datepicker-container", `j-datepicker-container__${e.pickerPosition}`])
        }, [
          u("div", Di, [
            u("section", Vi, [
              u("button", {
                title: e.mergedConfig.translations.prev,
                type: "button",
                disabled: e.isPreviousMonthDisabled,
                onClick: t[5] || (t[5] = (p) => e.prevMonth())
              }, [
                g(d, {
                  class: "j-datepicker-icon j-datepicker-icon__left",
                  "icon-id": "icon-arrow"
                })
              ], 8, Ai),
              u("select", {
                name: "datepicker-month",
                onChange: t[6] || (t[6] = (...p) => e.onChangeMonth && e.onChangeMonth(...p))
              }, [
                (a(!0), o(w, null, I(e.monthsOption, (p, j) => (a(), o("option", {
                  key: j,
                  disabled: p.disabled,
                  value: j,
                  selected: e.currentDate.getMonth() === j
                }, S(p.name), 9, $i))), 128))
              ], 32),
              u("select", {
                name: "datepicker-year",
                onChange: t[7] || (t[7] = (...p) => e.onChangeYear && e.onChangeYear(...p))
              }, [
                (a(!0), o(w, null, I(e.yearRange, (p, j) => (a(), o("option", {
                  key: j,
                  value: p,
                  selected: e.currentDate.getFullYear() === p
                }, S(p), 9, Ei))), 128))
              ], 32),
              u("button", {
                title: e.mergedConfig.translations.next,
                type: "button",
                disabled: e.isNextMonthDisabled,
                onClick: t[8] || (t[8] = (p) => e.nextMonth())
              }, [
                g(d, {
                  class: "j-datepicker-icon j-datepicker-icon__right",
                  "icon-id": "icon-arrow"
                })
              ], 8, Pi)
            ]),
            u("section", Mi, [
              (a(!0), o(w, null, I(e.mergedConfig.translations.days, (p, j) => (a(), o("span", {
                key: `dayOfWeek${j}`,
                title: p.fullName,
                class: "j-datepicker-day-name",
                disabled: ""
              }, S(p.shortName), 9, Oi))), 128)),
              (a(!0), o(w, null, I(e.calendarData.monthView.leadingDays, (p, j) => (a(), o("button", {
                key: `leadingDay${j}`,
                type: "button",
                class: "j-datepicker-week-day",
                disabled: ""
              }, S(p), 1))), 128)),
              (a(!0), o(w, null, I(e.days, (p, j) => (a(), o("button", {
                key: `day${j}`,
                type: "button",
                disabled: p.disabled,
                class: v(["j-datepicker-week-day", { "j-datepicker-selected-day": e.isSelectedDay(p) }]),
                onClick: (C) => e.onClickDay(p.number)
              }, S(p.number), 11, Bi))), 128)),
              (a(!0), o(w, null, I(e.calendarData.monthView.trailingDays, (p, j) => (a(), o("button", {
                key: `trailingDay${j}`,
                type: "button",
                class: "j-datepicker-week-day",
                disabled: ""
              }, S(p), 1))), 128))
            ]),
            e.time ? (a(), k(c, {
              key: 0,
              value: e.selectedDate && e.selectedDate.toISOString(),
              min: e.min,
              max: e.max,
              "date-config": e.dateConfig,
              onUpdateDate: e.onChangeTime
            }, null, 8, ["value", "min", "max", "date-config", "onUpdateDate"])) : _("", !0)
          ], 512)
        ], 2)), [
          [O, e.isExpanded]
        ])
      ]),
      _: 1
    })
  ], 34)), [
    [m, e.handleClickAway]
  ]);
}
const Li = /* @__PURE__ */ y(Ci, [["render", Ni], ["__scopeId", "data-v-bfab1bcb"]]);
const ce = 5, ee = 45, re = 47, Ri = 1e3 / 60, zi = 100, De = (re - ee) / (zi / Ri), Fi = Math.PI / 180, se = { x: 50, y: 50 }, Hi = 5, Ve = "Total";
function Ae(e, t) {
  const n = /* @__PURE__ */ new Map();
  return (...l) => {
    const s = l.join(":");
    return n.has(s) || n.set(s, e.apply(t, l)), n.get(s);
  };
}
const Wi = {
  name: "j-donut-chart",
  components: {
    "j-chart-info-highlight": Nn
  },
  props: {
    /**
     * Set of data to be represented in the chart.
     * It's an array of objects with possible properties: value, label, color.
     */
    dataset: {
      type: Array,
      required: !0,
      default: () => []
    },
    /**
     * Locale to use for localization.
     * It's a string with the desired locale code -i.e.: 'nl-NL'.
     * If not provided, it falls back to 'en-US'`.
     */
    locale: {
      type: String,
      default: null
    },
    /**
     * String to use as `label` for the total segment.
     * It's a string with the desired string for the total `label`. It can be used for language localization.
     * If not provided, it falls back to 'Total'`.
     */
    totalLabel: {
      type: String,
      default: Ve
    },
    /**
     * Number to use to control the width of the segment.
     * A number of more than 6 will cause the segment to overflow outside of the svg (although this works)
     */
    segmentWidth: {
      type: Number,
      default: 2
    },
    /**
     * Number to use to control the width of the segment that is selected.
     * A number of more than 6 will cause the segment to overflow outside of the svg (although this works)
     */
    selectedSegmentWidth: {
      type: Number,
      default: 3
    },
    /**
     * Number that controls the gap between the segments in the donut chart
     */
    segmentGap: {
      type: Number,
      default: Hi
    },
    /**
     * Should the segment widths scale with the svg?
     * If true, the value for segmentWidth will be the thickness in px that the segments will be ONLY IF the svg is 100px wide.
     * - If the svg is scaled wider than 100px, the segments will be > segmentWidth px thick
     * - If the svg is scaled narrower than 100px, the segments will be < segmentWidth px thick
     *
     * If false, the segments won't scale proportionally to the svg. This means that they will always be segmentWidth px thick
     * In addition, the segment gap will also be automatically scaled too.
     */
    scaleSegmentWidth: {
      type: Boolean,
      default: !0
    },
    /**
     * A function which takes a number and returns a formatted string.
     * This could be used to display a currency with the currency symbol instead of a raw number, for example.
     */
    numberFormatter: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      selectedIndex: -1,
      radii: [],
      resizeObserver: null,
      elementWidth: 0
    };
  },
  computed: {
    /**
     * Calculates each segment's arc to be used as the `d` attribute of a SVG `path`.
     * @returns {Array} containing the arc for each segment.
     */
    arcs() {
      if (this.radii.length === 1)
        return [this.describeCircleArc(this.radii[0])];
      let e = 360, t = null;
      return this.radii.map((n, l) => {
        t = this.parts[l];
        const s = e - (t + this.gap), i = this.describeArc(n, s, e - this.gap);
        return e = s, i;
      });
    },
    /**
     * Calculates each segment's proportion in degrees out of the whole circa.
     * Ensures that the minimum segment length is 5 degrees adjusting the others to fit the circa.
     * @returns {Array} containing the part for each segment
     */
    parts() {
      const e = this.dataset.length, t = (360 - e * this.gap) / this.totalValue;
      let n = 0, l = 0;
      return this.sortedExtendedDataset.map(({ value: s }) => {
        let i = s * t;
        return i < ce ? (n = n + ce - i, l = l + 1, i = ce) : l && (i = i - n / (e - l)), i;
      });
    },
    gap() {
      if (this.scaleSegmentWidth)
        return this.segmentGap;
      const e = (this.elementWidth || 100) / 100;
      return this.segmentGap / e;
    },
    /**
     * Extends `dataset`'s segments with `radius` property and sorts them in descending order
     * @returns {Array} containing segments
     */
    sortedExtendedDataset() {
      return [...this.dataset].sort((e, t) => e.value - t.value).map((e) => ({
        radius: ee,
        ...e
      }));
    },
    /**
     * Calculates the sum of all segment's values
     * @returns {number} total
     */
    totalValue() {
      return this.dataset.reduce((e, t) => e + t.value, 0);
    },
    /**
     * Generated the total segment with its value as the sum of all segment's values
     * @returns {Object} containing `label` and `value` properties
     */
    totalSegment() {
      return {
        label: this.totalLabel || Ve,
        value: this.getLocalisedValue(this.totalValue)
      };
    },
    /**
     * Generated the highlighted segment
     * @returns {Object} containing `label` and `value` properties
     */
    highlightedSegment() {
      if (this.selectedIndex === -1)
        return this.totalSegment;
      const { label: e, value: t } = this.sortedExtendedDataset[this.selectedIndex];
      return {
        label: e,
        value: this.getLocalisedValue(t)
      };
    }
  },
  watch: {
    dataset: {
      handler(e) {
        const t = Array.isArray(e) ? e.length : 0;
        this.radii = new Array(t).fill(ee);
      },
      immediate: !0
    },
    scaleSegmentWidth: {
      handler(e) {
        e ? (this.resizeObserver.disconnect(), this.resizeObserver = null) : this.makeResizeObserver();
      }
    }
  },
  /**
   * Replaces arcs generating methods with memoized versions.
   * Doing it on `created` hook we bind memoize cache to the component instance.
   */
  created() {
    this.describeArc = Ae(this.describeArc, this), this.describeCircleArc = Ae(this.describeCircleArc, this);
  },
  mounted() {
    this.scaleSegmentWidth || this.makeResizeObserver();
  },
  beforeUnmount() {
    this.scaleSegmentWidth || this.resizeObserver.disconnect();
  },
  methods: {
    /**
     * Calculates arc's point position on cartesian system
     * @param {number} radius
     * @param {number} angleInDegrees
     * @returns {Object}
     */
    polarToCartesian(e, t) {
      const n = (t - 90) * Fi;
      return {
        x: se.x + e * Math.cos(n),
        y: se.y + e * Math.sin(n)
      };
    },
    /**
     * Generates paths commands (`d` attribute) for an arc
     * @param {number} radius
     * @param {number} startAngle
     * @param {number} endAngle
     * @returns {string}
     */
    describeArc(e, t, n) {
      const l = this.polarToCartesian(e, t), s = this.polarToCartesian(e, n), i = n - t <= 180 ? "0" : "1";
      return `M ${l.x} ${l.y} A ${e} ${e} 0 ${i} 1 ${s.x} ${s.y}`;
    },
    /**
     * Generates paths commands (`d` attribute) for a circle
     * @param {number} radius
     * @returns {string}
     */
    describeCircleArc(e) {
      return `M ${se.x} ${se.y} m -${e}, 0 a ${e},${e} 0 1,1 ${e * 2},0 a ${e},${e} 0 1,1 ${-(e * 2)},0`;
    },
    /**
     * Triggers selected segment decreasing
     * Resets selected index
     */
    clearSelected() {
      this.decreaseRadius(this.selectedIndex), this.selectedIndex = -1;
    },
    /**
     * Triggers selected segment increasing
     * Sets selected index
     * @param {number} index
     */
    handleMouseEnter(e) {
      this.selectedIndex = e, this.increaseRadius(e);
    },
    /**
     * Gradually increases segment's radius
     * @param {number} index
     */
    increaseRadius(e) {
      const t = () => {
        const n = this.radii[e] + De;
        this.updateRadii(
          e,
          n > re ? re : n
        ), n < re && e === this.selectedIndex && window.requestAnimationFrame(t);
      };
      window.requestAnimationFrame(t);
    },
    /**
     * Gradually decreases segment's radius
     * @param {number} index
     */
    decreaseRadius(e) {
      const t = () => {
        const n = this.radii[e] - De;
        this.updateRadii(e, n < ee ? ee : n), n > ee && e !== this.selectedIndex && window.requestAnimationFrame(t);
      };
      window.requestAnimationFrame(t);
    },
    /**
     * Updates data property `radii`
     * To trigger Vue reactivity we need to reset an array
     * @param {number} index
     * @param {number} radius
     */
    updateRadii(e, t) {
      const n = [...this.radii];
      n[e] = t, this.radii = [...n];
    },
    /**
     * Verifies if mouse left default segment's area
     * @param {Object} event
     */
    handleMouseLeave(e) {
      e.relatedTarget !== this.$refs.baseCircle && this.clearSelected();
    },
    /**
     * Generates localised value based on locale
     * @param {number} value
     * @returns {string}
     */
    getLocalisedValue(e) {
      return this.numberFormatter ? this.numberFormatter(e) : this.locale ? e.toLocaleString(this.locale) : e.toLocaleString();
    },
    /**
     * Creates a resize observer which is used to update the size of gaps between
     * the segments if scaleSegmentWidth is false.
     */
    makeResizeObserver() {
      this.resizeObserver = new ResizeObserver((e) => {
        for (const t of e)
          this.elementWidth = t.contentRect.width;
      }), this.resizeObserver.observe(this.$refs.chartEl);
    }
  }
}, Ui = {
  ref: "chartEl",
  class: "j-donut-chart"
}, qi = {
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg",
  class: "j-donut-chart__svg"
}, Ki = ["d", "vector-effect", "stroke-width", "onMouseenter"], Gi = /* @__PURE__ */ u("circle", {
  cx: "50",
  cy: "50",
  r: "42",
  fill: "transparent"
}, null, -1);
function Yi(e, t, n, l, s, i) {
  const r = f("j-chart-info-highlight");
  return a(), o("div", Ui, [
    (a(), o("svg", qi, [
      u("circle", {
        ref: "baseCircle",
        cx: "50",
        cy: "50",
        r: "46",
        fill: "transparent",
        class: "j-donut-chart__base-circle",
        onMouseleave: t[0] || (t[0] = (...d) => i.clearSelected && i.clearSelected(...d))
      }, null, 544),
      (a(!0), o(w, null, I(i.arcs, (d, c) => (a(), o("path", {
        key: c,
        d,
        "vector-effect": n.scaleSegmentWidth ? "none" : "non-scaling-stroke",
        class: "j-donut-chart__path",
        "stroke-width": c === s.selectedIndex ? n.selectedSegmentWidth : n.segmentWidth,
        style: $({
          "--segment-color": i.sortedExtendedDataset[c].color
        }),
        fill: "transparent",
        onMouseenter: (m) => i.handleMouseEnter(c),
        onMouseleave: t[1] || (t[1] = (...m) => i.handleMouseLeave && i.handleMouseLeave(...m))
      }, null, 44, Ki))), 128)),
      Gi
    ])),
    h(e.$slots, "default", M(B(i.highlightedSegment)), () => [
      g(r, { segment: i.highlightedSegment }, null, 8, ["segment"])
    ])
  ], 512);
}
const Po = /* @__PURE__ */ y(Wi, [["render", Yi]]);
const Xi = {
  name: "j-empty-state",
  components: {
    "j-icon": E
  },
  props: {
    /**
     * The icon to show as part of the empty state
     */
    icon: {
      type: String,
      default: "icon-empty-state-generic"
    },
    /**
     * The headline reason for why we're showing an empty state
     */
    title: {
      type: String,
      required: !0
    },
    /**
     * A more detailed desciption of why we're showing an empty state
     */
    description: {
      type: String,
      default: null
    },
    /**
     * The max-width to allow for the title and description. All variants have min widths defined for the content,
     * so using a max-width that's less than the variant's min-width will do nothing.
     */
    textMaxWidth: {
      type: String,
      default: "calc(12.5 * var(--j-spacing-m))"
    },
    /**
     * Empty state variant (e.g. vertical, horizontal)
     */
    variant: {
      type: String,
      default: "vertical",
      validator: (e) => ["vertical", "horizontal", "small-vertical"].includes(e)
    }
  }
}, Zi = {
  class: /* @__PURE__ */ v("j-empty-state__text")
}, Ji = { class: "j-empty-state__description" }, Qi = {
  key: 0,
  class: "j-empty-state__actions"
};
function es(e, t, n, l, s, i) {
  const r = f("j-icon");
  return a(), o("div", {
    class: v(["j-empty-state", `j-empty-state--${n.variant}`]),
    style: $(`--j-empty-state-content-max-width: ${n.textMaxWidth}`)
  }, [
    g(r, {
      "icon-id": n.icon,
      class: v(`j-empty-state__icon--${n.variant}`)
    }, null, 8, ["icon-id", "class"]),
    u("div", {
      class: v(`j-empty-state__wrapper--${n.variant}`)
    }, [
      u("div", Zi, [
        u("h2", {
          class: v(["j-empty-state__title", `j-empty-state__title--${n.variant}`])
        }, S(n.title), 3),
        u("div", {
          class: v(`j-empty-state__content j-empty-state__content--${n.variant}`)
        }, [
          h(e.$slots, "content", {}, () => [
            u("p", Ji, S(n.description), 1)
          ], !0)
        ], 2)
      ]),
      e.$slots.actions ? (a(), o("div", Qi, [
        h(e.$slots, "actions", {}, void 0, !0)
      ])) : _("", !0)
    ], 2)
  ], 6);
}
const Mo = /* @__PURE__ */ y(Xi, [["render", es], ["__scopeId", "data-v-e60d88c2"]]);
const ts = {
  name: "j-error-message",
  components: {
    "j-icon": E
  },
  props: {
    message: {
      type: String,
      default: null
    }
  }
}, ns = {
  class: "j-error-message",
  role: "alert"
}, is = { class: "j-error-message__text" };
function ss(e, t, n, l, s, i) {
  const r = f("j-icon");
  return a(), o("p", ns, [
    n.message ? (a(), k(r, {
      key: 0,
      class: "j-error-message__icon",
      "icon-id": "icon-error"
    })) : _("", !0),
    u("span", is, S(n.message), 1)
  ]);
}
const as = /* @__PURE__ */ y(ts, [["render", ss], ["__scopeId", "data-v-c97bc747"]]);
const ls = {
  name: "j-feedback-banner",
  components: {
    "j-button": F,
    "j-icon": E
  },
  props: {
    /**
     * The title of the banner
     */
    title: {
      type: String,
      default: null
    },
    /**
     * A callback function for when the banner's close button is clicked. If this is not provided,
     * there will be no close button on the banner
     */
    onClose: {
      type: Function,
      default: null
    },
    /**
     * Is the aim to try to display this message on a single line if the screen size permits?
     * If so the buttons will only wrap under the text when there is no more space next to it
     */
    isSingleLine: {
      type: Boolean,
      default: !1
    },
    /**
     * The banner variant: info, success, error or warning. This changes the color and icon used
     */
    variant: {
      type: String,
      default: "info",
      validator: (e) => ["info", "success", "error", "warning"].includes(e)
    },
    /**
     * Translation to be used when close button is enabled.
     */
    closeButtonTranslation: {
      type: String,
      default: "Dismiss"
    }
  },
  computed: {
    iconId() {
      return this.variant === "warning" ? "icon-alert" : `icon-${this.variant}`;
    }
  }
}, os = {
  key: 0,
  class: "j-feedback-banner__title"
}, rs = {
  key: 1,
  class: "j-feedback-banner__message"
}, ds = {
  key: 0,
  class: "j-feedback-banner__buttons"
};
function cs(e, t, n, l, s, i) {
  const r = f("j-icon"), d = f("j-button");
  return a(), o("div", {
    class: v(["j-feedback-banner", [`j-feedback-banner--${n.variant}`, { "j-feedback-banner--single-line": n.isSingleLine }]])
  }, [
    u("div", {
      class: v(["j-feedback-banner__text", {
        "j-feedback-banner__text--single-line": n.isSingleLine
      }])
    }, [
      g(r, {
        "icon-id": i.iconId,
        class: "j-feedback-banner__icon"
      }, null, 8, ["icon-id"]),
      n.title ? (a(), o("h5", os, S(n.title), 1)) : _("", !0),
      e.$slots.message ? (a(), o("div", rs, [
        h(e.$slots, "message", {}, void 0, !0)
      ])) : _("", !0)
    ], 2),
    e.$slots.buttons || n.onClose ? (a(), o("div", ds, [
      e.$slots.buttons ? h(e.$slots, "buttons", { key: 0 }, void 0, !0) : _("", !0),
      n.onClose ? (a(), k(d, {
        key: 1,
        variant: "tertiary",
        class: "j-feedback-banner__close-button",
        onClick: n.onClose
      }, {
        default: b(() => [
          P(S(n.closeButtonTranslation), 1)
        ]),
        _: 1
      }, 8, ["onClick"])) : _("", !0)
    ])) : _("", !0)
  ], 2);
}
const Oo = /* @__PURE__ */ y(ls, [["render", cs], ["__scopeId", "data-v-6035f77d"]]);
const us = {
  name: "j-label",
  props: {
    helpText: {
      type: String,
      default: ""
    },
    small: {
      type: Boolean,
      default: !1
    }
  }
}, hs = {
  key: 0,
  class: "j-label-wrapper"
}, ps = { class: "j-label-help" };
function _s(e, t, n, l, s, i) {
  return a(), o("label", T({
    ref: e.$attrs.ref
  }, e.$attrs, {
    class: ["j-label", [n.small ? "j-label-small" : ""]]
  }), [
    n.helpText ? (a(), o("span", hs, [
      h(e.$slots, "default", {}, void 0, !0),
      u("span", ps, S(n.helpText), 1)
    ])) : _("", !0),
    n.helpText ? _("", !0) : h(e.$slots, "default", { key: 1 }, void 0, !0)
  ], 16);
}
const ms = /* @__PURE__ */ y(us, [["render", _s], ["__scopeId", "data-v-a6352a73"]]);
const fs = {
  name: "j-textarea",
  props: {
    /**
     * @model
     * Input value - used for v-model binding on j-textarea.
     */
    modelValue: {
      type: String,
      default: ""
    },
    /**
     * Input validity property.
     * Used for aria-invalid attribute and invalid styles.
     */
    isValid: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    /**
     * Handles input event, passing input value.
     * @param {Object} event
     */
    handleInput(e) {
      this.$emit("update:modelValue", e.target.value);
    }
  }
}, ys = ["value", "aria-invalid"];
function gs(e, t, n, l, s, i) {
  return a(), o("textarea", T({
    class: "j-textarea",
    value: n.modelValue
  }, e.$attrs, {
    "aria-invalid": !n.isValid,
    onInput: t[0] || (t[0] = (...r) => i.handleInput && i.handleInput(...r)),
    onBlur: t[1] || (t[1] = (r) => e.$emit("blur")),
    onKeydown: t[2] || (t[2] = R(L(() => {
    }, ["stop"]), ["enter"]))
  }), null, 16, ys);
}
const $e = /* @__PURE__ */ y(fs, [["render", gs], ["__scopeId", "data-v-af2e2c36"]]);
const vs = {
  name: "j-input-group",
  components: {
    "j-input": ne
  },
  props: {
    /**
     * @model
     * Input value - used for v-model binding on j-input.
     */
    modelValue: {
      type: [String, Number],
      default: ""
    },
    /**
     * Input validity property.
     * Used for aria-invalid attribute, j-input-group__invalid class and invalid styles.
     */
    isValid: {
      type: Boolean,
      default: !0
    },
    /**
     * Input disability property.
     * Used for disabled attribute, j-input-group__disabled class and invalid styles.
     */
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    /**
     * Handles input event, passing input value.
     * @param {string} inputValue
     */
    handleInput(e) {
      this.$emit("update:modelValue", e);
    }
  }
}, bs = {
  key: 0,
  class: "j-input__tag"
}, js = {
  key: 1,
  class: "j-input__tag"
};
function Ss(e, t, n, l, s, i) {
  const r = f("j-input");
  return a(), o("div", {
    class: v(["j-input-group", { "j-input-group__disabled": n.disabled, "j-input-group__invalid": !n.isValid }])
  }, [
    e.$slots.prependTag ? (a(), o("div", bs, [
      h(e.$slots, "prependTag", {}, void 0, !0)
    ])) : _("", !0),
    h(e.$slots, "default", {}, () => [
      g(r, T({ class: "j-input-group__input" }, e.$attrs, {
        disabled: n.disabled,
        "is-valid": n.isValid,
        "model-value": n.modelValue,
        "onUpdate:modelValue": i.handleInput
      }), null, 16, ["disabled", "is-valid", "model-value", "onUpdate:modelValue"])
    ], !0),
    e.$slots.appendTag ? (a(), o("div", js, [
      h(e.$slots, "appendTag", {}, void 0, !0)
    ])) : _("", !0)
  ], 2);
}
const Ee = /* @__PURE__ */ y(vs, [["render", Ss], ["__scopeId", "data-v-0049abe4"]]), ks = {
  name: "j-input-generic",
  components: {
    "j-input": ne,
    "j-textarea": $e,
    "j-input-group": Ee
  },
  emits: ["update:modelValue"],
  inheritAttrs: !1,
  props: {
    /**
     * @model
     * Input value - used for v-model binding on j-input.
     */
    modelValue: {
      type: [String, Number],
      default: ""
    }
  },
  computed: {
    /**
     * Input inputComponent property.
     * @returns {any}
     */
    inputComponent() {
      var e;
      return ((e = this.$attrs) == null ? void 0 : e.type) === "textarea" ? $e : Object.keys(this.$slots).length === 0 ? ne : Ee;
    }
  },
  methods: {
    /**
     * Handles input event, passing input value.
     * @param {string} eventValue
     */
    handleInput(e) {
      this.$emit("update:modelValue", e);
    }
  }
};
function Cs(e, t, n, l, s, i) {
  return a(), k(J(i.inputComponent), T({ "model-value": n.modelValue }, e.$attrs, { "onUpdate:modelValue": i.handleInput }), Y({ _: 2 }, [
    I(e.$slots, (r, d) => ({
      name: d,
      fn: b(() => [
        h(e.$slots, d)
      ])
    }))
  ]), 1040, ["model-value", "onUpdate:modelValue"]);
}
const Je = /* @__PURE__ */ y(ks, [["render", Cs]]);
const ws = {
  name: "j-input-with-live-validation",
  components: {
    "j-input-generic": Je,
    "j-icon": E
  },
  inheritAttrs: !1,
  props: {
    /**
     * Validation status to show related icons based on provided status.
     */
    validationState: {
      type: String,
      default: "",
      validator: (e) => Object.keys(W).includes(e) || e === ""
    }
  },
  computed: {
    statusIcon() {
      return this.validationState && W[this.validationState].ICON;
    },
    isValid() {
      return this.validationState !== W.error.TEXT;
    }
  }
}, xs = { class: "j-input-with-live-validation" }, Is = { class: "j-input-with-live-validation__icon-wrapper" };
function Ts(e, t, n, l, s, i) {
  const r = f("j-input-generic"), d = f("j-icon");
  return a(), o("div", xs, [
    g(r, T(e.$attrs, {
      class: "j-input-with-live-validation__input",
      "is-valid": i.isValid
    }), Y({ _: 2 }, [
      e.$slots.prependTag ? {
        name: "prependTag",
        fn: b(() => [
          h(e.$slots, "prependTag", {}, void 0, !0)
        ]),
        key: "0"
      } : void 0,
      e.$slots.appendTag ? {
        name: "appendTag",
        fn: b(() => [
          h(e.$slots, "appendTag", {}, void 0, !0)
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["is-valid"]),
    D(u("div", Is, [
      g(d, {
        class: v(["j-input-with-live-validation__icon", i.statusIcon]),
        "icon-id": i.statusIcon
      }, null, 8, ["class", "icon-id"])
    ], 512), [
      [O, i.statusIcon]
    ])
  ]);
}
const Ds = /* @__PURE__ */ y(ws, [["render", Ts], ["__scopeId", "data-v-6a34659f"]]);
const Vs = {
  name: "j-typeahead-layout",
  components: {
    "j-panel": ye
  },
  props: {
    /**
     * Indicates if layout should be focusable.
     */
    tabindex: {
      type: Number,
      default: -1
    },
    /**
     * Validity state.
     */
    isValid: {
      type: Boolean,
      default: !0
    },
    /**
     * If panel should be shown.
     */
    showPanel: {
      type: Boolean,
      default: !1
    },
    /**
     * Custom css classes for panel.
     */
    panelCssClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isSilentFocusInProgress: !1,
      isShownWhenMouseDown: !1
    };
  },
  methods: {
    /**
     * Checks if focus is within the component
     * and imitates native `blur` behaviour.
     * @param {EventTarget} relatedTarget
     */
    onFocusOut({ relatedTarget: e }) {
      this.$el.contains(e) || (this.$emit("typeahead:blur"), this.updatePanelVisibility(!1));
    },
    /**
     * Updates panel visibility on focus.
     */
    onFocus() {
      if (this.isSilentFocusInProgress) {
        this.isSilentFocusInProgress = !1;
        return;
      }
      this.updatePanelVisibility(!0);
    },
    /**
     * Emits custom event for escape
     * and sets focus on the target if it's possible
     */
    onEsc() {
      this.$emit("typeahead:esc"), this.updatePanelVisibility(!1), this.$nextTick(() => {
        this.tabindex > -1 && this.focus({ isSilent: !0 });
      });
    },
    /**
     * Emits visibility state update.
     * @param {boolean} state
     */
    updatePanelVisibility(e) {
      this.$emit("update:showPanel", e);
    },
    /**
     * Sets focus on the root tag.
     * @param {boolean} isSilent
     */
    focus({ isSilent: e = !0 } = {}) {
      this.isSilentFocusInProgress = e, this.$el.focus();
    },
    /**
     * If panel is hidden, we show it first,
     * and process navigation on next key action.
     * @param {string} direction
     */
    onNavigate(e) {
      this.showPanel ? this.$emit(`typeahead:${e}`) : this.updatePanelVisibility(!0);
    },
    /**
     * In order to toggle Typeahead by clicking on target element
     * we need to know its state before `click` event if fired.
     */
    onMouseDown() {
      this.isShownWhenMouseDown = this.showPanel;
    },
    /**
     * If state before interaction starts is different\
     * from the state when interaction is finished,
     * the state will be toggled.
     */
    onMouseUp() {
      this.isShownWhenMouseDown === this.showPanel && this.updatePanelVisibility(!this.showPanel);
    }
  }
}, As = ["tabindex"];
function $s(e, t, n, l, s, i) {
  const r = f("j-panel");
  return a(), o("div", {
    class: "j-typeahead-layout",
    tabindex: n.tabindex,
    onFocus: t[2] || (t[2] = (...d) => i.onFocus && i.onFocus(...d)),
    onFocusout: t[3] || (t[3] = (...d) => i.onFocusOut && i.onFocusOut(...d)),
    onKeydown: [
      t[4] || (t[4] = R(L((...d) => i.onEsc && i.onEsc(...d), ["prevent"]), ["esc"])),
      t[5] || (t[5] = R((d) => i.onNavigate("up"), ["up"])),
      t[6] || (t[6] = R((d) => i.onNavigate("down"), ["down"]))
    ]
  }, [
    D(u("div", {
      class: v(["j-typeahead-layout__panel", n.panelCssClass])
    }, [
      g(r, null, {
        default: b(() => [
          h(e.$slots, "typeahead:panel", {}, void 0, !0)
        ]),
        _: 3
      })
    ], 2), [
      [O, n.showPanel]
    ]),
    u("div", {
      class: v(["j-typeahead-layout__target", { "j-typeahead-layout__target--invalid": !n.isValid }]),
      onMousedown: t[0] || (t[0] = (...d) => i.onMouseDown && i.onMouseDown(...d)),
      onMouseup: t[1] || (t[1] = (...d) => i.onMouseUp && i.onMouseUp(...d))
    }, [
      h(e.$slots, "typeahead:target", {}, void 0, !0)
    ], 34)
  ], 40, As);
}
const Qe = /* @__PURE__ */ y(Vs, [["render", $s], ["__scopeId", "data-v-ac8e115b"]]);
const Es = {
  name: "j-typeahead-search",
  components: {
    "j-icon": E,
    "j-input": ne,
    "j-button": F
  },
  inheritAttrs: !1,
  props: {
    /**
     * Input value.
     */
    value: {
      type: String,
      default: ""
    },
    /**
     * Label for "Clear" button.
     */
    buttonLabel: {
      type: String,
      default: "Clear"
    },
    /**
     * Custom color for "Clear" button icon.
     */
    buttonColor: {
      type: String,
      default: "--j-color-neutral-6"
    }
  },
  methods: {
    /**
     * Emits `clear` event and moves focus back to input.
     */
    clearSearchInput() {
      this.$emit("clear"), this.focus();
    },
    /**
     * Emits change to the input value.
     * {source: 'input'} is used to determine that change comes from input.
     * @param {string} value
     */
    onInput(e) {
      this.$emit("change:value", e, { source: "input" });
    },
    /**
     * Sets focus to the input element.
     * Could be used by parent.
     */
    focus() {
      this.$refs.input.$el.focus();
    },
    /**
     * Emits submit event.
     */
    onEnter() {
      this.$emit("submit:value", this.value);
    }
  }
}, Ps = { class: "j-typeahead-search__icon-wrapper" }, Ms = { class: "j-typeahead-search__icon-wrapper" };
function Os(e, t, n, l, s, i) {
  const r = f("j-icon"), d = f("j-input"), c = f("j-button");
  return a(), o("div", {
    class: "j-typeahead-search",
    style: $(`--j-typeahead-search-button-color: var(${n.buttonColor})`)
  }, [
    u("span", Ps, [
      g(r, {
        class: "j-typeahead-search__icon",
        size: "m",
        "icon-id": "icon-search"
      })
    ]),
    g(d, T({
      ref: "input",
      "model-value": n.value,
      autocomplete: "off"
    }, e.$attrs, {
      class: "j-typeahead-search__input",
      type: "search",
      "onUpdate:modelValue": i.onInput,
      onKeydown: [
        R(i.onEnter, ["enter"]),
        t[0] || (t[0] = R(L(() => {
        }, ["prevent"]), ["down"])),
        t[1] || (t[1] = R(L(() => {
        }, ["prevent"]), ["up"]))
      ]
    }), null, 16, ["model-value", "onUpdate:modelValue", "onKeydown"]),
    D(u("span", Ms, [
      g(c, {
        class: "j-typeahead-search__clear",
        "content-type": "icon-only",
        "icon-id": "icon-delete",
        variant: "tertiary",
        size: "small",
        "aria-label": n.buttonLabel,
        onClick: i.clearSearchInput,
        onFocusin: t[2] || (t[2] = L(() => {
        }, ["stop"]))
      }, null, 8, ["aria-label", "onClick"])
    ], 512), [
      [O, n.value]
    ])
  ], 4);
}
const et = /* @__PURE__ */ y(Es, [["render", Os], ["__scopeId", "data-v-cf798a5f"]]);
const Bs = {
  name: "j-typeahead-select",
  components: {
    "j-icon": E,
    "j-button": F
  },
  props: {
    /**
     * Placeholder for the select.
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Visual label of selected item.
     * Used with different styles than placeholder.
     */
    selectedLabel: {
      type: String,
      default: null
    },
    /**
     * Indicated if component should be in active state.
     */
    isActive: {
      type: Boolean,
      default: !1
    },
    /**
     * In case if there is a default label available,
     * this label will not be accompanied by clear button.
     */
    defaultOptionLabel: {
      type: String,
      default: ""
    }
  },
  computed: {
    /**
     * If there is selected label available, we show it
     * otherwise fallbacks to placeholder.
     * @returns {string}
     */
    visibleValue() {
      return this.selectedLabel || this.placeholder;
    },
    /**
     * Determines when we show clear button.
     * @returns {boolean}
     */
    showClearButton() {
      return !!this.selectedLabel && this.selectedLabel !== this.defaultOptionLabel;
    }
  },
  methods: {
    onClear() {
      this.$emit("clear:selection");
    }
  }
}, Ns = { class: "j-select-with-typeahead__target" };
function Ls(e, t, n, l, s, i) {
  const r = f("j-button"), d = f("j-icon");
  return a(), o("div", Ns, [
    u("span", {
      class: v(["j-select-with-typeahead__selection", { "j-select-with-typeahead__selection--placeholder": !n.selectedLabel }])
    }, S(i.visibleValue), 3),
    D(g(r, {
      class: "j-select-with-typeahead__clear",
      "content-type": "icon-only",
      "icon-id": "icon-delete",
      variant: "tertiary",
      size: "small",
      onClick: L(i.onClear, ["stop"]),
      onFocusin: t[0] || (t[0] = L(() => {
      }, ["stop"]))
    }, null, 8, ["onClick"]), [
      [O, i.showClearButton]
    ]),
    g(d, {
      class: v(["j-select-with-typeahead__arrow", { "j-select-with-typeahead__arrow--top": n.isActive }]),
      "icon-id": "icon-arrow",
      size: "m"
    }, null, 8, ["class"])
  ]);
}
const Rs = /* @__PURE__ */ y(Bs, [["render", Ls], ["__scopeId", "data-v-1a2b5908"]]);
const zs = {
  name: "option-panel",
  components: {
    "j-icon": E,
    "j-panel": ye
  },
  props: {
    /**
     * Should the panel be visible
     */
    isVisible: {
      type: Boolean,
      default: !1
    },
    /**
     * The array of option objects that will be rendered
     */
    options: {
      type: Array,
      required: !0,
      default: () => []
    },
    /**
     * The property in each option that will be used as a label
     */
    optionLabel: {
      type: String,
      default: "name"
    },
    /**
     * The property in each option that will be used as a key
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /**
     * Position option content to left or right, making the checkmark appear on opposite side
     */
    contentPosition: {
      type: String,
      default: "right",
      validator: (e) => ["right", "left"].includes(e)
    },
    /**
     * The index in the array of options of the object to be presented as selected
     */
    selectedIndex: {
      type: Number,
      default: -1
    },
    /**
     * The index in the array of options of the object to be highlighted (this is used for
     * showing which item is being selected by the keyboard)
     */
    highlightIndex: {
      type: Number,
      default: -1
    }
  },
  computed: {
    itemInTheView() {
      return [this.highlightIndex, this.selectedIndex].find((e) => e > -1);
    }
  },
  watch: {
    itemInTheView: {
      handler(e) {
        this.$nextTick(() => {
          this.scrollItemIntoView(e);
        });
      },
      immediate: !0
    },
    isVisible: {
      handler(e) {
        e && this.$nextTick(() => {
          this.scrollItemIntoView(this.selectedIndex);
        });
      },
      immediate: !0
    }
  },
  methods: {
    /**
     * Makes sure that the item is visible in the options panel
     * @param {number} itemIndex
     */
    scrollItemIntoView(e) {
      var t;
      !this.isVisible || e < 0 || e > this.options.length || (t = this.$refs["option-panel"].children[e]) == null || t.scrollIntoView({ block: "nearest" });
    },
    /**
     * Passes the object of the option that has been selected back up to the parent component
     * @param {Object} selected
     */
    onSelect(e) {
      this.$emit("select", e);
    }
  }
}, Fs = ["aria-label", "aria-selected", "onClick"];
function Hs(e, t, n, l, s, i) {
  const r = f("j-icon"), d = f("j-panel");
  return D((a(), k(d, { class: "j-option-panel" }, {
    default: b(() => [
      u("ul", {
        ref: "option-panel",
        role: "listbox",
        class: v(["j-option-panel__list", { "j-option-panel__content--position-left": n.contentPosition === "left" }])
      }, [
        (a(!0), o(w, null, I(n.options, (c, m) => (a(), o("li", {
          key: c[n.optionValue],
          ref_for: !0,
          ref: "option-items",
          role: "option",
          class: "j-option-panel__option",
          "aria-label": c[n.optionLabel],
          "aria-selected": m === n.highlightIndex,
          onClick: (p) => i.onSelect(c[n.optionValue])
        }, [
          m === n.selectedIndex ? (a(), k(r, {
            key: 0,
            class: "j-option-panel__icon",
            "icon-id": "icon-done"
          })) : _("", !0),
          h(e.$slots, "option", M(B(c)), () => [
            P(S(c[n.optionLabel]), 1)
          ], !0)
        ], 8, Fs))), 128))
      ], 2)
    ]),
    _: 3
  }, 512)), [
    [O, n.isVisible]
  ]);
}
const tt = /* @__PURE__ */ y(zs, [["render", Hs], ["__scopeId", "data-v-40016a71"]]);
const Ws = {
  name: "j-typeahead-panel",
  components: {
    "j-option-panel": tt
  },
  inheritAttrs: !1,
  props: {
    /**
     * Indicates the property of provided items which should be used as unique key.
     */
    uniqueBy: {
      type: String,
      default: "id"
    },
    /**
     * Indicates the property of provided items which should be used as a label.
     */
    labeledBy: {
      type: String,
      default: "name"
    },
    /**
     * List of possible items for selection.
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * Currently highlighted option.
     */
    highlightedIndex: {
      type: Number,
      default: -1
    },
    /**
     * Selected option.
     */
    selectedIndex: {
      type: Number,
      default: -1
    },
    /**
     * Label of currently selected option.
     */
    selectedLabel: {
      type: String,
      default: null
    },
    /**
     * Current term.
     * Used to determine if there is no match or no term provided.
     */
    term: {
      type: String,
      default: null
    },
    /**
     * In some cases we may not want to show results information.
     */
    showResultsInfo: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      showPanel: !1
    };
  },
  computed: {
    /**
     * Panel with options could be shown
     * only when there is at least one option.
     * @returns {boolean}
     */
    showOptionPanel() {
      return !!this.items.length;
    },
    /**
     * Search term to be used for search criteria highlight.
     * If there is an item selected and current term is the same as item's label,
     * then there is no need to highlight it.
     * @returns {string}
     */
    highlightedTerm() {
      return this.selectedLabel === this.term ? "" : this.term;
    }
  },
  methods: {
    /**
     * Emits selection event
     * @param {string} uniqueBy
     */
    onSelect(e) {
      this.$emit("select:option", e);
    }
  }
}, Us = {
  key: 0,
  class: "j-typeahead-panel__results-info"
}, qs = { class: "j-typeahead-panel__no-results" };
function Ks(e, t, n, l, s, i) {
  const r = f("j-option-panel");
  return a(), o("div", null, [
    D(u("div", null, [
      n.showResultsInfo ? (a(), o("div", Us, [
        h(e.$slots, "typeahead:results-info", M(B({ results: n.items })), () => [
          u("span", null, S(n.items.length) + " results found ", 1)
        ], !0)
      ])) : _("", !0),
      g(r, {
        "option-value": n.uniqueBy,
        "option-label": n.labeledBy,
        "highlight-index": n.highlightedIndex,
        "selected-index": n.selectedIndex,
        options: n.items,
        "is-visible": i.showOptionPanel,
        "base-tag": "div",
        onSelect: i.onSelect
      }, {
        option: b((d) => [
          h(e.$slots, "typeahead:option", M(B({ option: d, term: i.highlightedTerm })), () => [
            P(S(d[n.labeledBy]), 1)
          ], !0)
        ]),
        _: 3
      }, 8, ["option-value", "option-label", "highlight-index", "selected-index", "options", "is-visible", "onSelect"])
    ], 512), [
      [O, i.showOptionPanel]
    ]),
    D(u("div", qs, [
      h(e.$slots, "typeahead:no-results", { term: n.term }, () => [
        D(u("span", null, ' No results matched "' + S(n.term) + '" ', 513), [
          [O, n.term]
        ]),
        D(u("span", null, " Start typing to get results ", 512), [
          [O, !n.term]
        ])
      ], !0)
    ], 512), [
      [O, !i.showOptionPanel]
    ])
  ]);
}
const nt = /* @__PURE__ */ y(Ws, [["render", Ks], ["__scopeId", "data-v-63eae2dd"]]);
function Gs(e, t, n, l = 0) {
  const s = e + t;
  return s > n ? l : s < l ? n : s;
}
function Ys(e, t, n, l = 0) {
  const s = e + t;
  return s > n ? n : s < l ? l : s;
}
const Xs = { wrapAround: Gs, withBoundaries: Ys }, Zs = {
  name: "j-typeahead-base",
  inheritAttrs: !1,
  props: {
    /**
     * Navigation strategy to be used during keyboard navigation.
     * Check navigation.service.js for possible options.
     */
    navigationStrategy: {
      type: String,
      default: "wrapAround"
    },
    /**
     * @model
     * Currently selected option.
     */
    modelValue: {
      type: Object,
      default: null
    },
    /**
     * Indicates the property of provided items which should be used as unique key.
     */
    uniqueBy: {
      type: String,
      default: "id"
    },
    /**
     * Indicates the property of provided items which should be used as a label.
     */
    labeledBy: {
      type: String,
      default: "name"
    },
    /**
     * List of possible items for selection.
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * Default selection.
     */
    defaultOption: {
      type: Object,
      default: null
    },
    /**
     * If typeahead is currently open.
     */
    isActive: {
      type: Boolean,
      default: !1
    },
    /**
     * Custom function for term "normalization".
     * In some implementations we may want to override term on item selection.
     */
    normalizeTerm: {
      type: Function,
      default: ({ term: e }) => e
    },
    /**
     * Validity state.
     */
    isValid: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      term: "",
      currentIndex: -1
    };
  },
  computed: {
    slotProps() {
      return {
        state: this.state,
        api: {
          moveUp: () => this.navigate(-1),
          moveDown: () => this.navigate(1),
          updateTerm: this.updateTerm.bind(this),
          onEnter: this.onEnter.bind(this),
          onSelect: this.onSelect.bind(this),
          clearSearch: this.clearSearch.bind(this),
          clearSelection: this.clearSelection.bind(this),
          clear: this.clear.bind(this)
        }
      };
    },
    /**
     * Index of the current selection.
     * @returns {number}
     */
    selectedIndex() {
      return this.modelValue ? this.items.findIndex((e) => e[this.uniqueBy] === this.modelValue[this.uniqueBy]) : -1;
    },
    /**
     * Label of the current selection.
     * @returns {string}
     */
    selectedLabel() {
      var e, t;
      return ((e = this.modelValue) == null ? void 0 : e[this.labeledBy]) || ((t = this.defaultOption) == null ? void 0 : t[this.labeledBy]) || null;
    },
    /**
     * State used by slotted children
     * @returns {Object}
     */
    state() {
      var e;
      return {
        selectedLabel: this.selectedLabel,
        defaultOptionLabel: ((e = this.defaultOption) == null ? void 0 : e[this.labeledBy]) || null,
        term: this.term,
        isValid: this.isValid,
        items: this.items,
        labeledBy: this.labeledBy,
        uniqueBy: this.uniqueBy,
        selectedIndex: this.selectedIndex,
        highlightedIndex: this.currentIndex
      };
    }
  },
  watch: {
    modelValue: {
      /**
       * Updates current selection when model value changes.
       * @param {Object|null} newValue
       */
      handler(e) {
        e && (this.term = this.normalizeTerm(this.state));
      },
      deep: !0,
      immediate: !0
    },
    /**
     * "Normalizes" term by provided custom function when typeahead becomes inactive.
     * @param {boolean} value
     */
    isActive(e) {
      e || (this.term = this.normalizeTerm(this.state));
    }
  },
  methods: {
    /**
     * Updates current item index,
     * depending on the selected navigation strategy.
     * Accepts 1 as direction from the 0,
     * and -1 as direction to the 0
     * @param {number} direction
     */
    navigate(e) {
      this.items.length && (this.currentIndex = Xs[this.navigationStrategy](
        this.currentIndex,
        e,
        this.items.length - 1
      ));
    },
    /**
     * Selects the currently highlighted items if there is one.
     */
    onEnter() {
      var t;
      if (!this.isActive)
        return;
      const e = this.currentIndex > -1 ? this.currentIndex : 0;
      this.onSelect((t = this.items[e]) == null ? void 0 : t[this.uniqueBy]);
    },
    /**
     * Gets an item from items by unique key and triggers selection update.
     * @param {string} key
     */
    onSelect(e) {
      e && this.updateSelection(this.items.find((t) => t[this.uniqueBy] === e));
    },
    /**
     * Updates currently selected item.
     * @param {Object} selected
     */
    updateSelection(e) {
      this.$emit("update:modelValue", e);
    },
    /**
     * Updates search term and emits relevant event.
     * @param {string} value
     * @param {Object} options
     */
    updateTerm(e, t = {}) {
      this.term = e || "", this.$emit("update:term", this.term, t);
    },
    /**
     * Sets search to empty string.
     */
    clearSearch() {
      this.updateTerm("");
    },
    /**
     * Sets selection to null.
     */
    clearSelection() {
      this.updateSelection(this.defaultOption);
    },
    /**
     * Clears current term and selection.
     */
    clear() {
      this.clearSelection(), this.clearSearch();
    }
  }
};
function Js(e, t, n, l, s, i) {
  return a(), o("div", {
    class: v(e.$attrs.class)
  }, [
    h(e.$slots, "default", M(B(i.slotProps)))
  ], 2);
}
const it = /* @__PURE__ */ y(Zs, [["render", Js]]);
const Qs = {
  name: "j-select-with-typeahead",
  components: {
    "j-typeahead-layout": Qe,
    "j-typeahead-select": Rs,
    "j-typeahead-search": et,
    "j-typeahead-panel": nt,
    "j-typeahead-base": it
  },
  props: {
    /**
     * Placeholder for the select.
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Copy used as the input's placeholder.
     */
    searchPlaceholder: {
      type: String,
      default: "Search here"
    },
    /**
     * Tabindex of typeahead's active area.
     */
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Result information could be optional.
     */
    showResultsInfo: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isActive: !1
    };
  },
  computed: {
    /**
     * When Typeahead is active, layout should not be focusable.
     * @returns {number}
     */
    layoutTabindex() {
      return this.isActive ? -1 : this.tabindex;
    }
  },
  watch: {
    /**
     * After Typeahead is activated,
     * Input gets focus.
     * @param {boolean} value
     */
    isActive(e) {
      e && this.$nextTick(() => {
        this.focusInput();
      });
    }
  },
  methods: {
    /**
     * Puts focus on the input.
     */
    focusInput() {
      this.$refs.input.focus();
    },
    /**
     * Toggles active state.
     * @param {boolean} value
     */
    togglePanel(e) {
      this.isActive = e;
    },
    /**
     * Gets new selection and propagates event up.
     * If selection is truthy, hides panel and sets focus back to layout.
     * @param {Object} selection
     */
    onUpdateSelection(e) {
      e && this.$nextTick(() => {
        this.togglePanel(!1);
      }), this.$refs.layout.focus(), this.$emit("update:modelValue", e);
    },
    /**
     * Propagates term`s update.
     * @param {string} term
     */
    onUpdateTerm(e) {
      this.$emit("update:term", e);
    }
  }
};
function ea(e, t, n, l, s, i) {
  const r = f("j-typeahead-select"), d = f("j-typeahead-search"), c = f("j-typeahead-panel"), m = f("j-typeahead-layout"), p = f("j-typeahead-base");
  return a(), k(p, T(e.$attrs, {
    "is-active": s.isActive,
    class: "j-select-with-typeahead",
    "model-value": n.modelValue,
    "onUpdate:modelValue": i.onUpdateSelection,
    "onUpdate:term": i.onUpdateTerm
  }), {
    default: b(({ api: j, state: C }) => [
      g(m, {
        ref: "layout",
        tabindex: i.layoutTabindex,
        "show-panel": s.isActive,
        "panel-css-class": "j-select-with-typeahead__panel",
        "onUpdate:showPanel": i.togglePanel,
        "onTypeahead:up": j.moveUp,
        "onTypeahead:down": j.moveDown,
        "onTypeahead:blur": t[0] || (t[0] = (V) => e.$emit("blur"))
      }, {
        "typeahead:target": b(() => [
          g(r, {
            "is-active": s.isActive,
            placeholder: n.placeholder,
            "selected-label": C.selectedLabel,
            "default-option-label": C.defaultOptionLabel,
            "onClear:selection": j.clear
          }, null, 8, ["is-active", "placeholder", "selected-label", "default-option-label", "onClear:selection"])
        ]),
        "typeahead:panel": b(() => [
          g(d, T({
            ref: "input",
            class: "j-select-with-typeahead__search",
            value: C.term,
            placeholder: n.searchPlaceholder,
            "button-color": "--j-color-neutral-4"
          }, e.$attrs, {
            "onChange:value": j.updateTerm,
            "onSubmit:value": j.onEnter,
            onClear: j.clearSearch
          }), null, 16, ["value", "placeholder", "onChange:value", "onSubmit:value", "onClear"]),
          g(c, T(C, {
            "show-results-info": n.showResultsInfo,
            "onSelect:option": j.onSelect
          }), {
            "typeahead:option": b((V) => [
              h(e.$slots, "typeahead:option", M(B(V)), void 0, !0)
            ]),
            "typeahead:no-results": b((V) => [
              h(e.$slots, "typeahead:no-results", M(B(V)), void 0, !0)
            ]),
            _: 2
          }, 1040, ["show-results-info", "onSelect:option"])
        ]),
        _: 2
      }, 1032, ["tabindex", "show-panel", "onUpdate:showPanel", "onTypeahead:up", "onTypeahead:down"])
    ]),
    _: 3
  }, 16, ["is-active", "model-value", "onUpdate:modelValue", "onUpdate:term"]);
}
const ta = /* @__PURE__ */ y(Qs, [["render", ea], ["__scopeId", "data-v-e00dcf8c"]]);
const na = {
  name: "select-input",
  props: {
    /**
     * Id of the component
     */
    id: {
      type: String,
      default: ""
    },
    /**
     * Should interaction with the SelectInput be disabled
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * This component serves no purpose by itself - it should be used with a panel.
     * This prop is about whether the associated panel is visible or not
     */
    isPanelVisible: {
      type: Boolean,
      default: !1
    },
    /**
     * The text to display if nothing selected
     */
    placeholder: {
      type: String,
      required: !0
    },
    /**
     * @model
     * value which will be passes through the v-model dir with input event
     */
    modelValue: {
      type: [String, Number],
      default: ""
    },
    /**
     * Should we use a native select? Typically for use on touchscreen devices
     * which have their own touch friendly implementations
     */
    useNative: {
      type: Boolean,
      default: !1
    },
    /**
     * The array of option objects that will be rendered
     */
    options: {
      type: Array,
      required: !0,
      default: () => []
    },
    /**
     * The property in each option that will be used as a label
     */
    optionLabel: {
      type: String,
      default: "name"
    },
    /**
     * The property in each option that will be used as a key
     */
    optionValue: {
      type: String,
      default: "value"
    }
  },
  computed: {
    /**
     * Return selected option from available options
     * @returns {Object} item from options
     */
    selected() {
      return this.options.find((e) => e[this.optionValue] === this.modelValue);
    },
    /**
     * Determine if additional logic has to be applied for selects with templates
     * @returns {boolean}
     */
    hasScopedSlots() {
      return !!this.$slots.placeholder || !!this.$slots.selected;
    }
  },
  methods: {
    /**
     * Handles input event, passing input value.
     * @param {Object} event
     */
    handleInput(e) {
      this.$emit("update:modelValue", e.target.value);
    },
    /**
     * Handles mousedown event,
     * prevents default if this.useNative property is false.
     * @param {Object} event
     */
    handleMousedown(e) {
      this.disabled || this.useNative || e.preventDefault();
    }
  }
}, ia = { class: "j-select-input" }, sa = ["id", "disabled", "value"], aa = ["selected"], la = ["value", "selected"];
function oa(e, t, n, l, s, i) {
  return a(), o("div", ia, [
    u("select", {
      id: n.id,
      ref: "select",
      disabled: n.disabled,
      value: n.modelValue,
      class: v(["j-select-input__select", {
        "j-select-input__content": !i.hasScopedSlots,
        "j-select-input__select--with-template": i.hasScopedSlots
      }]),
      onInput: t[0] || (t[0] = (...r) => i.handleInput && i.handleInput(...r)),
      onMousedown: t[1] || (t[1] = (...r) => i.handleMousedown && i.handleMousedown(...r)),
      onClick: t[2] || (t[2] = (r) => e.$refs.select.focus())
    }, [
      u("option", {
        value: "",
        selected: !n.modelValue,
        disabled: ""
      }, S(n.placeholder), 9, aa),
      (a(!0), o(w, null, I(n.options, (r) => (a(), o("option", {
        key: r[n.optionValue],
        value: r[n.optionValue],
        selected: r[n.optionValue] === n.modelValue
      }, S(r[n.optionLabel]), 9, la))), 128))
    ], 42, sa),
    i.hasScopedSlots ? (a(), o("div", {
      key: 0,
      class: v(["j-select-input__content", { "j-select-input__content--disabled": n.disabled }])
    }, [
      n.modelValue ? _("", !0) : h(e.$slots, "placeholder", { key: 0 }, () => [
        P(S(n.placeholder), 1)
      ], !0),
      n.modelValue ? h(e.$slots, "selected", M(T({ key: 1 }, i.selected)), () => [
        P(S(i.selected[n.optionLabel]), 1)
      ], !0) : _("", !0)
    ], 2)) : _("", !0)
  ]);
}
const ra = /* @__PURE__ */ y(na, [["render", oa], ["__scopeId", "data-v-6a556420"]]);
const da = {
  name: "j-select",
  components: {
    "select-input": ra,
    "option-panel": tt
  },
  directives: {
    clickAway: Q
  },
  props: {
    /**
     * Id to propagate to the dropdown-select component
     */
    id: {
      type: String,
      default: ""
    },
    /**
     * The array of option objects that will be rendered in the OptionPanel
     */
    options: {
      default: () => [],
      type: Array
    },
    /**
     * The property in each option that will be used as a label
     */
    optionLabel: {
      type: String,
      default: "name"
    },
    /**
     * The property in each option that will be used as a key
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /**
     * Should interaction with the Select be disabled
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * The text to display when no option is selected
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Selected option provided for two-way binding
     */
    modelValue: {
      type: [String, Number],
      default: ""
    },
    /**
     * Position option content to left or right, making the checkmark appear on opposite side
     */
    contentPosition: {
      type: String,
      default: "right",
      validator: (e) => ["right", "left"].includes(e)
    }
  },
  data() {
    return {
      panelVisible: !1,
      selectedValue: "",
      highlightIndex: -1,
      // Used to mimic a focus like state for the keyboard
      isTouchAvailable: "ontouchstart" in window
    };
  },
  computed: {
    valueIndex() {
      return this.options.findIndex((e) => e[this.optionValue] === this.selectedValue);
    },
    filteredAttrs() {
      const { class: e, ...t } = this.$attrs;
      return t;
    }
  },
  watch: {
    selectedValue() {
      this.setHighlightIndex(), this.emitInputEvent();
    },
    modelValue(e) {
      this.options.find((t) => t[this.optionValue] === e) && (this.selectedValue = e);
    },
    options(e) {
      e.find((t) => t[this.optionValue] === this.modelValue) || (this.selectedValue = null);
    }
  },
  created() {
    this.modelValue && this.options.find((e) => e[this.optionValue] === this.modelValue) && (this.selectedValue = this.modelValue);
  },
  methods: {
    /**
     * Toggles the open state of the panel between true or false.
     * If the panelState argument is passed, it will force the open state of the panel to that value
     * @param {boolean|undefined} panelState
     * @returns {void}
     */
    togglePanelState(e) {
      this.disabled || this.isTouchAvailable || (this.panelVisible = e === void 0 ? !this.panelVisible : !!e, this.setHighlightIndex());
    },
    /**
     * Sets the highlighted index to the index of the currently selected item, or -1 if no item is selected.
     */
    setHighlightIndex() {
      this.highlightIndex = this.selectedValue ? this.valueIndex : -1;
    },
    /**
     * Handles keyboard input on the select.
     * @param {event} event
     */
    // eslint-disable-next-line complexity
    handleKeyboard(e) {
      if (!(this.isTouchAvailable || e.keyCode === 9 && !this.panelVisible))
        if (e.preventDefault(), this.panelVisible)
          switch (e.keyCode) {
            case 27: {
              this.togglePanelState(!1);
              break;
            }
            case 13:
            case 32: {
              const t = this.options[this.highlightIndex];
              t ? this.selectOption(t[this.optionValue]) : this.togglePanelState(!1);
              break;
            }
            case 38: {
              this.highlightIndex = Math.max(this.highlightIndex - 1, 0);
              break;
            }
            case 40: {
              this.highlightIndex = Math.min(this.highlightIndex + 1, this.options.length - 1);
              break;
            }
            default: {
              const t = this.findOptionIndexByFirstCharacter(e.key);
              t > -1 && (this.highlightIndex = t);
            }
          }
        else
          switch (e.keyCode) {
            case 32:
            case 38:
            case 40: {
              this.togglePanelState();
              break;
            }
            default: {
              const t = this.findOptionIndexByFirstCharacter(e.key);
              t > -1 && this.selectOption(this.options[t][this.optionValue]);
            }
          }
    },
    /**
     * Finds the index of the first item in the options list that begins with the character passed in
     * Returns -1 if no item is found, or if a string that is longer or shorter than 1 character is passed in
     * @param {string} char
     * @returns {number}
     */
    findOptionIndexByFirstCharacter(e) {
      return e.length === 1 ? this.options.findIndex((t) => t[this.optionLabel].toLowerCase().startsWith(e.toLowerCase())) : -1;
    },
    /**
     * Sets the option passed in as the currently selected one
     * @param {string} selectedOptionValue
     */
    selectOption(e) {
      this.selectedValue = e, this.togglePanelState(!1), this.$refs.selectInput.$el.focus();
    },
    /**
     * Handles value change, for two-way data binding.
     */
    emitInputEvent() {
      this.$emit("update:modelValue", this.selectedValue);
    },
    emitBlurEvent(e) {
      this.$emit("blur", e);
    }
  }
}, ca = { class: "j-select" };
function ua(e, t, n, l, s, i) {
  const r = f("select-input"), d = f("option-panel"), c = z("click-away");
  return D((a(), o("div", ca, [
    g(r, T({
      id: n.id,
      ref: "selectInput",
      modelValue: s.selectedValue,
      "onUpdate:modelValue": t[0] || (t[0] = (m) => s.selectedValue = m),
      placeholder: n.placeholder
    }, i.filteredAttrs, {
      disabled: n.disabled,
      options: n.options,
      "option-label": n.optionLabel,
      "option-value": n.optionValue,
      "use-native": s.isTouchAvailable,
      "is-panel-visible": s.panelVisible,
      "aria-haspopup": s.isTouchAvailable ? !1 : "listbox",
      "aria-expanded": s.panelVisible,
      "aria-autocomplete": "list",
      onClick: t[1] || (t[1] = (m) => i.togglePanelState()),
      onBlur: i.emitBlurEvent,
      onKeydown: i.handleKeyboard,
      onKeyup: t[2] || (t[2] = L(() => {
      }, ["prevent"]))
    }), Y({ _: 2 }, [
      I(e.$slots, (m, p) => ({
        name: p,
        fn: b((j) => [
          h(e.$slots, p, M(B(j)), void 0, !0)
        ])
      }))
    ]), 1040, ["id", "modelValue", "placeholder", "disabled", "options", "option-label", "option-value", "use-native", "is-panel-visible", "aria-haspopup", "aria-expanded", "onBlur", "onKeydown"]),
    s.isTouchAvailable ? _("", !0) : (a(), k(d, {
      key: 0,
      options: n.options,
      "option-label": n.optionLabel,
      "option-value": n.optionValue,
      "selected-index": i.valueIndex,
      "highlight-index": s.highlightIndex,
      "content-position": n.contentPosition,
      "is-visible": s.panelVisible,
      onSelect: i.selectOption
    }, Y({ _: 2 }, [
      e.$slots.option ? {
        name: "option",
        fn: b((m) => [
          h(e.$slots, "option", M(B({ props: m })), void 0, !0)
        ]),
        key: "0"
      } : void 0,
      I(e.$slots, (m, p) => ({
        name: p,
        fn: b((j) => [
          h(e.$slots, "option", M(B(j)), void 0, !0)
        ])
      }))
    ]), 1032, ["options", "option-label", "option-value", "selected-index", "highlight-index", "content-position", "is-visible", "onSelect"]))
  ])), [
    [c, () => i.togglePanelState(!1)]
  ]);
}
const st = /* @__PURE__ */ y(da, [["render", ua], ["__scopeId", "data-v-438a4b62"]]), ha = "Invalid value";
function q(e, t) {
  return pa(e) ? t() : !0;
}
function pa(e) {
  return [null, void 0, ""].includes(e) ? !1 : typeof e != "object" || Array.isArray(e) && !!e.length || !!Object.keys(e).length;
}
const ue = {
  /**
   * Checks if a value is required and if so checks if it is meaningful.
   * @param {boolean} isRequired
   * @param {*} value
   * @returns {boolean|*} Result of the function invocation or `true` if a value is meaningful
   */
  required(e, t) {
    return e ? Array.isArray(t) ? !!t.length : t == null ? !1 : t === !1 ? !0 : !!String(t).trim().length : !0;
  },
  /**
   * Checks the value against given regular expression.
   * Returns true if the value is not meaningful.
   * @param {RegExp} regex
   * @param {*} value
   * @returns {boolean}
   */
  pattern(e, t) {
    return q(t, () => e.test(t));
  },
  /**
   * Checks if the value is bigger or equal to the provided minimum.
   * Returns true if the value is not meaningful.
   * @param {number} minValue
   * @param {*} value
   * @returns {boolean}
   */
  min(e, t) {
    return q(t, () => Number(t) >= e);
  },
  /**
   * Checks if the value is smaller or equal to the provided maximum.
   * Returns true if the value is not meaningful.
   * @param {number} maxValue
   * @param {*} value
   * @returns {boolean}
   */
  max(e, t) {
    return q(t, () => Number(t) <= e);
  },
  /**
   * Checks if the value length is smaller or equal to the provided minimum length.
   * Returns true if the value is not meaningful.
   * @param {number} minLength
   * @param {*} value
   * @returns {boolean}
   */
  minlength(e, t) {
    return q(t, () => Number.isInteger(t.length) && t.length >= e);
  },
  /**
   * Checks if the value length smaller or equal to the provided maximum length.
   * Returns true if the value is not meaningful.
   * @param {number} maxLength
   * @param {*} value
   * @returns {boolean}
   */
  maxlength(e, t) {
    return q(t, () => Number.isInteger(t.length) && t.length <= e);
  },
  minDate(e, t) {
    return e ? q(t, () => new Date(t) > new Date(e)) : !0;
  },
  maxDate(e, t) {
    return e ? q(t, () => new Date(t) < new Date(e)) : !0;
  },
  /**
   * Invokes given check with a given value.
   * @param {Function} customCheck
   * @param {*} value
   * @param {Object} [options]
   * @param {Object} [options.context] - form model.
   * @returns {boolean|string} Returns either boolean or a string with a custom error.
   */
  custom(e, t, n) {
    return e(t, n);
  },
  withDelay(e, t, n) {
    return q(t, () => e(t, n));
  }
};
async function Pe(e) {
  const { value: t, validationRules: n = {}, errorMessages: l = {}, options: s } = e, i = Object.keys(n);
  try {
    return await Promise.all(
      i.map(async (r) => {
        var c;
        const d = await ((c = ue[r]) == null ? void 0 : c.call(ue, n[r], t, s));
        return d === !0 ? Promise.resolve(!0) : Promise.reject(new Error(d || l[r] || ha));
      })
    ), "";
  } catch (r) {
    return Promise.reject(r.message);
  }
}
const Me = {
  checkbox: Ce,
  radio: Ce,
  select: st,
  liveValidated: Ds,
  date: Li,
  selectWithTypeahead: ta
}, _a = {
  name: "j-form-field",
  components: {
    "j-label": ms,
    "j-error": as
  },
  props: {
    /**
     * Name of the field.
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Label for a field.
     * Also, could be passed as a slot.
     */
    label: {
      type: String,
      default: null
    },
    /**
     * Label's help text.
     */
    labelHelp: {
      type: String,
      default: null
    },
    /**
     * Type of the field.
     * Could be either a string for particular input type or component definition as Constructor/Object.
     * Checkbox and radio types will use ChoiceGroup component as a proxy.
     */
    type: {
      type: [String, Function, Object],
      default: "text"
    },
    /**
     * Config for a field.
     * Checkbox and radio could accept an array of options.
     */
    config: {
      type: [Object, Array],
      default: () => ({})
    },
    /**
     * Value of the field.
     */
    modelValue: {
      type: [String, Number, Boolean, Object, Array],
      default: null
    },
    /**
     * Validation rules for a field.
     */
    validation: {
      type: Object,
      default: () => ({})
    },
    /**
     * Validation options for given validation rules (e.g: 'delay')
     */
    validationOptions: {
      type: Object,
      default: () => ({})
    },
    /**
     * Error messages for a field.
     */
    validationMessages: {
      type: Object,
      default: () => ({})
    },
    /**
     * Optional form model.
     */
    formModel: {
      type: Object,
      default: () => ({})
    },
    /**
     * Optional string containing custom styling via CSS classes for the input element/custom component.
     */
    componentCustomCss: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      componentValue: null,
      errorMessage: "",
      validationState: "",
      lastValidatedValue: null,
      asyncValidationDelay: null,
      hideError: !0,
      inputSelfValidityError: null
    };
  },
  computed: {
    /**
     * Gets an id from component config.
     * Generates a random one if no id is provided.
     * @returns {string} id
     */
    componentId() {
      return this.config.id || ve();
    },
    /**
     * Gets field props from component config.
     * If field uses ChoiceGroup then returns an array as config.
     * @returns {Object|Array}
     */
    componentProps() {
      return ["checkbox", "radio"].includes(this.type) ? { config: Tt(this.config) } : this.config;
    },
    /**
     * Gets a component definition for a required field.
     * Maps component names with supported components or returns a given component.
     * @returns {Object|Function} component definition
     */
    component() {
      return this.isAsyncValidationAvailable ? Me.liveValidated : typeof this.type == "string" ? Me[this.type] || Je : this.type;
    },
    /**
     * Checks if field have properties for Label component.
     * @returns {boolean}
     */
    hasLabel() {
      return !!(this.label || this.labelHelp || this.$slots.label);
    },
    /**
     * Checks if async validation (validation with delay) is available.
     * @returns {boolean}
     */
    isAsyncValidationAvailable() {
      return typeof this.validation.withDelay == "function";
    },
    /**
     * Filters slots and returns only dedicateds to input.
     * @returns {Object}
     */
    inputSlots() {
      const { label: e, ...t } = this.$slots;
      return t;
    }
  },
  watch: {
    /**
     * Validates new value if a field was already changed.
     * Emits `change` event.
     * @param {string|number|boolean|Object|Array} newValue
     */
    componentValue(e) {
      this.validate({ value: e, lazy: !0, forceHideError: this.hideError }), this.$emit("update:modelValue", e);
    },
    modelValue: {
      handler(e) {
        this.componentValue = e;
      },
      immediate: !0
    },
    validation: {
      handler() {
        this.lastValidatedValue = null, this.validate({ forceHideError: this.hideError });
      },
      deep: !0
    }
  },
  methods: {
    /**
     * Reacts to blur event on the `component`.
     * Makes sure validation error starts to be shown if any and runs validations.
     */
    onBlur() {
      this.hideError = !1, this.validate();
    },
    onInputSelfValidityError(e) {
      this.validationState = e ? W.error.TEXT : "", this.inputSelfValidityError = e;
    },
    /**
     * Runs validation for a given value.
     * @param {Object} params
     * @param {string|number|boolean|Object|Array} params.value
     * @param {boolean} params.lazy
     * @param {boolean} params.forceHideError
     * @returns {boolean}
     */
    async validate({ value: e = this.componentValue, lazy: t = !1, forceHideError: n = !1 } = {}) {
      if (this.inputSelfValidityError)
        return this.hideError = !1, this.errorMessage = this.inputSelfValidityError, this.validationState = W.error.TEXT, this.$emit("formFieldValidity", !this.errorMessage), !this.errorMessage;
      this.hideError = n;
      const l = JSON.stringify(e);
      if (l !== this.lastValidatedValue) {
        this.validationState = "";
        const s = {
          value: e,
          errorMessages: this.validationMessages,
          options: {
            context: this.formModel,
            ...this.validationOptions
          }
        }, { withDelay: i, ...r } = this.validation;
        try {
          await Pe({ ...s, validationRules: r }), i && s.value && await this.asyncValidate({ ...s, validationRules: { withDelay: i } }, t), this.errorMessage = "";
        } catch (d) {
          this.errorMessage = d, this.validationState = W.error.TEXT;
        }
        this.lastValidatedValue = l;
      }
      return this.$emit("formFieldValidity", !this.errorMessage), !this.errorMessage;
    },
    /**
     * Runs async validation with given config.
     * @param {Object} validationConfig
     * @param {Object} validationConfig.value
     * @param {Object} validationConfig.validationRules
     * @param {Object} validationConfig.errorMessages
     * @param {Object} validationConfig.options
     * @param {boolean} lazy
     * @returns {Promise}
     */
    asyncValidate(e, t) {
      return clearTimeout(this.asyncValidationDelay), new Promise((n, l) => {
        this.asyncValidationDelay = setTimeout(
          () => {
            this.validationState = W.running.TEXT, Pe(e).then(() => {
              this.validationState = W.successful.TEXT, n();
            }).catch((s) => {
              this.validationState = W.error.TEXT, l(s);
            });
          },
          t ? e.options.delay : 0
        );
      });
    },
    /**
     * Resets field's internal state to default values.
     */
    reset() {
      clearTimeout(this.asyncValidationDelay), this.errorMessage = "", this.lastValidatedValue = null, this.hideError = !0;
    }
  }
}, ma = { class: "j-form-field" };
function fa(e, t, n, l, s, i) {
  const r = f("j-label"), d = f("j-error");
  return a(), o("div", ma, [
    i.hasLabel ? (a(), k(r, {
      key: 0,
      class: "j-form-field__label",
      "help-text": n.labelHelp,
      for: i.componentId
    }, {
      default: b(() => [
        h(e.$slots, "label", {}, () => [
          P(S(n.label), 1)
        ], !0)
      ]),
      _: 3
    }, 8, ["help-text", "for"])) : _("", !0),
    (a(), k(J(i.component), T({
      id: i.componentId,
      modelValue: s.componentValue,
      "onUpdate:modelValue": t[0] || (t[0] = (c) => s.componentValue = c),
      required: n.validation.required,
      "is-valid": s.hideError || !s.errorMessage,
      type: n.type,
      class: n.componentCustomCss || "j-form-field__input",
      "validation-state": s.hideError ? "" : s.validationState,
      name: n.name
    }, { ...i.componentProps, ...e.$attrs }, {
      onBlur: t[1] || (t[1] = (c) => i.onBlur()),
      onValidityState: i.onInputSelfValidityError
    }), Y({ _: 2 }, [
      I(i.inputSlots, (c, m) => ({
        name: m,
        fn: b((p) => [
          h(e.$slots, m, M(B(p)), void 0, !0)
        ])
      }))
    ]), 1040, ["id", "modelValue", "required", "is-valid", "type", "class", "validation-state", "name", "onValidityState"])),
    g(d, {
      message: s.hideError ? "" : s.errorMessage
    }, null, 8, ["message"])
  ]);
}
const ya = /* @__PURE__ */ y(_a, [["render", fa], ["__scopeId", "data-v-313ea24e"]]);
const ga = {
  name: "j-form-builder",
  components: {
    "j-form-field": ya
  },
  props: {
    /**
     * Form fields configuration.
     */
    formConfig: {
      type: Array,
      required: !0,
      validator: (e) => e.every(
        (t) => {
          var n;
          return ((n = t == null ? void 0 : t.fields) == null ? void 0 : n.every(
            (l) => typeof l.name == "string" && !!l.name.length
          )) || !1;
        }
      )
    },
    /**
     * Form values from v-model.
     */
    modelValue: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fieldsValidity: {},
      isValid: null,
      itemRefs: []
    };
  },
  watch: {
    isValid(e, t) {
      e !== t && this.$emit("formValidity", e);
    },
    modelValue: {
      handler(e) {
        this.$emit("update:modelValue", e);
      },
      deep: !0,
      immediate: !0
    }
  },
  async mounted() {
    this.$watch("formConfig", this.onFormConfigChange, { immediate: !0, deep: !0 });
  },
  methods: {
    /**
     * Calculates overall form validity by aggregating fields validity.
     * Triggers `formValidity` custom event on model change and passes the new model.
     * @param {Object} fieldsetName
     * @param {Object} fieldName
     * @param {Object} valid
     */
    handleFormFieldValidity(e = "", t, n) {
      this.fieldsValidity[`${e}:${t}`] = n, this.isValid = Object.values(this.fieldsValidity).every(Boolean);
    },
    /**
     * Triggers `change` event on model change and passes the new model.
     */
    handleModelChange() {
      this.$emit("update:modelValue", this.modelValue);
    },
    /**
     * Runs validation and triggers `submit` event if form is valid.
     * @param {Object} event
     */
    async handleSubmission(e) {
      if (e.stopImmediatePropagation(), await this.validateForm()) {
        this.$emit("submit", this.modelValue);
        return;
      }
      this.scrollToInvalidField();
    },
    /**
     * Runs validation against all formFields.
     * @param {boolean} forceHideError
     */
    async validateForm(e = !1) {
      return await Promise.all(this.itemRefs.map((t) => t.validate({ forceHideError: e }))), this.isValid;
    },
    /**
     * Resets each field to initial state.
     */
    resetForm() {
      this.itemRefs.forEach((e) => e == null ? void 0 : e.reset());
    },
    /**
     * Checks if a description for the provided fieldset param has been specified in any possible way.
     * The possible ways to do so are: as a slot or in the fieldset config
     * @param {Object} fieldset
     * @returns {boolean|Promise} - combined result of validation.
     */
    hasFieldsetDescription({ description: e, name: t }) {
      return !!(e || this != null && this.$slots[`${t}FieldsetDescription`]);
    },
    /**
     * Creates default validity property object.
     * @returns {Object}
     */
    setValidity() {
      return this.formConfig.reduce((e, t) => {
        const { fields: n = [], name: l = "" } = t;
        return n.forEach((s) => {
          var r;
          const i = `${l}:${s.name}`;
          e[i] = ((r = this.formValidity) == null ? void 0 : r[i]) ?? null;
        }), e;
      }, {});
    },
    /**
     * Reacts to `formConfig` change.
     */
    onFormConfigChange() {
      this.fieldsValidity = this.setValidity();
    },
    /**
     * Filters slots by field name.
     * @param {string} fieldName
     * @returns {Object}
     */
    filterFieldSlots(e) {
      return Object.keys(this.$slots).filter((t) => t.includes(e)).reduce((t, n) => (t[n] = this.clearSlotName(n, e), t), {});
    },
    /**
     * Remove field name for slot name.
     * @param {string} slotName
     * @param {string} fieldName
     * @returns {string}
     */
    clearSlotName(e, t) {
      const n = e.replace(t, "");
      return n.charAt(0).toLowerCase() + n.slice(1);
    },
    /**
     * Scroll the form to the first invalid field in case there is one.
     * @param {Object} options passed to Element.scrollIntoView
     * @returns {void}
     */
    scrollToInvalidField(e = { behavior: "smooth" }) {
      const t = Object.entries(this.fieldsValidity).find((n) => n[1] === !1);
      if (t) {
        const n = t[0].split(":")[1], l = this.itemRefs.find((s) => s.name === n);
        l && l.$el.scrollIntoView(e);
      }
    },
    setItemRef(e) {
      e && this.itemRefs.push(e);
    }
  }
}, va = ["disabled", "aria-disabled"], ba = {
  key: 1,
  class: "j-form-builder__description"
}, ja = {
  key: 0,
  class: "j-form-builder__actions"
};
function Sa(e, t, n, l, s, i) {
  const r = f("j-form-field");
  return a(), o("form", {
    novalidate: "",
    class: "j-form-builder",
    onReset: t[0] || (t[0] = L(() => {
    }, ["prevent"])),
    onKeydown: t[1] || (t[1] = R(L((...d) => i.handleSubmission && i.handleSubmission(...d), ["prevent"]), ["enter"])),
    onSubmit: t[2] || (t[2] = L((...d) => i.handleSubmission && i.handleSubmission(...d), ["prevent"]))
  }, [
    (a(!0), o(w, null, I(n.formConfig, (d, c) => (a(), o("fieldset", {
      key: c,
      disabled: d.disabled,
      "aria-disabled": d.disabled,
      class: "j-form-builder__fieldset"
    }, [
      d.title ? (a(), o("h4", {
        key: 0,
        class: v(["j-form-builder__title", { "j-form-builder__title--no-description": !i.hasFieldsetDescription(d) }])
      }, S(d.title), 3)) : _("", !0),
      i.hasFieldsetDescription(d) ? (a(), o("div", ba, [
        h(e.$slots, `${d.name}FieldsetDescription`, {}, () => [
          P(S(d.description), 1)
        ], !0)
      ])) : _("", !0),
      (a(!0), o(w, null, I(d.fields, (m) => (a(), o(w, {
        key: `${m.name}-field`
      }, [
        g(r, T({
          ref_for: !0,
          ref: i.setItemRef,
          modelValue: (n.modelValue[d.name] || n.modelValue)[m.name],
          "onUpdate:modelValue": (p) => (n.modelValue[d.name] || n.modelValue)[m.name] = p
        }, m, {
          "form-model": n.modelValue,
          class: "j-form-builder__field",
          "onUpdate:modelValue": i.handleModelChange,
          onFormFieldValidity: (p) => i.handleFormFieldValidity(d.name, m.name, p)
        }), Y({ _: 2 }, [
          I(i.filterFieldSlots(m.name), (p, j) => ({
            name: p,
            fn: b((C) => [
              h(e.$slots, j, M(B(C)), void 0, !0)
            ])
          }))
        ]), 1040, ["modelValue", "onUpdate:modelValue", "form-model", "onFormFieldValidity"]),
        e.$slots[`${m.name}After`] ? (a(), o("div", {
          key: `${m.name}-slot`,
          class: "j-form-builder__slot"
        }, [
          h(e.$slots, `${m.name}After`, {}, void 0, !0)
        ])) : _("", !0)
      ], 64))), 128))
    ], 8, va))), 128)),
    e.$slots.formActions ? (a(), o("div", ja, [
      h(e.$slots, "formActions", {}, void 0, !0)
    ])) : _("", !0)
  ], 32);
}
const Bo = /* @__PURE__ */ y(ga, [["render", Sa], ["__scopeId", "data-v-3d3dcc5a"]]);
const ka = {
  name: "j-legend-item",
  props: {
    /**
     * Color for the legend item.
     */
    color: {
      type: String,
      default: null
    },
    /**
     * Label for the legend item, to be displayed next to color.
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Value for the legend item, to be displayed to the right of color and label.
     */
    value: {
      type: [Number, String],
      default: null
    },
    /**
     * Indicator that says does colored label should be rounded and how much.
     * Possible values are: 'none', 's', 'm', 'l', with 's' as default value.
     * If 'none' means square, if 'l' means circle.
     */
    colorRoundedSize: {
      type: String,
      default: "s",
      validator: (e) => ["none", "s", "m", "l"].includes(e)
    },
    /**
     * Indicator that specify the colored label size.
     * Possible values are: 'xxxs', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'.
     * Default value: 's'.
     */
    colorBlockSize: {
      type: String,
      default: "s",
      validator: (e) => ["xxxs", "xxs", "xs", "s", "m", "l", "xl", "xxl", "xxxl"].includes(e)
    }
  }
}, Ca = { class: "j-legend-item" }, wa = { class: "j-legend-item__colored-label" }, xa = { class: "j-legend-item__label" }, Ia = {
  key: 0,
  class: "j-legend-item__value"
};
function Ta(e, t, n, l, s, i) {
  return a(), o("div", Ca, [
    u("div", wa, [
      u("div", {
        class: v(["j-legend-item__color", `j-legend-item__color--rounded-${n.colorRoundedSize}`]),
        style: $([
          !!n.color && `--j-legend-item__color--background-color: ${n.color}`,
          `--j-legend-item__color--size: var(--j-spacing-${n.colorBlockSize})`
        ])
      }, null, 6),
      u("span", xa, S(n.label), 1)
    ]),
    n.value ? (a(), o("span", Ia, S(n.value), 1)) : _("", !0)
  ]);
}
const Da = /* @__PURE__ */ y(ka, [["render", Ta], ["__scopeId", "data-v-12fac607"]]);
const Va = {
  name: "j-legend",
  components: {
    "j-legend-item": Da
  },
  props: {
    /**
     * The array of items to be displayed as legend items. Each item should be an object which contains at least
     * color and label property. Each item is exposed as a scope slot to a parent so it's properties will be used there to render legend items propely.
     */
    items: {
      type: Array,
      required: !0
    },
    /**
     * Vertical spacing between legend items.
     */
    itemsSpacing: {
      type: String,
      default: "var(--j-spacing-m)"
    }
  }
}, Aa = { class: "j-legend" };
function $a(e, t, n, l, s, i) {
  const r = f("j-legend-item");
  return a(), o("ul", Aa, [
    (a(!0), o(w, null, I(n.items, (d, c) => (a(), o("li", {
      key: d.label,
      style: $({ marginTop: c > 0 && `${n.itemsSpacing}` })
    }, [
      h(e.$slots, "legend-item", M(B(d)), () => [
        g(r, {
          label: d.label,
          color: d.color,
          value: d.value
        }, null, 8, ["label", "color", "value"])
      ], !0)
    ], 4))), 128))
  ]);
}
const No = /* @__PURE__ */ y(Va, [["render", $a], ["__scopeId", "data-v-b8492017"]]);
const Ea = {
  name: "j-link",
  components: {
    "j-icon": E
  },
  props: {
    /**
     * URL property
     */
    href: {
      type: String,
      required: !0
    },
    /**
     * Should we force showing the external link icon? This might be useful
     * if navigating between separate apps on the same domain
     */
    isExternal: {
      type: Boolean,
      default: !1
    }
  }
}, Pa = ["href"];
function Ma(e, t, n, l, s, i) {
  const r = f("j-icon");
  return a(), o("a", {
    href: n.href,
    class: v(["j-link", { "j-link--external": n.isExternal }])
  }, [
    h(e.$slots, "default", {}, void 0, !0),
    g(r, {
      "icon-id": "icon-open-new",
      class: "j-link__icon"
    })
  ], 10, Pa);
}
const Lo = /* @__PURE__ */ y(Ea, [["render", Ma], ["__scopeId", "data-v-2e4efc3e"]]);
const Oa = {
  name: "j-logo",
  props: {
    /**
     * Should the logo be shown in its expanded state or not?
     */
    isExpanded: {
      type: Boolean,
      default: !0
    },
    /**
     * URL of an image to use when the logo is in its collapsed state
     */
    collapsedImg: {
      type: String,
      required: !0
    },
    /**
     * URL of an image to use when the logo is in its expanded state
     */
    expandedImg: {
      type: String,
      required: !0
    },
    /**
     * Text for screen readers to describe the logo (probably should be the name of the company)
     */
    logoAltText: {
      type: String,
      default: ""
    },
    /**
     * The root URL for the site, will enable the logo to be a link
     */
    href: {
      type: String
    }
  },
  computed: {
    tagName() {
      return this.href ? "a" : "div";
    }
  }
}, Ba = ["src", "alt"], Na = ["src", "alt"];
function La(e, t, n, l, s, i) {
  return a(), k(J(i.tagName), {
    class: "j-logo",
    href: n.href
  }, {
    default: b(() => [
      g(G, { name: "fade" }, {
        default: b(() => [
          D(u("img", {
            "data-testing-id": "logo-collapsed",
            src: n.collapsedImg,
            alt: n.logoAltText,
            class: "j-logo__image j-logo__image--collapsed"
          }, null, 8, Ba), [
            [O, !n.isExpanded]
          ])
        ]),
        _: 1
      }),
      g(G, { name: "fade" }, {
        default: b(() => [
          D(u("img", {
            "data-testing-id": "logo-expanded",
            src: n.expandedImg,
            alt: n.logoAltText,
            class: "j-logo__image j-logo__image--expanded"
          }, null, 8, Na), [
            [O, n.isExpanded]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["href"]);
}
const Ra = /* @__PURE__ */ y(Oa, [["render", La], ["__scopeId", "data-v-360e28c5"]]);
function za() {
  const t = {
    preventScroll: !1,
    trap: !1
  }, n = 'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let l, s, i, r, d;
  function c(A) {
    const N = A.querySelectorAll(n);
    i = N[0], r = N[N.length - 1];
  }
  function m(A) {
    if (A.keyCode !== 9)
      return;
    const N = document.activeElement === i, X = document.activeElement === r, Z = document.activeElement === l;
    A.shiftKey ? (N || Z) && (r.focus(), A.preventDefault()) : (X || Z) && (i.focus(), A.preventDefault());
  }
  function p() {
    c(l), l.addEventListener("keydown", m);
  }
  function j() {
    l.removeEventListener("keydown", m);
  }
  function C(A, N, X) {
    l = A, s = document.activeElement, d = X, l.focus(N), d && p();
  }
  function V() {
    d && j(), s && s.focus();
  }
  return {
    mounted(A, { modifiers: { preventScroll: N, trap: X } = t, value: Z }) {
      Z && C(A, { preventScroll: N }, X);
    },
    updated(A, { modifiers: { preventScroll: N, trap: X } = t, value: Z, oldValue: at }) {
      Z !== at && (Z ? C(A, { preventScroll: N }, X) : V());
    },
    unmounted(A, { value: N }) {
      N && V();
    }
  };
}
const Fa = {
  name: "j-modal",
  components: {
    "j-button": F
  },
  directives: {
    preventBodyScroll: Ke,
    clickAway: Q,
    focus: za
  },
  props: {
    /**
     * The title of the modal to display in the header
     */
    title: {
      type: String,
      default: null
    },
    /**
     * Positioning of the modal
     */
    position: {
      type: String,
      default: "center",
      validator: (e) => [
        "center",
        "top-center",
        "top-left",
        "top-right",
        "bottom-center",
        "bottom-left",
        "bottom-right"
      ].includes(e)
    },
    /**
     * The minimum width of the modal
     */
    minWidth: {
      type: String,
      default: "0rem"
    },
    /**
     * The maximum width of the modal
     */
    maxWidth: {
      type: String,
      default: "calc(var(--j-spacing-m) * 32)"
    },
    /**
     * The overflow-y of the modal body
     *
     * The main use case for this prop is to prevent a scroll bar from appearing when elements are absolutely positioned beyond the bottom of the modal body (for example the Jolt Select's OptionsPanel), by setting this prop to `"visible"`
     */
    bodyOverflowY: {
      type: String,
      default: "auto",
      validator: (e) => [
        "visible",
        "hidden",
        "clip",
        "scroll",
        "auto",
        "inherit",
        "initial",
        "revert",
        "unset"
      ].includes(e)
    },
    /**
     * Should the modal close if the user clicks outside it
     */
    closeOnOutsideClick: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    /**
     * Generates a random id to reuse in modal component.
     * @returns {string} id
     */
    componentId() {
      return ve();
    },
    hasHeader() {
      return this.title || this.$attrs.onClose;
    }
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeyboard);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.handleKeyboard);
  },
  methods: {
    /**
     * Handles keyboard Esc event on modal.
     * @param {event} event
     */
    handleKeyboard(e) {
      e.keyCode === 27 && this.close(e);
    },
    /**
     * Emitts close event, passing cosed closing event.
     * @param {Object} event
     */
    close(e) {
      this.$emit("close", e);
    }
  }
}, Ha = (e) => (me("data-v-5232a180"), e = e(), fe(), e), Wa = /* @__PURE__ */ Ha(() => /* @__PURE__ */ u("div", { class: "j-modal__overlay" }, null, -1)), Ua = ["aria-labelledby"], qa = ["id"], Ka = {
  key: 1,
  class: "j-modal__footer"
};
function Ga(e, t, n, l, s, i) {
  const r = f("j-button"), d = z("click-away"), c = z("focus"), m = z("prevent-body-scroll");
  return D((a(), o("div", {
    class: v(["j-modal", `j-modal--${n.position}`]),
    style: $({ "--modal-min-width": n.minWidth, "--modal-max-width": n.maxWidth })
  }, [
    Wa,
    D((a(), o("div", T(e.$attrs, {
      role: "dialog",
      "aria-modal": "true",
      tabindex: "-1",
      "aria-labelledby": `j-modal__title-${i.componentId}`,
      class: "j-modal__window"
    }), [
      i.hasHeader ? (a(), o("div", {
        key: 0,
        class: v(["j-modal__header", { "j-modal__header__empty": !n.title }])
      }, [
        n.title ? (a(), o("h4", {
          key: 0,
          id: `j-modal__title-${i.componentId}`,
          class: "j-modal__title"
        }, S(n.title), 9, qa)) : _("", !0),
        e.$attrs.onClose ? (a(), k(r, {
          key: 1,
          "content-type": "icon-only",
          "icon-id": "icon-delete",
          variant: "tertiary",
          class: "j-modal__close-button",
          "aria-label": "close",
          onClick: i.close
        }, null, 8, ["onClick"])) : _("", !0)
      ], 2)) : _("", !0),
      u("div", {
        class: "j-modal__body",
        style: $({ "--modal-body-overflow-y": n.bodyOverflowY })
      }, [
        h(e.$slots, "default", {}, void 0, !0)
      ], 4),
      e.$slots.footer ? (a(), o("div", Ka, [
        h(e.$slots, "footer", {}, void 0, !0)
      ])) : _("", !0)
    ], 16, Ua)), [
      [d, n.closeOnOutsideClick ? i.close : null],
      [
        c,
        !0,
        void 0,
        { trap: !0 }
      ]
    ])
  ], 6)), [
    [m, !0]
  ]);
}
const Ro = /* @__PURE__ */ y(Fa, [["render", Ga], ["__scopeId", "data-v-5232a180"]]);
const Ya = {
  name: "j-primary-nav",
  components: {
    "j-logo": Ra,
    "j-primary-nav-expandable-sections": qe
  },
  directives: {
    clickAway: Q
  },
  props: {
    /**
     * Should the primary navigation be collapsible? If it is, navigation items will collapse down to
     * show just their icons and the navigation will expand on hover/focus.
     */
    isCollapsible: {
      type: Boolean,
      default: !1
    },
    /**
     * A list of navigation section objects. Each section should contain
     *      items: A list of naviagtion items
     *      header (optional): The string
     */
    sections: {
      type: Array,
      default: () => []
    },
    /**
     * Items (deprecated) Use sections instead and pass the items into a section object
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * The URL for the image to use as the collapsed version of the logo
     */
    logoCollapsed: {
      type: String,
      default: void 0
    },
    /**
     * The URL for the image to use as the expanded version of the logo
     */
    logoExpanded: {
      type: String,
      default: void 0
    },
    /**
     * The root URL for the site. This is used as the URL on the logo
     */
    rootUrl: {
      type: String,
      default: void 0
    },
    /**
     * The logo alt text
     */
    logoAltText: {
      type: String,
      default: void 0
    },
    /**
     * The z-index to apply to the nav. Default is 10
     */
    zIndex: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      // If the nav is collapsible, start it collapsed. If it isn't, start it open
      navExpanded: !this.isCollapsible,
      hasScrolled: !1
    };
  },
  computed: {
    allSections() {
      return this.sections.length > 0 ? this.sections : this.items ? [{ items: this.items }] : [];
    }
  },
  watch: {
    isCollapsible(e) {
      this.navExpanded = !e;
    }
  },
  mounted() {
    this.$refs.navWrapper.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    this.$refs.navWrapper.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleClickAway() {
      this.isCollapsible && this.collapseNav();
    },
    expandNav() {
      this.navExpanded = !0;
    },
    collapseNav() {
      this.navExpanded = !1;
    },
    handleScroll(e) {
      this.hasScrolled = e.target.scrollTop > 5;
    }
  }
}, Xa = {
  key: 0,
  class: "j-primary-nav__logo-wrapper"
}, Za = {
  ref: "navWrapper",
  class: "j-primary-nav__nav-wrapper"
};
function Ja(e, t, n, l, s, i) {
  const r = f("j-logo"), d = f("j-primary-nav-expandable-sections"), c = z("click-away");
  return D((a(), o("div", T({
    class: ["j-primary-nav", {
      "j-primary-nav--collapsible": n.isCollapsible,
      "j-primary-nav--scrolled": s.hasScrolled
    }]
  }, rt(n.isCollapsible ? { mouseenter: i.expandNav, mouseleave: i.collapseNav } : {}, !0)), [
    u("header", {
      class: "j-primary-nav__panel",
      style: $({ "--primary-nav-z-index": n.zIndex })
    }, [
      n.logoExpanded && n.logoCollapsed ? (a(), o("div", Xa, [
        g(r, {
          "is-expanded": s.navExpanded,
          "collapsed-img": n.logoCollapsed,
          "expanded-img": n.logoExpanded,
          href: n.rootUrl,
          "logo-alt-text": n.logoAltText,
          class: "j-primary-nav__logo"
        }, null, 8, ["is-expanded", "collapsed-img", "expanded-img", "href", "logo-alt-text"])
      ])) : _("", !0),
      u("div", Za, [
        g(d, {
          sections: i.allSections,
          "nav-expanded": s.navExpanded
        }, {
          link: b(({ data: { item: m, classes: p, isVisible: j } }) => [
            h(e.$slots, "link", {
              data: {
                item: m,
                classes: p,
                isVisible: j,
                navExpanded: s.navExpanded,
                expandNav: i.expandNav,
                collapseNav: i.collapseNav
              }
            }, void 0, !0)
          ]),
          _: 3
        }, 8, ["sections", "nav-expanded"])
      ], 512),
      h(e.$slots, "default", {}, void 0, !0)
    ], 4)
  ], 16)), [
    [c, i.handleClickAway]
  ]);
}
const Qa = /* @__PURE__ */ y(Ya, [["render", Ja], ["__scopeId", "data-v-26a06451"]]);
const el = {
  name: "j-navigation",
  components: {
    "j-auxiliary-nav": un,
    "j-primary-nav": Qa
  },
  props: {
    /**
     * Should the primary navigation be collapsible? If it is, navigation items will collapse down to
     * show just their icons and the navigation will expand on hover/focus.
     */
    isCollapsible: {
      type: Boolean,
      default: !1
    },
    /**
     * Should the navigation be shown in small device mode
     */
    isSmall: {
      type: Boolean,
      default: !1
    },
    /**
     * A list of navigation section objects. Each section should contain
     *      items: A list of naviagtion items
     *      header (optional): The string
     */
    sections: {
      type: Array,
      default: () => []
    },
    /**
     * The URL for the image to use as the collapsed version of the logo
     */
    logoCollapsed: {
      type: String,
      default: null
    },
    /**
     * The URL for the image to use as the expanded version of the logo
     */
    logoExpanded: {
      type: String,
      default: null
    },
    /**
     * The root URL for the site. This is used as the URL on the logo
     */
    rootUrl: {
      type: String,
      default: void 0
    },
    /**
     * Configuration to be bound to the AuxiliaryNav. 3 props will automatically be passed to the AuxiliaryNav:
     *  - isSmall
     *  - logo
     *  - primaryNavSections
     *
     * See the props of the AuxiliaryNav component for full details on all of the other props that can be passed.
     *  */
    auxiliaryNavConfig: {
      type: Object,
      default: null
    },
    /**
     * The z-index to apply to the primary nav. Default is 10
     */
    primaryNavZIndex: {
      type: Number,
      default: 10
    },
    /**
     * The classes to add to the main element
     */
    mainElClasses: {
      type: String,
      default: null
    },
    /**
     * The alt text for the logo
     */
    logoAltText: {
      type: String,
      default: void 0
    }
  }
}, tl = { class: "j-navigation" };
function nl(e, t, n, l, s, i) {
  const r = f("j-primary-nav"), d = f("j-auxiliary-nav");
  return a(), o("div", tl, [
    n.isSmall ? _("", !0) : (a(), k(r, {
      key: 0,
      "is-collapsible": n.isCollapsible,
      sections: n.sections,
      "logo-collapsed": n.logoCollapsed,
      "logo-expanded": n.logoExpanded,
      "root-url": n.rootUrl,
      "z-index": n.primaryNavZIndex,
      "logo-alt-text": n.logoAltText
    }, {
      link: b(({ data: { item: c, classes: m, isVisible: p, navExpanded: j, expandNav: C, collapseNav: V } }) => [
        h(e.$slots, "primaryNavLink", {
          data: { item: c, classes: m, isVisible: p, navExpanded: j, expandNav: C, collapseNav: V }
        }, void 0, !0)
      ]),
      default: b(() => [
        h(e.$slots, "primaryNavExtraContent", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["is-collapsible", "sections", "logo-collapsed", "logo-expanded", "root-url", "z-index", "logo-alt-text"])),
    e.$slots.main ? h(e.$slots, "main", { key: 1 }, void 0, !0) : (a(), o("main", {
      key: 2,
      class: v(n.mainElClasses)
    }, [
      g(d, T({
        "is-small": n.isSmall,
        logo: n.logoCollapsed,
        "primary-nav-sections": n.sections
      }, n.auxiliaryNavConfig), {
        auxiliaryNavLink: b(({ data: { item: c, classes: m, isVisible: p, hideSmallNav: j } }) => [
          h(e.$slots, "auxiliaryNavLink", {
            data: { item: c, classes: m, isVisible: p, hideSmallNav: j }
          }, void 0, !0)
        ]),
        auxiliaryNavProfileMenuLink: b(({ data: { item: c, classes: m, hideSmallNav: p } }) => [
          h(e.$slots, "auxiliaryNavProfileMenuLink", {
            data: { item: c, classes: m, hideSmallNav: p }
          }, void 0, !0)
        ]),
        smallNavExtraContent: b(() => [
          h(e.$slots, "smallNavExtraContent", {}, void 0, !0)
        ]),
        _: 3
      }, 16, ["is-small", "logo", "primary-nav-sections"]),
      h(e.$slots, "default", {}, void 0, !0)
    ], 2))
  ]);
}
const zo = /* @__PURE__ */ y(el, [["render", nl], ["__scopeId", "data-v-21296096"]]);
const il = {
  name: "j-side-panel-header",
  components: {
    "j-button": F
  },
  props: {
    /**
     * The title of the sidepanel
     */
    title: {
      type: String,
      required: !0
    },
    /**
     * Does the current sidepanel require a back button? If the back button is displayed
     * Clicks on it will emit the 'back' event
     */
    hasBackButton: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    closePanel() {
      this.$emit("close");
    },
    goBack() {
      this.$emit("back");
    }
  }
}, sl = { class: "j-side-panel-header" }, al = { class: "j-side-panel-header__primary" }, ll = { class: "j-side-panel-header__content" }, ol = { class: "j-side-panel-header__title" }, rl = { key: 0 }, dl = { class: "j-side-panel-header__secondary" }, cl = { class: "j-side-panel-header__icons" };
function ul(e, t, n, l, s, i) {
  const r = f("j-button");
  return a(), o("div", sl, [
    u("div", al, [
      n.hasBackButton ? (a(), k(r, {
        key: 0,
        "content-type": "icon-only",
        "icon-id": "icon-back",
        variant: "tertiary",
        class: "j-side-panel-header__icon",
        onClick: L(i.goBack, ["stop"])
      }, null, 8, ["onClick"])) : _("", !0),
      u("div", ll, [
        u("h3", ol, S(n.title), 1),
        e.$slots.extraHeaderContent ? (a(), o("div", rl, [
          u("div", dl, [
            h(e.$slots, "extraHeaderContent", {}, void 0, !0)
          ])
        ])) : _("", !0)
      ]),
      u("div", cl, [
        h(e.$slots, "icons", {}, void 0, !0),
        g(r, {
          "content-type": "icon-only",
          "icon-id": "icon-delete",
          variant: "tertiary",
          class: "j-side-panel-header__icon",
          onClick: i.closePanel
        }, null, 8, ["onClick"])
      ])
    ])
  ]);
}
const hl = /* @__PURE__ */ y(il, [["render", ul], ["__scopeId", "data-v-4f6a89b7"]]);
const pl = /^(((var|calc|min|max|clamp|fit-content)\(.*\))|(((\d+)(rem|em|%|vw|px))|max-content|min-content|auto|none))$/, he = (e) => pl.test(e), _l = {
  name: "j-slider",
  props: {
    /**
     * Boolean to set the slider visibility.
     * Its default value is `false`
     */
    visible: {
      type: Boolean,
      default: !1
    },
    /**
     * String to define where the slider slides into the screen from.
     * Possible values are left and right, with right as default value.
     */
    location: {
      type: String,
      default: "right",
      validator: (e) => ["left", "right"].includes(e)
    },
    /**
     * String containing the `width` that the slider will have. This can be anything that can be interpreted
     * as a valid css width, e.g. values in px, rem, expressions with calc, var, max, min etc.
     * Default value is `auto`.
     */
    width: {
      type: String,
      default: "auto",
      validator: he
    },
    /**
     * String containing the `min-width` that the slider will have. This can be anything that can be interpreted
     * as a valid css width, e.g. values in px, rem, expressions with calc, var, max, min etc.
     * Default value is `none`.
     */
    minWidth: {
      type: String,
      default: "none",
      validator: he
    },
    /**
     * String containing the `max-width` that the slider will have. This can be anything that can be interpreted
     * as a valid css width, e.g. values in px, rem, expressions with calc, var, max, min etc.
     * Default value is `none`.
     */
    maxWidth: {
      type: String,
      default: "none",
      validator: he
    },
    /**
     * String containing the transition timing function to be applied.
     * Default value is `ease`
     */
    transitionFunction: {
      type: String,
      default: "ease"
    },
    /**
     * Number representing the time the slide in/out transition takes to complete in seconds.
     * Default value is 0.16
     */
    transitionDuration: {
      type: Number,
      default: 0.16
    },
    /**
     * Number representing the time the width transition takes to complete in seconds.
     * Default value is 0
     */
    widthTransitionDuration: {
      type: Number,
      default: 0
    },
    /**
     * String to define the shadow's size that the slider shows.
     * Possible values are `s`, `m` and `none` - if no shadow has to be applied, with `s` as default value.
     */
    shadowSize: {
      type: String,
      default: "s",
      validator: (e) => ["s", "m", "none"].includes(e)
    },
    /**
     * Should the slider use CSS fixed positioning? Defaults to false, which uses CSS absolute positioning
     */
    useFixedPosition: {
      type: Boolean,
      default: !1
    },
    /**
     * The z-index to apply to the slider. Default is 1
     */
    zIndex: {
      type: Number,
      default: 1
    }
  },
  methods: {
    onSlideOutDone(e) {
      this.$emit("slide-out-done", e);
    }
  }
}, ml = ["aria-expanded"];
function fl(e, t, n, l, s, i) {
  return a(), k(G, {
    name: "slider",
    onAfterLeave: i.onSlideOutDone
  }, {
    default: b(() => [
      D(u("aside", {
        ref: "sliderEl",
        class: v(["j-slider", [
          `j-slider--${n.location}`,
          `j-slider--shadow-${n.shadowSize}`,
          n.widthTransitionDuration > 0 ? "j-slider--animate-width" : null,
          n.useFixedPosition ? "j-slider--position-fixed" : null
        ]]),
        style: $({
          "--slider-width": n.width,
          "--slider-min-width": n.minWidth,
          "--slider-max-width": n.maxWidth,
          "--slider-transition-function": n.transitionFunction,
          "--slider-transition-duration": `${n.transitionDuration}s`,
          "--slider-width-transition-duration": `${n.widthTransitionDuration}s`,
          "--slider-z-index": n.zIndex
        }),
        "aria-expanded": n.visible
      }, [
        h(e.$slots, "default", {}, void 0, !0)
      ], 14, ml), [
        [O, n.visible]
      ])
    ]),
    _: 3
  }, 8, ["onAfterLeave"]);
}
const yl = /* @__PURE__ */ y(_l, [["render", fl], ["__scopeId", "data-v-f1e52a93"]]);
const gl = {
  name: "j-side-panel",
  components: {
    "j-side-panel-header": hl,
    "j-slider": yl
  },
  directives: {
    clickAway: Q
  },
  props: {
    /**
     * Should the sidepanel be shown?
     */
    isVisible: {
      type: Boolean,
      default: !1
    },
    /**
     * The title of the sidepanel
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * The size (width) of the sidepanel. Should be one of 'regular' or 'large'
     */
    size: {
      type: String,
      default: "regular",
      validator: (e) => ["regular", "large"].includes(e)
    },
    /**
     * Does the current sidepanel require a back button? If the back button is displayed
     * Clicks on it will emit the 'back' event
     */
    hasBackButton: {
      type: Boolean,
      default: !1
    },
    /**
     * The z-index to apply to the slider. Default is 20
     */
    zIndex: {
      type: Number,
      default: 20
    },
    isRelativelyPositioned: {
      type: Boolean,
      default: !1
    },
    sliderConfiguration: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      currentSize: this.size,
      isChangingSize: !1,
      widthTransitionDuration: 0
    };
  },
  computed: {
    panelWidthProperties() {
      return this.sliderConfiguration ? this.sliderConfiguration : this.currentSize === "large" ? {
        width: "60vw",
        "max-width": "min(100%, calc(100 * var(--spacing-m)))",
        "min-width": "min(100%, calc(56 * var(--spacing-m)))"
      } : {
        width: "32vw",
        "max-width": "min(100%, calc(34 * var(--spacing-m)))",
        "min-width": "min(100%, calc(30 * var(--spacing-m)))"
      };
    }
  },
  watch: {
    isVisible(e) {
      e ? document.addEventListener("keydown", this.handleKeyboard) : document.removeEventListener("keydown", this.handleKeyboard);
    },
    size(e) {
      this.isVisible ? (this.widthTransitionDuration = 0.3, this.isChangingSize = !0) : this.currentSize = e;
    }
  },
  created() {
    this.isVisible && document.addEventListener("keydown", this.handleKeyboard);
  },
  mounted() {
    this.$refs.sliderEl.$el.addEventListener("transitionend", this.onTransitionEnd);
  },
  beforeUnmount() {
    this.$refs.sliderEl.$el.removeEventListener("transitionend", this.onTransitionEnd), this.isVisible && document.removeEventListener("keydown", this.handleKeyboard);
  },
  methods: {
    handleKeyboard(e) {
      e.keyCode === 27 && this.closePanel();
    },
    handleClickAway() {
      this.isVisible && this.closePanel();
    },
    onContentVisibilityChange() {
      this.$nextTick(() => this.currentSize = this.size), this.$refs.contentEl.scrollTop = 0;
    },
    onTransitionEnd(e) {
      e.target === this.$refs.sliderEl.$el && e.propertyName === "width" && (this.isChangingSize = !1, this.widthTransitionDuration = 0);
    },
    closePanel() {
      this.$emit("close");
    },
    goBack() {
      this.$emit("back");
    },
    onSlideOutDone(e) {
      this.$emit("slide-out-done", e);
    }
  }
}, vl = { class: "j-side-panel" }, bl = {
  ref: "contentEl",
  class: "j-side-panel__content"
};
function jl(e, t, n, l, s, i) {
  const r = f("j-side-panel-header"), d = f("j-slider"), c = z("click-away");
  return D((a(), k(d, T({ ref: "sliderEl" }, i.panelWidthProperties, {
    visible: n.isVisible,
    "use-fixed-position": !n.isRelativelyPositioned,
    "transition-duration": 0.24,
    "width-transition-duration": s.widthTransitionDuration,
    "z-index": n.zIndex,
    class: { "j-side-panel--changing-size": s.isChangingSize },
    onSlideOutDone: i.onSlideOutDone
  }), {
    default: b(() => [
      u("div", vl, [
        h(e.$slots, "header", {}, () => [
          g(r, {
            title: n.title,
            "has-back-button": n.hasBackButton,
            onClose: i.closePanel,
            onBack: i.goBack
          }, Y({ _: 2 }, [
            e.$slots.extraHeaderContent ? {
              name: "extraHeaderContent",
              fn: b(() => [
                h(e.$slots, "extraHeaderContent", {}, void 0, !0)
              ]),
              key: "0"
            } : void 0,
            e.$slots.icons ? {
              name: "icons",
              fn: b(() => [
                h(e.$slots, "icons", {}, void 0, !0)
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["title", "has-back-button", "onClose", "onBack"])
        ], !0),
        u("div", bl, [
          g(G, {
            name: "fade-content",
            mode: "out-in",
            onAfterLeave: i.onContentVisibilityChange
          }, {
            default: b(() => [
              h(e.$slots, "default", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["onAfterLeave"])
        ], 512)
      ])
    ]),
    _: 3
  }, 16, ["visible", "use-fixed-position", "width-transition-duration", "z-index", "class", "onSlideOutDone"])), [
    [c, i.handleClickAway]
  ]);
}
const Fo = /* @__PURE__ */ y(gl, [["render", jl], ["__scopeId", "data-v-aa8eca2f"]]);
const Sl = {
  inject: ["registerTab"],
  props: {
    /**
     * Tab identifier, if provided it is used as tab's uniqueid
     */
    id: {
      type: String,
      default: null
    },
    /**
     * Name of the tab to display in the tab list, if no Id have been provided then the name will be normalized and use as tab's uniqueid.
     * This field is required
     */
    name: {
      type: String,
      default: null,
      required: !0
    },
    /**
     * Specify if the tab should be disabled
     */
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      active: !1
    };
  },
  computed: {
    /**
     * Uniqueid generated using the Id if provided, otherwise the name of the tab is normalized an used.
     * @returns {string} uniqueid
     */
    uniqueid() {
      var e;
      return this.id || ((e = this.name) == null ? void 0 : e.toLowerCase().replace(/\s/g, "-"));
    },
    /**
     * Hash the uniqueid computed property as route to the tab
     * @returns {string} hash
     */
    hash() {
      return this.disabled ? "#" : `#${this.uniqueid}`;
    }
  },
  created() {
    this.registerTab(this);
  },
  methods: {
    /**
     * Set the tab as active
     * @param {boolean} active
     */
    setActive(e) {
      this.active = e;
    },
    focus() {
      this.$refs.tabPanel.focus();
    }
  }
}, kl = ["id", "aria-hidden", "aria-labelledby", "tabindex"];
function Cl(e, t, n, l, s, i) {
  return D((a(), o("section", {
    id: i.uniqueid,
    ref: "tabPanel",
    "aria-hidden": !s.active,
    "aria-labelledby": n.name,
    tabindex: s.active ? 0 : -1,
    role: "tabpanel",
    class: "j-tab-panel"
  }, [
    h(e.$slots, "default")
  ], 8, kl)), [
    [O, s.active]
  ]);
}
const Ho = /* @__PURE__ */ y(Sl, [["render", Cl]]);
const wl = 2, ae = {
  ASC: "asc",
  DESC: "desc"
}, xl = {
  name: "j-table",
  components: {
    "j-icon": E,
    "j-actions-group": zt
  },
  props: {
    /**
     * An object containing configuration for the table's columns. This can have the following options:
     *
     * - label: The text to display for the column header
     *
     * - minWidth (default = 2):
     *          The minimum width this column should have. This should be a number which will be
     *          multiplied by --j-spacing-m to generate the minWidth
     *
     * - maxWidth:
     *          The maximum width this column should have. This should be a number which will be
     *          multiplied by --j-spacing-m to generate the maxWidth
     *
     * - canGrow (default = true): Can this column grow to be wider than its minWidth?
     *
     * - shouldTruncate (default = false):
     *          Should this cell be truncated if it would exceed its width, rather than
     *          wrapping onto multiple lines?
     *
     * - priority (optional):
     *          The importance of the column. This is used in determining which columns to hide if
     *          there isn't enough horizontal space to show the full table. It follows the following rules:
     *          A column with no priority provided will never be hidden. The lower the number the higher
     *          priority, so a column with priority 1 will be visible at smaller screen sizes than a column
     *          with priority 2. If 2 columns have the same priority they will both be hidden at the same time
     *          If there isn't enough space to show all the items, and no items can be hidden, the table
     *          will allow horizontal scrolling
     */
    columns: {
      type: Array,
      required: !0
    },
    /**
     * An array of Objects each representing a row in the table. Options for each row are:
     *
     * - `cells`:
     *          An array of the column data contained in this row. This can either be strings or objects.
     *          If it's strings, the string will be automatically rendered in a table cell. If they're
     *          objects, a slot will be created and the object will be passed back to the slot. This can be
     *          used for rendering more complex cells.
     *
     * - `href`: If the row should link somewhere, this should contain the URL that it should link to
     *
     * - `target` (default = `'_self'`):
     *          To be used in conjuntion with href. If linking, this represents the target of the link.
     *          Any valid target is ok, e.g. '_blank' to open the link in a new tab
     *
     * - `isSelected` (deault = `false`): Is the row selected? Renders a bar on the LHS to show this if it is.
     *
     * - `actions`: An array of actions over the row which are rendered in the last column as an actions group. Entries should each be an `object`. The following properties are supported, all of which are optional:
     *     - `url` ~ `string`: If provided, the list item will contain an `a` linking to the given url. If omitted, the list item will contain a button.
     *     - `isExternal` ~ `boolean`: If `url` is set and this prop is set to `true`, clicking it will open the given URL in a new tab.
     *     - `disabled` ~ `boolean`: If set to  `true`, the button will be disabled.
     *     - `icon` ~ `string`: If provided, the list item will show the given icon before the label.
     *     - `iconClasses` ~ `string` | `Array`: If provided, the one or more given CSS classes will be applied to the icon.
     *     - `label` ~ `string`: If provided, the list item will contain this label.
     *     - `onClick` ~ `function`: If provided, clicking the button will trigger a call to the given function. The first argument will be the `action` object and the second will be the `$event` object.
     *     - `tooltip` ~ `string`: If provided, hovering over the action icon will cause a tooltip to show with the given content. (It will be rendered into a slot)
     */
    rows: {
      type: Array,
      required: !0
    },
    /**
     * Should the rows have hover states indicating that you can interact with them. You might want this if you're
     * using the slot to render an <a> or a custom component like a <router-link> in your rows
     */
    interactiveRows: {
      type: Boolean,
      default: !1
    },
    /**
     * Should the table body pass under the header on scrolling? Please note, setting this prop to true won't necessarily
     * make this happen by magic - you might also need to make sure that your table has a fixed height.
     */
    stickyHeader: {
      type: Boolean,
      default: !1
    },
    /**
     * visibleRowActions: number representing the default actions visible in the cell, the rest will be rendered as part of the action panel
     */
    visibleRowActions: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      sortedColumnIndex: void 0,
      sortedColumnOrder: void 0,
      resizeObserver: null,
      width: null,
      mediumSpacingInPx: 16,
      // this is the default but we calculate it on mount
      hiddenColumns: []
    };
  },
  computed: {
    columnStyles() {
      return this.columns.map(({ minWidth: e = wl, maxWidth: t }) => {
        let n = `--j-table-column-min-width: ${e};`;
        return t && (n += ` max-width: calc(${t} * var(--j-spacing-m));`), n;
      });
    },
    columnClasses() {
      return this.columns.map(({ shouldTruncate: e = !1, canGrow: t = !0 }, n) => ({
        "j-table__column": !0,
        "j-table__column--truncate": e,
        "j-table__column--grow": t,
        "j-table__column--hidden": this.hiddenColumns.includes(n)
      }));
    },
    processedRows() {
      return this.rows.map((e, t) => ({
        row: e,
        rowClasses: {
          "j-table__row j-table__row--body": !0,
          "j-table__row--interactive": this.$attrs["onRow-clicked"] || this.interactiveRows,
          "j-table__row--selected": e.isSelected
        },
        tabindex: this.$attrs["row-clicked"] ? 0 : null,
        onClick: (n) => this.$emit("row-clicked", t, n)
      }));
    },
    columnsMergedByPriority() {
      const e = [];
      return this.columns.forEach((t) => {
        const n = e.find((l) => l.priority === t.priority);
        n ? n.minWidth += t.minWidth : e.push({ ...t });
      }), e.sort(Vt("priority")), e;
    },
    /*
     * Work out the widths at which we should hide various columns
     */
    responsiveWidths() {
      if (this.columnsMergedByPriority.length < 2)
        return [];
      const e = [];
      let t = this.spacingToPx(this.columnsMergedByPriority[0].minWidth + this.actionsColumnWidth);
      for (let n = 1; n < this.columnsMergedByPriority.length; n += 1)
        t += this.spacingToPx(this.columnsMergedByPriority[n].minWidth), e.push({ width: t, hidePriority: this.columnsMergedByPriority[n].priority });
      return e;
    },
    tableMinWidth() {
      var e, t;
      return ((t = (e = this.columnsMergedByPriority) == null ? void 0 : e[0]) == null ? void 0 : t.minWidth) || 0;
    },
    visibleColumns() {
      return this.columns.filter((e, t) => !this.hiddenColumns.includes(t));
    },
    maxActionsInRow() {
      return this.rows.reduce(
        (e, { actions: t = [] }) => Math.max(t == null ? void 0 : t.length, e),
        0
      );
    },
    maxVisibleRowActions() {
      return Math.min(this.maxActionsInRow, this.visibleRowActions);
    },
    withRowActions() {
      return this.maxActionsInRow > 0;
    },
    actionsColumnWidth() {
      return this.withRowActions ? this.hiddenColumns.length > 0 || this.maxVisibleRowActions === 0 ? 1 : this.maxVisibleRowActions === this.maxActionsInRow ? this.maxVisibleRowActions : this.maxVisibleRowActions + 1 : 0;
    },
    hasRowScopedSlot() {
      return this != null && this.$slots ? "row" in this.$slots : !1;
    }
  },
  watch: {
    width: "onResize"
  },
  mounted() {
    this.getMediumSpacingInPx(), this.resizeObserver = new ResizeObserver((e) => {
      const [t] = e;
      this.width = Math.round(t.contentRect.width);
    }), this.resizeObserver.observe(this.$refs.wrapperEl);
  },
  beforeUnmount() {
    this.resizeObserver.disconnect();
  },
  created() {
    const e = this.columns.findIndex((t) => t.sortOrder);
    e >= 0 && (this.sortedColumnIndex = e, this.sortedColumnOrder = this.columns[e].sortOrder);
  },
  methods: {
    sort(e) {
      this.sortedColumnIndex === e ? this.sortedColumnOrder = this.sortedColumnOrder === ae.ASC ? ae.DESC : ae.ASC : (this.sortedColumnIndex = e, this.sortedColumnOrder = ae.ASC), this.$emit("sort", {
        name: this.columns[e].sortableName,
        order: this.sortedColumnOrder
      }), this.$refs.tableEl.scrollTop > 0 && (this.$refs.tableEl.scrollTop = 0);
    },
    onResize(e) {
      const [t] = this.responsiveWidths.filter(({ width: l }) => l > e).map((l) => l.hidePriority);
      if (t === void 0) {
        this.hiddenColumns.length > 0 && (this.hiddenColumns = []);
        return;
      }
      const n = this.columns.map((l, s) => ({
        ...l,
        index: s
      })).filter((l) => l.priority && l.priority >= t).map((l) => l.index);
      n.length !== this.hiddenColumns.length && (this.hiddenColumns = n);
    },
    getMediumSpacingInPx() {
      const e = document.createElement("div");
      Object.assign(e.style, {
        // Absolute positioning to free element for resizing and avoid potential jumps/jank
        position: "absolute",
        width: "var(--spacing-m)"
      }), document.body.appendChild(e), this.mediumSpacingInPx = e.offsetWidth, document.body.removeChild(e);
    },
    spacingToPx(e) {
      return e * this.mediumSpacingInPx;
    },
    slotExists(e) {
      return `cell-${e + 1}` in this.$slots;
    }
  }
}, Il = {
  class: "j-table__row j-table__row--header",
  role: "row"
}, Tl = ["onClick"], Dl = {
  key: 0,
  class: "j-table__actions-column",
  role: "columnheader"
}, Vl = ["data-qa"], Al = ["tabindex", "onClick"], $l = {
  key: 0,
  class: "j-table__actions-column"
};
function El(e, t, n, l, s, i) {
  const r = f("j-icon"), d = f("j-actions-group");
  return a(), o("div", {
    ref: "wrapperEl",
    class: v(["j-table-wrapper", { "j-table--sticky-header": n.stickyHeader }]),
    style: $(`--j-table-min-width: calc(${i.tableMinWidth} * var(--j-spacing-m))`)
  }, [
    u("ul", {
      ref: "tableEl",
      class: "j-table",
      role: "table",
      style: $(`--j-table-actions-column-max-width: ${i.actionsColumnWidth}`)
    }, [
      u("li", Il, [
        (a(!0), o(w, null, I(n.columns, (c, m) => (a(), o("div", {
          key: m,
          class: v(["j-table__column--header", i.columnClasses[m]]),
          style: $(i.columnStyles[m]),
          role: "columnheader"
        }, [
          c.sortableName ? (a(), o("button", {
            key: 0,
            class: v(["j-table__sort-button", { "j-table__sort-button--active": s.sortedColumnIndex === m }]),
            onClick: (p) => i.sort(m)
          }, [
            P(S(c.label) + " ", 1),
            g(r, {
              "icon-id": s.sortedColumnIndex !== m ? "icon-sortable" : "icon-sorted",
              class: v(["j-table__sort-icon", {
                "j-table__sort-icon--inactive": s.sortedColumnIndex !== m,
                "j-table__sort-icon--asc": s.sortedColumnIndex === m && s.sortedColumnOrder === "asc",
                "j-table__sort-icon--desc": s.sortedColumnIndex === m && s.sortedColumnOrder === "desc"
              }])
            }, null, 8, ["icon-id", "class"])
          ], 10, Tl)) : (a(), o(w, { key: 1 }, [
            P(S(c.label), 1)
          ], 64))
        ], 6))), 128)),
        i.withRowActions ? (a(), o("div", Dl)) : _("", !0)
      ]),
      (a(!0), o(w, null, I(i.processedRows, ({ row: c, rowClasses: m, tabindex: p, onClick: j }, C) => (a(), o("li", {
        key: c.id || C,
        "data-qa": c.id || C,
        class: "j-table__row-wrapper",
        role: "row"
      }, [
        i.hasRowScopedSlot ? h(e.$slots, "row", {
          key: 1,
          data: {
            row: c,
            rowClasses: m,
            columnClasses: i.columnClasses,
            columnStyles: i.columnStyles,
            tabindex: p,
            onClick: j
          }
        }, void 0, !0) : (a(), o("div", {
          key: 0,
          class: v(m),
          tabindex: p,
          onClick: j
        }, [
          (a(!0), o(w, null, I(c.cells, (V, A) => (a(), o("div", {
            key: A,
            class: v(i.columnClasses[A]),
            style: $(i.columnStyles[A]),
            role: "cell"
          }, [
            i.slotExists(A) ? h(e.$slots, `cell-${A + 1}`, {
              key: 0,
              cell: V
            }, void 0, !0) : (a(), o(w, { key: 1 }, [
              P(S(V), 1)
            ], 64))
          ], 6))), 128)),
          i.withRowActions ? (a(), o("div", $l, [
            c.actions ? (a(), k(d, {
              key: 0,
              class: "j-table__actions-group",
              actions: c.actions,
              "max-visible-actions": i.maxVisibleRowActions
            }, null, 8, ["actions", "max-visible-actions"])) : _("", !0)
          ])) : _("", !0)
        ], 10, Al))
      ], 8, Vl))), 128))
    ], 4)
  ], 6);
}
const Wo = /* @__PURE__ */ y(xl, [["render", El], ["__scopeId", "data-v-dcdf4de0"]]);
const Pl = {
  components: {
    "j-select": st
  },
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    parentActiveTab: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visibleTabsCount: 0,
      activeTab: null,
      isDropdownPanelOpen: !1,
      tabListRefs: [],
      isMobile: !1
    };
  },
  computed: {
    mobileTabs() {
      if (!this.isMobile)
        return !1;
      const e = this.findActiveTab(), t = this.tabs.map((n) => ({ name: n.name, value: n.hash }));
      return {
        active: e == null ? void 0 : e.hash,
        options: t
      };
    }
  },
  created() {
    this.isMobile = window.innerWidth <= 640, setTimeout(() => {
      if (this.parentActiveTab) {
        const e = this.findTabByHash(this.parentActiveTab);
        this.onSelectTab(e);
      }
    }, 200);
  },
  mounted() {
    this.activeTab || this.onSelectTab(this.tabs[0]);
  },
  methods: {
    findActiveTab() {
      return this.tabs.find((e) => e.active);
    },
    findTabByHash(e) {
      return this.tabs.find(({ hash: t }) => t === e);
    },
    findTabIndex(e) {
      return this.tabs.findIndex(({ hash: t }) => t === e.hash);
    },
    focusTab(e) {
      e < 0 || (e >= this.tabListRefs.length ? this.$refs.moreTabs.$el.firstChild.focus() : this.tabListRefs[e].focus());
    },
    onSelectTab(e, t) {
      if (e.disabled) {
        t == null || t.preventDefault();
        return;
      }
      this.activeTab = e, this.$emit("select", e);
    },
    onSelectOption(e) {
      const t = this.findTabByHash(e);
      t && this.onSelectTab(t);
    },
    onDropdownPanelToggled(e) {
      this.isDropdownPanelOpen = e;
    },
    setItemRef(e) {
      e && !this.tabListRefs.map((t) => t.hash).includes(e.hash) && this.tabListRefs.push(e);
    }
  }
}, Ml = { ref: "tabListContainer" }, Ol = {
  key: 1,
  role: "tablist",
  class: "j-tabs__tabs"
}, Bl = ["aria-controls", "aria-selected", "tabindex", "href", "onClick"];
function Nl(e, t, n, l, s, i) {
  const r = f("j-select");
  return a(), o("div", Ml, [
    s.isMobile ? (a(), k(r, {
      key: 0,
      modelValue: i.mobileTabs.active,
      "onUpdate:modelValue": [
        t[0] || (t[0] = (d) => i.mobileTabs.active = d),
        i.onSelectOption
      ],
      options: i.mobileTabs.options
    }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])) : (a(), o("ul", Ol, [
      (a(!0), o(w, null, I(n.tabs, (d, c) => (a(), o("li", {
        key: c,
        class: v([{ "j-tabs__tab--active": d.active, "j-tabs__tab--disabled": d.disabled }, "j-tabs__tab"]),
        role: "presentation"
      }, [
        u("a", {
          ref_for: !0,
          ref: i.setItemRef,
          "aria-controls": d.hash,
          "aria-selected": d.active,
          tabindex: d.active ? null : -1,
          href: d.hash,
          role: "tab",
          onClick: (m) => i.onSelectTab(d)
        }, S(d.name), 9, Bl)
      ], 2))), 128))
    ]))
  ], 512);
}
const Ll = /* @__PURE__ */ y(Pl, [["render", Nl]]), Rl = {
  name: "jolt-tabs",
  components: {
    "j-tab-list": Ll
  },
  provide() {
    return {
      registerTab: (e) => this.tabs.push(e)
    };
  },
  props: {
    /**
     * Active Tab Id: If specified, it will try to find and toggle active the Tab with the provided id
     */
    activeTab: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      tabs: []
    };
  },
  watch: {
    activeTab(e) {
      this.setActiveTab(e);
    }
  },
  mounted() {
    this.setActiveTab(this.activeTab);
  },
  methods: {
    setActiveTab(e) {
      if (e) {
        const t = this.findTab(e);
        t && this.selectTab(t);
      }
    },
    findTab(e) {
      return this.tabs.find((t) => t.hash === e);
    },
    selectTab(e) {
      this.tabs.forEach((t) => {
        t.setActive(t.hash === e.hash);
      }), this.$emit("select", e);
    }
  }
}, zl = { class: "j-tabs" }, Fl = { class: "j-tabs__panels" };
function Hl(e, t, n, l, s, i) {
  const r = f("j-tab-list");
  return a(), o("div", zl, [
    g(r, {
      "parent-active-tab": n.activeTab,
      tabs: s.tabs,
      onSelect: i.selectTab
    }, null, 8, ["parent-active-tab", "tabs", "onSelect"]),
    u("div", Fl, [
      h(e.$slots, "default")
    ])
  ]);
}
const Uo = /* @__PURE__ */ y(Rl, [["render", Hl]]);
const Wl = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), Ul = {
  name: "j-term-highlighter",
  props: {
    /**
     * Search term.
     * Will be used to find highlights in the text.
     */
    term: {
      type: String,
      default: null
    },
    /**
     * Text to be rendered.
     */
    text: {
      type: String,
      required: !0
    },
    /**
     * Desired tag that should be a root of the component.
     */
    tag: {
      type: String,
      default: "span"
    },
    /**
     * Class that will be used for highlighted part.
     */
    highlightedElementClass: {
      type: String,
      default: "j-term-highlighter__highlight"
    },
    /**
     * Tag that will be used for highlighted part.
     */
    highlightedElementTag: {
      type: String,
      default: "em"
    }
  },
  computed: {
    /**
     * Splits text into chunks based on the given term.
     * Each chunk contains text to be rendered and indicator if the chunk matches the term.
     * @returns {Array}
     */
    chunks() {
      const e = Wl(this.term), t = new RegExp(e, "i"), n = new RegExp(`(${e})`, "gi");
      return this.text.split(n).filter((l) => !!l).map((l) => ({
        text: l,
        match: t.test(l)
      }));
    }
  },
  render() {
    return be(
      this.tag,
      {},
      this.term ? this.chunks.map((e) => e.match ? be(this.highlightedElementTag, { class: [this.highlightedElementClass] }, e.text) : e.text) : this.text
    );
  }
}, qo = /* @__PURE__ */ y(Ul, [["__scopeId", "data-v-ee1e7d3c"]]);
const ql = {
  name: "tertiary-nav",
  props: {
    /**
     * The array of items to display in the navigation. Each item should be an object which contains at least
     * a key and label property. The key is used by v-for and the label should be the text to display for the
     * item. An isActive property can be set to true for one of the items if one of the items is currently active
     * */
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      navItems: this.widthitems,
      activeItemIndex: 0,
      activeBarInPlace: !1,
      activeBarLeft: 0,
      activeBarWidth: 0,
      resizeObserver: null,
      outerWidth: 0,
      innerWidth: 0,
      navItemRefs: []
    };
  },
  computed: {
    isScrollable() {
      return this.innerWidth > this.outerWidth;
    }
  },
  watch: {
    activeItemIndex: "updateActiveBar",
    items(e) {
      this.activeItemIndex = e.findIndex((t) => t.isActive);
    }
  },
  created() {
    document.fonts.ready.then(() => {
      this.updateActiveBar();
    });
  },
  mounted() {
    this.activeItemIndex = this.items.findIndex((e) => e.isActive), this.activeItemIndex < 0 && (this.activeItemIndex = 0), this.updateActiveBar(), this.resizeObserver = new ResizeObserver((e) => {
      for (const t of e)
        this.outerWidth = Math.round(t.contentRect.width), this.innerWidth = this.$refs.scrollableEl.scrollWidth;
    }), this.resizeObserver.observe(this.$refs.wrapperEl);
  },
  beforeUnmount() {
    this.resizeObserver.disconnect();
  },
  methods: {
    updateActiveItem(e) {
      this.activeItemIndex = e;
    },
    updateActiveBar() {
      if (this.activeItemIndex >= 0) {
        let e = this.navItemRefs[this.activeItemIndex];
        e.$el && (e = e.$el), this.activeBarLeft = e.offsetLeft - (this.activeItemIndex === 0 ? 8 : 0), this.activeBarWidth = e.offsetWidth + (this.activeItemIndex === 0 ? 8 : 0), this.$nextTick(() => {
          this.activeBarInPlace = !0;
        });
      }
    },
    setItemRef(e) {
      e && this.navItemRefs.push(e);
    }
  }
}, Kl = {
  ref: "scrollableEl",
  class: "j-tertiary-nav__nav"
}, Gl = { class: "j-tertiary-nav__list" }, Yl = ["onClick"], Xl = ["href", "target", "onClick"];
function Zl(e, t, n, l, s, i) {
  return a(), o("div", {
    ref: "wrapperEl",
    class: v(["j-tertiary-nav", { "j-tertiary-nav--scrollable": i.isScrollable }])
  }, [
    u("nav", Kl, [
      u("ul", Gl, [
        (a(!0), o(w, null, I(n.items, (r, d) => (a(), o("li", {
          key: r.key,
          ref_for: !0,
          ref: i.setItemRef,
          class: "j-tertiary-nav__item"
        }, [
          e.$slots.tab ? (a(), o("span", {
            key: 0,
            onClick: (c) => i.updateActiveItem(d)
          }, [
            h(e.$slots, "tab", {
              data: {
                item: r,
                classes: {
                  "j-tertiary-nav__link": !0,
                  "j-tertiary-nav__link--active": d === s.activeItemIndex
                }
              }
            })
          ], 8, Yl)) : _("", !0),
          e.$slots.tab ? _("", !0) : (a(), o("a", {
            key: 1,
            href: r.href,
            target: r.target,
            class: v(["j-tertiary-nav__link", { "j-tertiary-nav__link--active": d === s.activeItemIndex }]),
            onClick: (c) => i.updateActiveItem(d)
          }, S(r.label), 11, Xl))
        ]))), 128))
      ]),
      u("div", {
        class: v(["j-tertiary-nav__active-bar", { "j-tertiary-nav__active-bar--animate": s.activeBarInPlace }]),
        style: $({
          transform: `translateX(calc(var(--j-spacing-m) - var(--j-spacing-xs) + ${s.activeBarLeft}px))`,
          width: `calc(${s.activeBarWidth}px + var(--j-spacing-m) - 2 * var(--j-spacing-m))`
        })
      }, null, 6)
    ], 512)
  ], 2);
}
const Ko = /* @__PURE__ */ y(ql, [["render", Zl]]);
const Jl = {
  name: "tile",
  components: {
    "j-icon": E,
    "j-tooltip": He,
    "j-tooltip-message": We
  },
  props: {
    /**
     * The title of the tile
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * The icon id to use in the top-left corner of the tile
     */
    icon: {
      type: String,
      default: null
    },
    /**
     * Classes to pass to the content div
     */
    contentClasses: {
      type: String,
      default: null
    },
    /**
     * The top padding to use for the main body of the tile
     */
    contentTopPadding: {
      type: String,
      default: "var(--j-spacing-l)"
    },
    /**
     * The bottom padding to use for the main body of the tile
     */
    contentBottomPadding: {
      type: String,
      default: "var(--j-spacing-l)"
    },
    /**
     * Is the content left aligned with title in case when there is an icon.
     */
    contentLeftAligned: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasHeader() {
      return this.title || this.$slots.header || this.$slots.tooltip;
    }
  }
}, Ql = (e) => (me("data-v-2ebb6d55"), e = e(), fe(), e), eo = {
  key: 1,
  viewBox: "0 0 52 52",
  class: "j-tile__corner"
}, to = /* @__PURE__ */ Ql(() => /* @__PURE__ */ u("path", { d: "M56,0 L56,56 L0,56 C0,45 6,40 13,40 L20,40 C31,40 40,31 40,20 L40,13 C40,6 45,0 56,0 Z" }, null, -1)), no = [
  to
], io = {
  key: 2,
  class: "j-tile__header"
}, so = {
  key: 0,
  class: "j-tile__title"
}, ao = {
  key: 1,
  class: "j-tile__header-content"
}, lo = {
  key: 3,
  class: "j-tile__footer"
};
function oo(e, t, n, l, s, i) {
  const r = f("j-icon"), d = f("j-tooltip-message"), c = f("j-tooltip");
  return a(), o("div", {
    class: v(["j-tile", { "j-tile--with-icon": n.icon }]),
    style: $({
      "--tile-content-top-padding": n.contentTopPadding,
      "--tile-content-bottom-padding": n.contentBottomPadding
    })
  }, [
    n.icon ? (a(), k(r, {
      key: 0,
      "icon-id": n.icon,
      class: "j-tile__icon"
    }, null, 8, ["icon-id"])) : _("", !0),
    n.icon ? (a(), o("svg", eo, no)) : _("", !0),
    i.hasHeader ? (a(), o("div", io, [
      n.title ? (a(), o("h4", so, S(n.title), 1)) : _("", !0),
      e.$slots.header || e.$slots.tooltip ? (a(), o("div", ao, [
        h(e.$slots, "header", {}, () => [
          e.$slots.tooltip ? (a(), k(c, {
            key: 0,
            class: "j-tile__tooltip"
          }, {
            tooltip: b(() => [
              g(d, { class: "j-tile__tooltip-message" }, {
                default: b(() => [
                  h(e.$slots, "tooltip", {}, void 0, !0)
                ]),
                _: 3
              })
            ]),
            default: b(() => [
              g(r, {
                "icon-id": "icon-info",
                class: "j-tile__tooltip-icon"
              })
            ]),
            _: 3
          })) : _("", !0)
        ], !0)
      ])) : _("", !0)
    ])) : _("", !0),
    u("div", {
      class: v(["j-tile__content", [n.contentClasses, n.contentLeftAligned && "j-tile__content--left-aligned"]])
    }, [
      h(e.$slots, "default", {}, void 0, !0)
    ], 2),
    e.$slots.footer ? (a(), o("div", lo, [
      h(e.$slots, "footer", {}, void 0, !0)
    ])) : _("", !0)
  ], 6);
}
const Go = /* @__PURE__ */ y(Jl, [["render", oo], ["__scopeId", "data-v-2ebb6d55"]]);
function ro(e) {
  return (t, n) => (t[n] = () => {
    e(), document.removeEventListener(n, t[n]);
  }, t);
}
const co = {
  name: "j-toggle",
  components: {
    "j-icon": E,
    "j-checkbox-generic": Ge
  },
  inheritAttrs: !1,
  // model: CheckboxGeneric.model,
  data() {
    const e = ["keyup", "mouseup", "touchend"], t = ro(() => this.isActive = !1);
    return {
      isActive: !1,
      listenersMap: e.reduce(t, {})
    };
  },
  methods: {
    /**
     * Sets active state to true.
     * Adds an event listener for corresponding 'action ended' event.
     * @param {string} stopEvent
     */
    onActionStart(e) {
      this.isActive = !0, document.addEventListener(e, this.listenersMap[e]);
    }
  }
}, uo = (e) => (me("data-v-f5c57bf4"), e = e(), fe(), e), ho = { class: "j-toggle__bullet__content" }, po = /* @__PURE__ */ uo(() => /* @__PURE__ */ u("span", { class: "j-toggle__button" }, null, -1)), _o = {
  key: 0,
  class: "j-toggle__label"
};
function mo(e, t, n, l, s, i) {
  const r = f("j-checkbox-generic"), d = f("j-icon"), c = z("focus");
  return D((a(), o("label", {
    class: "j-toggle",
    onMousedown: t[0] || (t[0] = (m) => i.onActionStart("mouseup")),
    onKeydown: t[1] || (t[1] = R((m) => i.onActionStart("keyup"), ["space"])),
    onTouchstart: t[2] || (t[2] = (m) => i.onActionStart("touchend"))
  }, [
    g(r, T(e.$attrs, { class: "j-toggle__input" }), null, 16),
    u("span", {
      class: v(["j-toggle__bullet", { "j-toggle__bullet--active": s.isActive }])
    }, [
      u("span", ho, [
        g(d, {
          "icon-id": "icon-delete",
          class: "j-toggle__icon j-toggle__icon--unchecked"
        }),
        g(d, {
          "icon-id": "icon-done",
          class: "j-toggle__icon j-toggle__icon--checked"
        }),
        po
      ])
    ], 2),
    e.$slots.default ? (a(), o("span", _o, [
      h(e.$slots, "default", {}, void 0, !0)
    ])) : _("", !0)
  ], 32)), [
    [
      c,
      s.isActive,
      void 0,
      { once: !0 }
    ]
  ]);
}
const Yo = /* @__PURE__ */ y(co, [["render", mo], ["__scopeId", "data-v-f5c57bf4"]]);
const fo = {
  name: "j-typeahead",
  components: {
    "j-typeahead-search": et,
    "j-typeahead-layout": Qe,
    "j-typeahead-panel": nt,
    "j-typeahead-base": it
  },
  inheritAttrs: !1,
  props: {
    /**
     * Copy used as the input's placeholder.
     */
    placeholder: {
      type: String,
      default: "Search here"
    },
    /**
     * Copy used as the clear button label.
     */
    buttonLabel: {
      type: String,
      default: "Clear"
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isActive: !1
    };
  },
  methods: {
    /**
     * Toggles active state.
     * @param {boolean} value
     */
    togglePanel(e) {
      this.isActive = e;
    },
    /**
     * Gets new selection and propagates event up.
     * If selection is truthy, hides Typeahead panel.
     * @param {Object} selection
     */
    onUpdateSelection(e) {
      e && (this.focusInput(), this.togglePanel(!1)), this.$emit("update:modelValue", e);
    },
    /**
     * Gets term and propagates event up.
     * In case if term update is result of input interaction,
     * it open Typeahead.
     * @param {string} term
     * @param {string} source
     */
    onUpdateTerm(e, { source: t } = {}) {
      t === "input" && this.togglePanel(!0), this.$emit("update:term", e);
    },
    /**
     * Puts focus on the input.
     */
    focusInput() {
      this.$refs.input.focus();
    },
    /**
     * When Typeahead becomes inactive and there is a selection,
     * the term should be set to the label of the selected item.
     * @param {string} term
     * @param {string} selectedLabel
     * @returns {string}
     */
    normalizeTerm({ term: e, selectedLabel: t }) {
      return t || e;
    }
  }
};
function yo(e, t, n, l, s, i) {
  const r = f("j-typeahead-search"), d = f("j-typeahead-panel"), c = f("j-typeahead-layout"), m = f("j-typeahead-base");
  return a(), k(m, T({ class: "j-typeahead" }, e.$attrs, {
    "is-active": s.isActive,
    "normalize-term": i.normalizeTerm,
    "model-value": n.modelValue,
    "onUpdate:modelValue": i.onUpdateSelection,
    "onUpdate:term": i.onUpdateTerm
  }), {
    default: b(({ state: p, api: j }) => [
      g(c, {
        "is-valid": p.isValid,
        "show-panel": s.isActive,
        "panel-css-class": "j-typeahead__layout",
        "onUpdate:showPanel": i.togglePanel,
        "onTypeahead:blur": t[1] || (t[1] = (C) => e.$emit("blur")),
        "onTypeahead:up": j.moveUp,
        "onTypeahead:down": j.moveDown
      }, {
        "typeahead:target": b(() => [
          g(r, T({
            ref: "input",
            value: p.term,
            placeholder: n.placeholder,
            "button-label": n.buttonLabel
          }, e.$attrs, {
            onFocus: t[0] || (t[0] = (C) => i.togglePanel(!0)),
            "onChange:value": j.updateTerm,
            "onSubmit:value": j.onEnter,
            onClear: j.clear
          }), null, 16, ["value", "placeholder", "button-label", "onChange:value", "onSubmit:value", "onClear"])
        ]),
        "typeahead:panel": b(() => [
          g(d, T({ class: "j-typeahead__panel" }, p, {
            "onSelect:option": j.onSelect
          }), {
            "typeahead:option": b((C) => [
              h(e.$slots, "typeahead:option", M(B(C)), void 0, !0)
            ]),
            "typeahead:no-results": b((C) => [
              h(e.$slots, "typeahead:no-results", M(B(C)), void 0, !0)
            ]),
            "typeahead:results-info": b((C) => [
              h(e.$slots, "typeahead:results-info", M(B(C)), void 0, !0)
            ]),
            _: 2
          }, 1040, ["onSelect:option"])
        ]),
        _: 2
      }, 1032, ["is-valid", "show-panel", "onUpdate:showPanel", "onTypeahead:up", "onTypeahead:down"])
    ]),
    _: 3
  }, 16, ["is-active", "normalize-term", "model-value", "onUpdate:modelValue", "onUpdate:term"]);
}
const Xo = /* @__PURE__ */ y(fo, [["render", yo], ["__scopeId", "data-v-6557155d"]]), x = {
  COMPLETED: "completed",
  ACTIVE: "active",
  INACTIVE: "inactive",
  EDITING: "editing"
};
function Oe(e, t = 300) {
  e && setTimeout(() => {
    e.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, t);
}
const go = {
  name: "j-wizard",
  provide() {
    return {
      __stepProps: () => this.stepsMeta,
      __disableHeaderButton: () => !!this.editingStep,
      __totalCount: () => this.totalCount,
      onNext: this.onNext,
      onPrev: this.onPrev,
      onEdit: this.onEdit,
      onEditDone: this.onEditDone,
      registerStep: this.registerStep,
      registerStepRef: this.registerStepRef,
      unregisterStep: this.unregisterStep,
      transitionDone: this.onTransitionDone
    };
  },
  props: {
    /**
     * Indicates if the wizard should scroll to the active step when it changes.
     */
    scrollToActive: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      activeStep: null,
      editingStep: null,
      stepsMeta: {},
      stepsKeys: []
    };
  },
  computed: {
    totalCount() {
      return this.stepsKeys.length;
    }
  },
  mounted() {
    this.stepsInTransition = [];
  },
  methods: {
    /**
     * Sets wizard to activate next step.
     * @param {Object} options
     * @param {string} options.step name of a current step
     * @param {boolean} options.silent property says if it should fire an events
     */
    onNext({ step: e, silent: t } = {}) {
      const n = this.stepsKeys.indexOf(e);
      this.handleStepMove(e, {
        stepIndex: n,
        nextStepIndex: n + 1,
        beforeTransition: () => (this.stepsMeta[e].status = x.COMPLETED, n + 1 === this.stepsKeys.length ? (this.activeStep = null, t || this.$emit("completed"), !1) : !0)
      });
    },
    /**
     * Sets wizard to activate previous step.
     * @param {Object} options
     * @param {string} options.step name of the current step
     */
    onPrev({ step: e }) {
      const t = this.stepsKeys.indexOf(e);
      this.handleStepMove(e, {
        stepIndex: t,
        nextStepIndex: t - 1,
        beforeTransition: () => t > 0 ? (this.stepsMeta[e].status = x.INACTIVE, !0) : !1
      });
    },
    /**
     * Handles wizard move from one step to another
     * @param {string} step name of the current step
     * @param {Object} options
     * @param {number} options.stepIndex current step index
     * @param {number} options.nextStepIndex step to be moved to index
     * @param {Object} options.beforeTransition function to be called befour move
     */
    handleStepMove(e, { stepIndex: t, nextStepIndex: n, beforeTransition: l }) {
      if (!(t === -1 || e !== this.activeStep) && (this.stepsInTransition = [e], l() && n >= 0 && n <= this.stepsKeys.length - 1)) {
        const s = this.stepsKeys[n];
        this.setStepStatus(s, x.ACTIVE), this.activeStep = s, this.$emit("step-active", { step: this.activeStep });
      }
    },
    /**
     * Sets wizard step to editable status
     * @param {Object} options
     * @param {string} options.step name of the step to be edited
     */
    onEdit({ step: e }) {
      !this.stepsMeta[e] || this.editingStep || (this.setStepStatus(e, x.EDITING), this.$emit("step-edit", { step: this.editingStep }));
    },
    /**
     * Sets wizard step to finish step editing
     * @param {Object} options
     * @param {boolean} options.silent property says if events should be fired
     */
    onEditDone({ silent: e } = {}) {
      if (this.editingStep) {
        if (e || this.$emit("step-edit-done", { step: this.editingStep }), this.setStepStatus(this.editingStep, x.COMPLETED), this.activeStep) {
          this.setStepStatus(this.activeStep, x.ACTIVE);
          return;
        }
        !e && !this.editingStep && this.$emit("completed");
      }
    },
    /**
     * Sets wizard step a status
     * @param {string} stepName name of the step
     * @param {string} status status to be set to the step
     */
    setStepStatus(e, t) {
      this.stepsMeta[e] && (this.stepsMeta[e].status = t, [x.ACTIVE, x.INACTIVE].includes(t) ? this.stepsInTransition.push(e) : this.stepsInTransition = [e], x.EDITING === t ? (this.activeStep && (this.stepsMeta[this.activeStep].status = x.INACTIVE, this.stepsInTransition.push(this.activeStep)), this.editingStep && (this.stepsMeta[this.editingStep].status = x.COMPLETED, this.stepsInTransition.push(this.editingStep)), this.editingStep = e) : t === x.COMPLETED && (this.editingStep = null));
    },
    /**
     * Change the wizard step to an editing status.
     * @param {string} stepName name of the step
     */
    reactivateStep(e) {
      this.stepsMeta[e].status === x.COMPLETED && this.onEdit({ step: e });
    },
    registerStep(e, t, n = !1) {
      if (this.stepsMeta[e]) {
        console.warn(`Duplicated Step '${e}'`);
        return;
      }
      t !== void 0 ? this.stepsKeys.splice(t, 0, e) : this.stepsKeys.push(e), this.stepsKeys.length === 1 && !n && (this.activeStep = this.stepsKeys[0]), this.registerStepMeta(e, t, n), t !== void 0 && this.reindex(), !n && this.areAllStepsCompleted(e) && (this.stepsMeta[e].status = x.ACTIVE, this.activeStep = e);
    },
    registerStepRef(e, t) {
      this.stepsMeta[e] && (this.stepsMeta[e].ref = t);
    },
    unregisterStep(e) {
      if (!this.stepsKeys.includes(e))
        return;
      const t = this.stepsKeys.indexOf(e), n = this.stepsMeta[e].status;
      if (delete this.stepsMeta[e], this.stepsKeys.splice(t, 1), e === this.activeStep && (this.activeStep = null), n === x.ACTIVE && t < this.stepsKeys.length) {
        const l = this.stepsKeys[t];
        this.stepsMeta[l].status = x.ACTIVE, this.activeStep = l;
      }
      this.reindex(), this.areAllStepsCompleted() && this.$emit("completed");
    },
    registerStepMeta(e, t, n) {
      let l = this.stepsKeys.length === 1 ? x.ACTIVE : x.INACTIVE;
      n && (l = x.COMPLETED), this.stepsMeta[e] = {
        name: e,
        status: l,
        index: this.stepsKeys.length
      };
    },
    reindex() {
      for (let e = 0; e < this.stepsKeys.length; e += 1)
        this.stepsMeta[this.stepsKeys[e]].index = e + 1;
    },
    onTransitionDone(e) {
      var t, n;
      this.stepsInTransition = (t = this.stepsInTransition) == null ? void 0 : t.filter((l) => l !== e), ((n = this.stepsInTransition) == null ? void 0 : n.length) === 0 && this.scrollToActive && (this.activeStep && !this.editingStep ? Oe(this.stepsMeta[this.activeStep].ref, 100) : !this.activeStep && this.editingStep && Oe(this.stepsMeta[this.editingStep].ref, 100));
    },
    areAllStepsCompleted(e) {
      for (const t of this.stepsKeys)
        if (t !== e && x.COMPLETED !== this.stepsMeta[t].status)
          return !1;
      return !0;
    }
  }
}, vo = { class: "j-wizard" };
function bo(e, t, n, l, s, i) {
  return a(), o("div", vo, [
    h(e.$slots, "default", {}, void 0, !0)
  ]);
}
const Zo = /* @__PURE__ */ y(go, [["render", bo], ["__scopeId", "data-v-1396c88a"]]);
const pe = 150, Be = 150, Ne = "j-step--fade-in", Le = "j-step--fade-out", Re = ["__stepProps", "__disableHeaderButton", "__totalCount"], jo = {
  name: "j-wizard-step",
  components: {
    "j-icon": E,
    "j-button": F
  },
  stateChangeTransition: !1,
  inject: [
    "onNext",
    "onPrev",
    "onEdit",
    "onEditDone",
    "registerStep",
    "registerStepRef",
    "unregisterStep",
    "transitionDone",
    ...Re
  ],
  props: {
    /**
     * Identifies a step and must be unique.
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * It's the title of the step, it's shown in the header aside the position indicator.
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Is the text shown on top of the title to indicates the progress and remaining steps.<br>
     * Ex. Step # of #
     */
    progressText: {
      type: String,
      default: ""
    },
    /**
     * Allows to customise the text of the default action button shown in the header (Edit button).
     */
    headerButtonText: {
      type: String,
      default: "Edit"
    },
    /**
     * Allows to show/hide the action button shown at the right of the header.
     */
    showHeaderButton: {
      type: Boolean,
      default: !0
    },
    /**
     * If you want to insert a step dynamically using the <code>v-if</code> directive you should indicate the index (zero based)
     * where the new step will be inserted, that way the <code>j-wizard</code> will know how to update his model accordingly.
     */
    index: {
      type: Number,
      default: void 0
    },
    /**
     * Indicates if the index/done icon shown in front of the title should be visible.
     */
    showIndexIcon: {
      type: Boolean,
      default: !0
    },
    /**
     * Indicates if the step is in a completed status initially. Useful when the step will be used to show data
     * already existent in a readonly view.
     */
    completed: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      componentHeight: "auto",
      contentFadeClass: "",
      isResizing: !1,
      statusPropagation: x.INACTIVE
    };
  },
  computed: {
    status() {
      const e = this.stepProps[this.name];
      return e ? e.status : x.INACTIVE;
    },
    indexComputed() {
      const e = this.stepProps[this.name];
      return e ? e.index : "?";
    },
    showHeaderActionButton() {
      return this.showHeaderButton && ![x.INACTIVE, x.ACTIVE].includes(this.status);
    },
    showStepTotalCount() {
      return [x.EDITING, x.ACTIVE].includes(this.status);
    },
    isStepCompleted() {
      return this.status === x.COMPLETED;
    },
    contentCollapsedClass() {
      return this.status === x.INACTIVE ? "j-step--collapsed j-step--hidden" : "";
    },
    ...Re.reduce((e, t) => (e[t.replace("__", "")] = function() {
      return this[t]();
    }, e), {}),
    className() {
      const e = ["j-step", `j-step--${this.status}`];
      return this.isResizing && e.push("j-step--resizing"), e.join(" ");
    }
  },
  watch: {
    async status(e) {
      if (this.$options.stateChangeTransition = !0, this.dimensions[e]) {
        this.contentFadeClass = Le, this.updateDimensions(e), setTimeout(() => {
          this.contentFadeClass = Ne, this.statusPropagation = e, this.transitionDone(this.name), this.$options.stateChangeTransition = !1;
        }, pe);
        return;
      }
      this.contentFadeClass = Le, setTimeout(() => {
        this.statusPropagation = e, this.contentFadeClass = Ne, setTimeout(() => {
          this.registerDimensions(e), this.updateDimensions(e), this.isResizing = !0, setTimeout(() => {
            this.transitionDone(this.name), this.$options.stateChangeTransition = !1, this.isResizing = !1;
          }, Be);
        });
      }, pe);
    }
  },
  created() {
    this.dimensions = {}, this.registerStep(this.name, this.index, this.completed);
  },
  mounted() {
    this.registerStepRef(this.name, this.$refs.componentContainer), this.contentResizeObserver = new ResizeObserver(
      Dt(
        async () => {
          this.$options.stateChangeTransition || (this.registerDimensions(this.status), this.updateDimensions(this.status));
        },
        pe + Be + 100,
        !1
      )
    ), this.contentResizeObserver.observe(this.$refs.contentWrapper);
  },
  beforeUnmount() {
    this.contentResizeObserver.unobserve(this.$refs.contentWrapper);
  },
  unmounted() {
    this.unregisterStep(this.name);
  },
  methods: {
    goNext(e = { silent: !1 }) {
      if (this.status === x.EDITING) {
        this.onEditDone(e);
        return;
      }
      this.onNext({ ...e, step: this.name });
    },
    goPrev() {
      this.onPrev({ step: this.name });
    },
    goEdit() {
      this.onEdit({ step: this.name });
    },
    editDone(e = { silent: !1 }) {
      this.onEditDone(e);
    },
    updateDimensions(e) {
      if (!this.dimensions[e])
        return;
      const { headerHeight: t, contentHeight: n } = this.dimensions[e];
      this.componentHeight = `${t + n}px`;
    },
    registerDimensions(e) {
      const { header: t, contentWrapper: n } = this.$refs;
      this.dimensions[e] = {
        headerHeight: t ? t.offsetHeight : 0,
        contentHeight: n ? n.offsetHeight : 0
      };
    }
  }
}, So = {
  ref: "header",
  class: "j-step--header"
}, ko = {
  key: 0,
  class: "j-step--position-in-total"
}, Co = { class: "j-step--title-bar" }, wo = { class: "j-step--title-container" };
function xo(e, t, n, l, s, i) {
  const r = f("j-icon"), d = f("j-button");
  return a(), o("section", {
    ref: "componentContainer",
    class: v(i.className),
    style: $({ height: s.componentHeight })
  }, [
    u("header", So, [
      i.showStepTotalCount ? (a(), o("span", ko, [
        e.$slots.progress ? h(e.$slots, "progress", {
          key: 0,
          index: i.indexComputed,
          total: e.totalCount
        }, void 0, !0) : (a(), o(w, { key: 1 }, [
          P(S(n.progressText ? n.progressText : `Step ${i.indexComputed} of ${e.totalCount}`), 1)
        ], 64))
      ])) : _("", !0),
      u("div", Co, [
        u("div", wo, [
          n.showIndexIcon ? (a(), o("span", {
            key: 0,
            class: v(["j-step--index", `j-step--index-${i.status}`])
          }, [
            i.isStepCompleted ? _("", !0) : (a(), o(w, { key: 0 }, [
              P(S(i.indexComputed), 1)
            ], 64)),
            i.isStepCompleted ? (a(), k(r, {
              key: 1,
              "icon-id": "icon-done",
              class: "j-step--done-icon"
            })) : _("", !0)
          ], 2)) : _("", !0),
          u("h2", {
            class: v(["j-step--title", `j-step--title-${i.status}`])
          }, S(n.title), 3)
        ]),
        i.showHeaderActionButton ? (a(), k(d, {
          key: 0,
          "icon-id": "icon-edit",
          variant: "tertiary",
          class: "j-step--edit-button",
          disabled: e.disableHeaderButton,
          "aria-disabled": e.disableHeaderButton,
          onClick: i.goEdit
        }, {
          default: b(() => [
            P(S(n.headerButtonText), 1)
          ]),
          _: 1
        }, 8, ["disabled", "aria-disabled", "onClick"])) : _("", !0)
      ])
    ], 512),
    u("div", {
      ref: "contentWrapper",
      class: v([[i.contentCollapsedClass, s.contentFadeClass], "j-step--content-wrapper"])
    }, [
      h(e.$slots, "default", {
        onNext: i.goNext,
        onPrev: i.goPrev,
        onEditDone: i.editDone,
        status: s.statusPropagation
      }, void 0, !0)
    ], 2)
  ], 6);
}
const Jo = /* @__PURE__ */ y(jo, [["render", xo], ["__scopeId", "data-v-6e2c4159"]]);
export {
  jt as ActionPanel,
  zt as ActionsGroup,
  un as AuxiliaryNav,
  Vo as Badge,
  F as Button,
  Ao as Card,
  $o as Carousel,
  Eo as CarouselSlide,
  Nn as ChartInfoHighlight,
  Kn as Checkbox,
  Ge as CheckboxGeneric,
  Ce as ChoiceGroup,
  Li as Datepicker,
  Po as DonutChart,
  ze as DropdownButton,
  Mo as EmptyState,
  as as ErrorMessage,
  Oo as FeedbackBanner,
  Bo as FormBuilder,
  ya as FormField,
  E as Icon,
  ne as Input,
  Je as InputGeneric,
  Ee as InputGroup,
  Ds as InputWithLiveValidation,
  ms as Label,
  No as Legend,
  Da as LegendItem,
  Lo as Link,
  Ra as Logo,
  Ro as Modal,
  zo as Navigation,
  tt as OptionPanel,
  ye as Panel,
  Qa as PrimaryNav,
  qe as PrimaryNavExpandableSections,
  Ue as PrimaryNavSection,
  Ut as PrimaryNavSectionItem,
  Qn as Radio,
  st as Select,
  ra as SelectInput,
  ta as SelectWithTypeahead,
  Fo as SidePanel,
  hl as SidePanelHeader,
  yl as Slider,
  Ho as Tab,
  Ll as TabList,
  Wo as Table,
  Uo as Tabs,
  qo as TermHighlighter,
  Ko as TertiaryNav,
  $e as Textarea,
  Go as Tile,
  Yo as Toggle,
  He as Tooltip,
  We as TooltipMessage,
  Xo as Typeahead,
  Zo as Wizard,
  Jo as WizardStep
};
